const ONE_LINK_PREFIX = "https://encar.onelink.me/DhHD?pid=Encar_MW&c=MW_%EC%95%B1%EC%A0%84%ED%99%98%20%EC%9C%A0%EB%8F%84%20%EB%B0%B0%EB%84%88&is_retargeting=true&af_click_lookback=10d", RYVUSS_SEARCH_PARAM = {
  action: {
    국산수입: "(And.Hidden.N._.CarType.A.)",
    전기친환경: "(And.Hidden.N._.CarType.A._.GreenType.Y.)",
    화물특장: "Hidden.N.",
    // Trust 필터를 Service 필터를 사용하도록 수정
    // 믿고: '(And.Hidden.N._.CarType.A._.Trust.Meetgo.)',
    // 엔카홈서비스: '(And.Hidden.N._.CarType.A._.Trust.HomeService.)',
    // 엔카부름: '(And.Hidden.N._.CarType.A._.Trust.PreDelivery.)',
    // 엔카진단: '(And.Hidden.N._.CarType.A._.Trust.Warranty.)',
    // 엔카보증: '(And.Hidden.N._.CarType.A._.Trust.ExtendWarranty.)',
    // 엔카보증_수입차: '(And.Hidden.N._.CarType.A._.Trust.ExtendWarrantyImported.)',
    // 헛걸음보상: '(And.Hidden.N._.CarType.A._.Trust.Compensate.)',
    국산수입_엔카믿고: "(And.Hidden.N._.CarType.A._.Service.EncarMeetgo.)",
    국산수입_엔카믿고_믿고배송: "(And.Hidden.N._.CarType.A._.Service.EncarMeetgo._.BuyType.Delivery.)",
    국산수입_엔카믿고_믿고방문: "(And.Hidden.N._.CarType.A._.Service.EncarMeetgo._.BuyType.Visit.)",
    국산수입_엔카진단: "(And.Hidden.N._.CarType.A._.(Or.ServiceMark.EncarDiagnosisP0._.ServiceMark.EncarDiagnosisP1._.ServiceMark.EncarDiagnosisP2.))",
    국산수입_엔카진단_P0: "(And.Hidden.N._.CarType.A._.(Or.ServiceMark.EncarDiagnosisP0.))",
    국산수입_엔카진단_P1: "(And.Hidden.N._.CarType.A._.(Or.ServiceMark.EncarDiagnosisP1.))",
    국산수입_엔카진단_P2: "(And.Hidden.N._.CarType.A._.(Or.ServiceMark.EncarDiagnosisP2.))",
    국산수입_엔카진단_P1_P2: "(And.Hidden.N._.CarType.A._.(Or.ServiceMark.EncarDiagnosisP1._.ServiceMark.EncarDiagnosisP2.))",
    국산수입_엔카보증: "(And.Hidden.N._.CarType.A._.Service.ExtendWarranty.)",
    국산수입_엔카보증_수입차: "(And.Hidden.N._.CarType.A._.Service.ExtendWarrantyImported.)",
    국산수입_헛걸음보상: "(And.Hidden.N._.CarType.A._.Service.Compensate.)",
    국산수입_차량이력공개: "(And.Hidden.N._.CarType.A._.Condition.Resume.)"
    // 전기친환경_엔카믿고: ..., // 다른 카타입 추가시
  },
  sort: {
    최근_업데이트순: "MobileModifiedDate",
    낮은_가격순: "MobilePriceAsc",
    높은_가격순: "MobilePriceDesc",
    낮은_주행거리순: "MobileMileageAsc",
    높은_주행거리순: "MobileMileageDesc",
    최근_연식순: "MobileYear"
  }
}, LIST_PAGE_DEFAULT_SEARCH_PARAM = {
  국산수입: `{"type":"car","action":"${RYVUSS_SEARCH_PARAM.action.국산수입}","toggle":{},"layer":"","sort":"${RYVUSS_SEARCH_PARAM.sort.최근_업데이트순}"}`,
  화물특장: `{"type":"truck","action":"${RYVUSS_SEARCH_PARAM.action.화물특장}","toggle":{},"layer":"","sort":"${RYVUSS_SEARCH_PARAM.sort.최근_업데이트순}"}`
};
var UserPassStatus;
(function(UserPassStatus2) {
  UserPassStatus2.VERIFIED = "VERIFIED", UserPassStatus2.BLOCKED = "BLOCKED", UserPassStatus2.NEED_VERIFICATION = "NEED_VERIFICATION";
})(UserPassStatus || (UserPassStatus = {}));
const HOT_MARK = {
  1: "개인",
  2: "급매",
  3: "절충",
  4: "LPG",
  5: "오디오",
  6: "임판",
  7: "장애인",
  8: "튜닝",
  9: "특옵션",
  10: "1인소유",
  11: "할부",
  12: "정비OK",
  13: "양호",
  14: "HOT",
  15: "COOL",
  17: "최저가",
  18: "카드",
  19: "짧은Km",
  20: "4WD",
  21: "리스승계",
  22: "계산서",
  23: "여성",
  24: "비흡연",
  // 25: '동영상',
  26: "제조사AS",
  27: "정식수입",
  28: "24시간상담",
  29: "준신차"
}, CITY_CODE_NUMBER = {
  "전국 배송": "all",
  // 검색필터용
  서울: "001",
  경기: "002",
  인천: "003",
  대전: "004",
  세종: "005",
  충남: "006",
  충북: "007",
  강원: "008",
  부산: "009",
  대구: "010",
  울산: "011",
  경남: "012",
  경북: "013",
  광주: "014",
  전남: "015",
  전북: "016",
  제주: "017",
  전남광주: "018"
}, CAR_DETAIL_IMAGE_OUTER_CODE = ["001", "002", "003", "004", "005", "031", "032", "033", "006"], CAR_DETAIL_IMAGE_INNER_CODE = ["007", "008", "009", "034", "035", "010", "036"], CAR_DETAIL_IMAGE_THUMBNAIL_CODE = ["011", "012", "013", "014", "025", "026"], CAR_DETAIL_IMAGE_OPTION_CODE = [
  "015",
  "016",
  "017",
  "018",
  "019",
  "020",
  "021",
  "022",
  "023",
  "024",
  "040",
  "041",
  "042",
  "043",
  "044",
  "045",
  "046",
  "047",
  "048",
  "049",
  "050",
  "051",
  "052",
  "053",
  "054",
  "055",
  "056",
  "057",
  "058",
  "059",
  "060",
  "061",
  "062",
  "063"
], CAR_DETAIL_IMAGE_GROUP = [
  { groupName: "OUTER", label: "외부", codes: CAR_DETAIL_IMAGE_OUTER_CODE },
  { groupName: "INNER", label: "내부", codes: CAR_DETAIL_IMAGE_INNER_CODE },
  { groupName: "THUMBNAIL", label: "썸네일", codes: CAR_DETAIL_IMAGE_THUMBNAIL_CODE },
  { groupName: "OPTION", label: "옵션", codes: CAR_DETAIL_IMAGE_OPTION_CODE }
], CAR_DETAIL_IMAGE_EXCLUDED_GROUP = ["THUMBNAIL"], CAR_DETAIL_PANORAMA_THUMBNAIL_CODE = "panoramaThumbnail", CAR_DETAIL_IMAGE_LABEL = {
  "001": "앞측면",
  "002": "뒷측면",
  "003": "전면",
  "004": "후면",
  "005": "휠/타이어",
  "031": "휠/타이어",
  "032": "헤드램프",
  "033": "리어램프",
  "006": "엔진",
  "007": "실내",
  "008": "계기판",
  "009": "변속기",
  "034": "도어트림",
  "035": "도어트림",
  "010": "차량시트",
  "036": "차량시트",
  "015": "옵션",
  "016": "옵션",
  "017": "옵션",
  "018": "옵션",
  "019": "옵션",
  "020": "옵션",
  "021": "옵션",
  "022": "옵션",
  "023": "옵션",
  "024": "옵션",
  "040": "옵션",
  "041": "옵션",
  "042": "옵션",
  "043": "옵션",
  "044": "옵션",
  "045": "옵션",
  "046": "옵션",
  "047": "옵션",
  "048": "옵션",
  "049": "옵션",
  "050": "옵션",
  "051": "옵션",
  "052": "옵션",
  "053": "옵션",
  "054": "옵션",
  "055": "옵션",
  "056": "옵션",
  "057": "옵션",
  "058": "옵션",
  "059": "옵션",
  "060": "옵션",
  "061": "옵션",
  "062": "옵션",
  "063": "옵션",
  [CAR_DETAIL_PANORAMA_THUMBNAIL_CODE]: "360°"
}, UNDER_BODY_STRING = "UNDER_BODY", UNDER_BODY_PHOTO_LABEL = {
  UNDER_BODY: "전체",
  UNDER_BODY_FRONT_LEFT: "운전석앞",
  UNDER_BODY_FRONT_RIGHT: "조수석앞",
  UNDER_BODY_REAR_RIGHT: "조수석뒤",
  UNDER_BODY_REAR_LEFT: "운전석뒤"
}, TEST_DRIVE_DA_KEY = "leadform@x90", isServer = typeof window > "u", isBrowser = typeof window < "u", currentHost = () => isBrowser ? `${window.location.protocol}//${window.location.host}` : "", DEPLOY_ENV = process.env.REACT_APP_DEPLOY_ENV || process.env.NEXT_PUBLIC_ENV, ENCAR_PC = process.env.REACT_APP_ENCAR_PC || process.env.NEXT_PUBLIC_ENCAR_PC, ENCAR_MOBILE = process.env.REACT_APP_ENCAR_MOBILE || process.env.NEXT_PUBLIC_ENCAR_MOBILE, ENCAR_FEM = process.env.NEXT_PUBLIC_ENCAR_FEM || currentHost(), ENCAR_FEM_SELL = process.env.REACT_APP_ENCAR_FEM_SELL || process.env.NEXT_PUBLIC_ENCAR_FEM_SELL || currentHost(), ENCAR_FEM_CAR = process.env.REACT_APP_ENCAR_FEM_CAR || process.env.NEXT_PUBLIC_ENCAR_FEM_CAR || currentHost(), ENCAR_FEM_BUY = process.env.REACT_APP_ENCAR_FEM_BUY || process.env.NEXT_PUBLIC_ENCAR_FEM_BUY || currentHost(), ENCAR_FEM_CHECK = process.env.REACT_APP_ENCAR_FEM_CHECK || process.env.NEXT_PUBLIC_ENCAR_FEM_CHECK || currentHost(), ENCAR_GLOBAL = process.env.REACT_APP_ENCAR_GLOBAL || process.env.NEXT_PUBLIC_ENCAR_GLOBAL || currentHost(), API_PRIVATE_URL = process.env.REACT_APP_API_PRIVATE_URL || process.env.NEXT_PUBLIC_API_PRIVATE_URL, API_URL = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL, API_AUTH_URL = process.env.REACT_APP_API_AUTH || process.env.NEXT_PUBLIC_AUTH, API_LOAN_URL = process.env.REACT_APP_API_LOAN || process.env.NEXT_PUBLIC_API_LOAN, API_MEYLE_URL = process.env.REACT_APP_API_MEYLE, API_NAS_URL = process.env.REACT_APP_API_NAS || process.env.NEXT_PUBLIC_API_NAS, API_DA_URL = process.env.REACT_APP_API_DA || process.env.NEXT_PUBLIC_API_DA, API_JUSO_URL = process.env.REACT_APP_API_JUSO || process.env.NEXT_PUBLIC_API_JUSO, API_CHAT_URL = process.env.REACT_APP_API_CHAT || process.env.NEXT_PUBLIC_API_CHAT, TOKEN_MOBILE = process.env.REACT_APP_TOKEN_MOBILE || process.env.NEXT_PUBLIC_API_TOKEN, TOKEN_PARTNERSHIP = process.env.REACT_APP_TOKEN_PARTNERSHIP || process.env.NEXT_PUBLIC_TOKEN_PARTNERSHIP, TOKEN_MEETGO = process.env.REACT_APP_TOKEN_MEETGO || process.env.NEXT_PUBLIC_TOKEN_MEETGO, TOKEN_VEHICLE = process.env.REACT_APP_TOKEN_VEHICLE || process.env.NEXT_PUBLIC_TOKEN_VEHICLE, TOKEN_BRAND = process.env.REACT_APP_TOKEN_BRAND, TOKEN_VEHICLE_PUBLIC = process.env.REACT_APP_TOKEN_VEHICLE_PUBLIC || process.env.NEXT_PUBLIC_TOKEN_VEHICLE_PUBLIC, TOKEN_INSPECT = process.env.REACT_APP_TOKEN_INSPECT || process.env.NEXT_PUBLIC_TOKEN_INSPECT, ENCAR_URL_NOAH = process.env.REACT_APP_URL_NOAH, NAVER_CLIENT_KEY = process.env.REACT_APP_KEY_NAVER_AUTH, KAKAO_CLIENT_KEY = process.env.REACT_APP_KEY_KAKAO_AUTH, GOOGLE_CLIENT_KEY = process.env.REACT_APP_KEY_GOOGLE_AUTH, ENCAR_IMG_SERVER = process.env.REACT_APP_IMG_SERVER || process.env.NEXT_PUBLIC_IMG_SERVER, ENCAR_IMAGE_DOMAIN = process.env.REACT_APP_IMG_DOMAIN || process.env.NEXT_PUBLIC_IMAGE_DOMAIN, ENCAR_KEY_KAKAO_APP_JS = process.env.REACT_APP_KEY_KAKAO_APP_JS || process.env.NEXT_PUBLIC_KEY_KAKAO_APP_JS, ENCAR_STATIC_SERVER = process.env.REACT_APP_STATIC_SERVER || process.env.NEXT_PUBLIC_STATIC_SERVER, PRO_TRANSFER_INSTATNT_AB_TEST_KEY = {
  PROMOTION_UI: DEPLOY_ENV === "prod" ? "6ad09408e4c16826f5d5da0b" : "6abccd494baa2a3e5cb1f085"
}, ENCAR_SURVEY_TYPE = {
  INSTANT: "INSTANT",
  LONG_TERM: "LONG_TERM",
  CSAT: "CSAT",
  CES: "CES"
}, ENCAR_SURVEY_DEVICE = {
  ALL: "ALL",
  PC: "PC",
  MOBILE: "MOBILE"
}, ENCAR_SURVEY = {
  /** AB: `ENCAR_SURVEY_AB_TEST.ENQUIRY_RECEIVED` (A) */
  ENQUIRY_RECEIVED: {
    eventId: "1",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "딜러 050 통화 이력이 있는 고객(회원·비회원 모두) 중 최근 3개월 안에 받은 적 없는 사람에게 통화 직후, 전화번호 기준 10분마다 묶어서 발송"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.MEETGO_DELIVERY_BUY` (A) */
  MEETGO_DELIVERY_BUY: {
    eventId: "5",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "엔카믿고(배송)로 구매를 완료한 고객. 재구매하면 다시 발송 > 구매확정 시점 기준, 1시간마다 묶어서 발송"
  },
  ENQUIRY_RECEIVED_LONGTERM: {
    eventId: "28",
    type: ENCAR_SURVEY_TYPE.LONG_TERM,
    trigger: "차량 검색 후 이탈 or 차량 검색 후 차량 리스트에서 5~9대 조회"
  },
  ESTIMATE_SELF: {
    eventId: "29",
    instanceKey: "estimate-csat-29",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "sell", label: "내차팔기 셀프 신청완료", path: "/apply/complete" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "페이지 진입 후 로그인 확인 및 소유주인증 상태 조회가 끝나면 자동 노출"
  },
  ESTIMATE_PRO: {
    eventId: "30",
    instanceKey: "estimate-csat-30",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "내차팔기 믿고 신청완료", path: "/estimate/pro/apply-success" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "페이지 진입 후 견적 ID(estimateId)가 확인되면 자동 노출"
  },
  ESTIMATE_PLUS: {
    eventId: "31",
    instanceKey: "estimate-csat-31",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "sell", label: "내차팔기 믿고+ 신청완료", path: "/apply/plus/complete" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "페이지 진입 후 견적 ID(estimateId)가 확인되면 자동 노출"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.CAR_DETAIL_INQUIRY` (A) */
  CAR_DETAIL_INQUIRY: {
    eventId: "33",
    instanceKey: "car-detail-csat-33",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "차량상세", path: "/cars/detail/:carId" },
    device: ENCAR_SURVEY_DEVICE.PC,
    trigger: "판매자 문의하기 > 전화문의 레이어를 3초 이상 연 뒤 닫거나, 연락처 받기(완료) 레이어를 닫을 때"
  },
  AFFILIATION_DEALER_COMPLETE: {
    eventId: "34",
    instanceKey: "affiliation-dealer-csat-1",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "buy", label: "엔카금융플러스 제휴딜러 가입완료", path: "/loan/affiliation-dealer/complete" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "페이지 진입 시 자동 노출, 또는 설문 카드 클릭 시"
  },
  LOAN_COUNSEL_CANCEL: {
    eventId: "36",
    instanceKey: "loan-counsel-csat-1",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "엔카페이 한도조회", path: "/loan/client/encarpay-limit-check/:applicationId" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: 'X버튼 2번째 클릭 시 뜨는 취소 레이어에서 "그만하기" 클릭 시'
  },
  LOAN_COUNSEL_SUCCESS: {
    eventId: "37",
    instanceKey: "loan-counsel-csat-2",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "엔카페이 한도조회", path: "/loan/client/encarpay-limit-check/:applicationId" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "상담신청 완료(SUCCESS) 화면 진입 시"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.ENQUIRY_RECEIVED` (B-1) */
  ENQUIRY_RECEIVED_V2_1: {
    eventId: "39",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "딜러 050 통화 이력이 있는 고객(회원·비회원 모두) 중 최근 3개월 안에 받은 적 없는 사람에게 통화 직후, 전화번호 기준 10분마다 묶어서 발송, 통화시간 10~30초"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.ENQUIRY_RECEIVED` (B-2) */
  ENQUIRY_RECEIVED_V2_2: {
    eventId: "40",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "딜러 050 통화 이력이 있는 고객(회원·비회원 모두) 중 최근 3개월 안에 받은 적 없는 사람에게 통화 직후, 전화번호 기준 10분마다 묶어서 발송, 통화시간 31~50초"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.ENQUIRY_RECEIVED` (B-3) */
  ENQUIRY_RECEIVED_V2_3: {
    eventId: "41",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "딜러 050 통화 이력이 있는 고객(회원·비회원 모두) 중 최근 3개월 안에 받은 적 없는 사람에게 통화 직후, 전화번호 기준 10분마다 묶어서 발송, 통화시간 51초 이상"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.MEETGO_DELIVERY_BUY` (B) */
  MEETGO_DELIVERY_BUY_V2: {
    eventId: "42",
    type: ENCAR_SURVEY_TYPE.INSTANT,
    trigger: "엔카믿고(배송)로 구매를 완료한 고객. 재구매하면 다시 발송 > 구매확정 시점 기준, 1시간마다 묶어서 발송"
  },
  /** AB: `ENCAR_SURVEY_AB_TEST.CAR_DETAIL_INQUIRY` (B) */
  CAR_DETAIL_INQUIRY_V2: {
    eventId: "43",
    instanceKey: "car-detail-csat-43",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "차량상세", path: "/cars/detail/:carId" },
    device: ENCAR_SURVEY_DEVICE.PC,
    trigger: "판매자 문의하기 > 전화문의 레이어를 3초 이상 연 뒤 닫거나, 연락처 받기(완료) 레이어를 닫을 때"
  },
  ENQUIRY_RECEIVED_LONGTERM_V2: {
    eventId: "44",
    type: ENCAR_SURVEY_TYPE.LONG_TERM,
    trigger: "차량 검색 후 이탈 or 차량 검색 후 차량 리스트에서 5~9대 조회"
  },
  QA: {
    eventId: "29",
    instanceKey: "qa-nps-survey",
    type: ENCAR_SURVEY_TYPE.CSAT,
    page: { service: "fem", label: "NPS 설문 QA", path: "/qa/nps" },
    device: ENCAR_SURVEY_DEVICE.ALL,
    trigger: "QA 화면에서 수동 오픈 (eventId는 화면 입력값 우선, 여기 값은 기본값)"
  }
}, ENCAR_SURVEY_AB_TEST = {
  /** 050 구매문의 INSTANT - A: 1, B: (39, 40, 41) */
  ENQUIRY_RECEIVED: {
    testId: "050-enquiry-received-ab",
    variants: {
      A: ENCAR_SURVEY.ENQUIRY_RECEIVED,
      B: ENCAR_SURVEY.ENQUIRY_RECEIVED_V2_1
    }
  },
  /** 믿고 구매문의 INSTANT - A: 5, B: 42 */
  MEETGO_DELIVERY_BUY: {
    testId: "meetgo-delivery-buy-ab",
    variants: {
      A: ENCAR_SURVEY.MEETGO_DELIVERY_BUY,
      B: ENCAR_SURVEY.MEETGO_DELIVERY_BUY_V2
    }
  },
  /** 차량상세 판매자 문의 CSAT(PC) — A: 33, B: 43 */
  CAR_DETAIL_INQUIRY: {
    testId: "car-detail-inquiry-ab",
    variants: {
      A: ENCAR_SURVEY.CAR_DETAIL_INQUIRY,
      B: ENCAR_SURVEY.CAR_DETAIL_INQUIRY_V2
    },
    cookieName: "enSurveyGroup_33-43"
  }
}, maskingFirstLast = (textValue, firstIndex, lastIndex) => {
  const text = textValue.toString(), twoCharacters = text.length === 2 ? 1 : 0, fName = text.substring(0, firstIndex), lName = text.substring(text.length - lastIndex + twoCharacters, text.length);
  let mName = "";
  return text.substring(firstIndex, text.length - lastIndex + twoCharacters).split("").forEach(() => {
    mName += "*";
  }), fName + mName + lName;
}, onMaskingEmailHandle = (email) => {
  if (!email)
    return;
  let result = "";
  const emailId = email.replace(/@.*/, ""), emailDomain = email.replace(/.*@/, "");
  return emailId.length <= 3 ? result = emailId.slice(0, 1) + "*".repeat(emailId.length - 1) : emailId.length <= 6 ? result = emailId.slice(0, 2) + "*".repeat(emailId.length - 2) : result = emailId.slice(0, 3) + "*".repeat(emailId.length - 6) + emailId.slice(emailId.length - 3, emailId.length), `${result}@${emailDomain}`;
}, maskingId = (id) => {
  if (id)
    return id.length <= 3 ? id : id.substring(0, 3) + Array(id.length - 2).join("*");
}, maskName = (name) => !name || name.length <= 2 ? name.length === 2 ? `${name[0]}*` : name : `${name[0]}${"*".repeat(name.length - 2)}${name[name.length - 1]}`, unEscapeAll = (str) => {
  const regex = /&(amp|lt|gt|quot|#39|#40|#41);/g, chars = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
    "&#40;": "(",
    "&#41;": ")"
  };
  return regex.test(str) ? str.replace(regex, (matched) => chars[matched] || matched) : str;
}, removeEmojiAndEntityCdoe = (str = "") => str.replace(new RegExp("\\p{Emoji_Presentation}|(?<!\\d)\\p{Extended_Pictographic}|&#\\s*\\d+\\s*;", "gu"), ""), maskAfterFiveChars = (value, visibleLength = 5) => {
  if (!value || Array.from(value).filter((ch) => ch !== " ").length <= visibleLength)
    return value;
  let visibleCount = 0;
  return Array.from(value).map((ch) => ch === " " ? ch : (visibleCount += 1, visibleCount <= visibleLength ? ch : "*")).join("");
};
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source)
      target[key] = source[key];
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    return value[0] === '"' && (value = value.slice(1, -1)), value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (!(typeof document > "u")) {
      attributes = assign({}, defaultAttributes, attributes), typeof attributes.expires == "number" && (attributes.expires = new Date(Date.now() + attributes.expires * 864e5)), attributes.expires && (attributes.expires = attributes.expires.toUTCString()), name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var stringifiedAttributes = "";
      for (var attributeName in attributes)
        attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, attributes[attributeName] !== !0 && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
      return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
  }
  function get(name) {
    if (!(typeof document > "u" || arguments.length && !name)) {
      for (var cookies = document.cookie ? document.cookie.split("; ") : [], jar = {}, i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split("="), value = parts.slice(1).join("=");
        try {
          var found = decodeURIComponent(parts[0]);
          if (jar[found] = converter.read(value, found), name === found)
            break;
        } catch {
        }
      }
      return name ? jar[name] : jar;
    }
  }
  return Object.create(
    {
      set,
      get,
      remove: function(name, attributes) {
        set(
          name,
          "",
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init(assign({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
function isIPAddress(strIP) {
  return /^(1|2)?\d?\d([.](1|2)?\d?\d){3}$/.test(strIP);
}
function getCookieDomain() {
  if (typeof window > "u")
    return "";
  const hostName = window.location.hostname;
  let domain, result = "";
  return hostName !== "localhost" && !isIPAddress(hostName) && (domain = hostName.split("."), result = `.${domain[domain.length - 2]}.${domain[domain.length - 1]}`), result;
}
function checkIP(strIP) {
  return /^(1|2)?\d?\d([.](1|2)?\d?\d){3}$/.test(strIP);
}
function setCookie(cName, cValue, cDay, cHour, cMin, cSec) {
  const expire = /* @__PURE__ */ new Date(), hostnames = window.location.hostname.split(".");
  let domain;
  hostnames[0] === "localhost" ? domain = "" : checkIP(window.location.hostname) ? domain = window.location.hostname : domain = `.${hostnames[hostnames.length - 2]}.${hostnames[hostnames.length - 1]}`;
  let cookies = `${cName}=${encodeURIComponent(cValue)}; domain=${domain}; path=/;`;
  cDay && expire.setDate(expire.getDate() + cDay), cHour && expire.setHours(expire.getHours() + cHour), cMin && expire.setMinutes(expire.getMinutes() + cMin), cSec && expire.setSeconds(expire.getSeconds() + cSec), (cDay || cHour || cMin || cSec) && (cookies += ` expires=${expire.toUTCString()};`), window.document.cookie = cookies;
}
function getCookie(key, cookieStr) {
  var _a;
  const newKey = `${key}=`, cookieData = cookieStr || ((_a = global.document) === null || _a === void 0 ? void 0 : _a.cookie) || "";
  let start = cookieData.indexOf(newKey), cValue = "";
  if (start !== -1) {
    start += newKey.length;
    let end = cookieData.indexOf(";", start);
    end === -1 && (end = cookieData.length), cValue = decodeURIComponent(cookieData.substring(start, end));
  }
  return cValue;
}
function deleteCookie(cName) {
  setCookie(cName, "", -1);
}
const LEGACY_COOKIE_KEYS_TO_CLEANUP = [
  "ab_6a7419105473e54b8f610a3c",
  "ab_6a74197102fef05a6286c391"
];
function removeCookies(names) {
  if (typeof window > "u")
    return;
  const domain = getCookieDomain();
  names.forEach((name) => {
    api.get(name) !== void 0 && (domain && api.remove(name, { path: "/", domain }), api.remove(name, { path: "/" }));
  });
}
const toFixedToNumber = (data, fixed) => {
  const newData = data ? Number(data) : 0;
  return Number(newData.toFixed(fixed));
}, numberCommaFormatter = /\B(?=(\d{3})+(?!\d))/g, numberWithComma = (num) => num == null ? "" : num.toString().replace(numberCommaFormatter, ","), numberWithKoreanUnit = (value) => {
  const numValue = typeof value == "string" ? Number(value.replace(",", "")) : value, prevUnit = numValue % 1e3, overUnit = Math.floor(numValue / 1e3), modToString = value.toString(), overUnitToArray = overUnit.toString().split(""), handleZero = (strValue) => {
    const trimValue = Number(strValue.toString().replace(",", ""));
    return trimValue === 0 ? "" : ` ${numberWithComma(trimValue)}`;
  };
  if (overUnit === 0)
    return `${value}`;
  if (overUnitToArray.length > 1) {
    const indexEnd = overUnitToArray.length - 1;
    return `${modToString.substring(0, indexEnd)}만 ${handleZero(modToString.substring(indexEnd))}`;
  }
  return overUnitToArray.length === 1 ? `${overUnit}천 ${handleZero(prevUnit)}` : "";
}, commaWithWon = (num) => {
  const koreanUnits = ["조", "억", ""];
  let remainingNum = num, answer = "";
  for (; remainingNum > 0; ) {
    const modToString = (remainingNum % 1e4).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    remainingNum = Math.floor(remainingNum / 1e4), answer = `${modToString}${koreanUnits.pop()}${answer}`;
  }
  return answer;
}, getTimer = (time) => {
  const min = Math.floor(time / 60), sec = time % 60, paddedMin = min < 10 ? `0${min}` : `${min}`, paddedSec = sec < 10 ? `0${sec}` : `${sec}`;
  return `${paddedMin}:${paddedSec}`;
};
function formatToManWon(amount) {
  return `${numberWithComma(Math.floor(amount / 1e4))}만원`;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof window < "u" && (window.dataTalkSendJsonClientCount = window.dataTalkSendJsonClientCount ? window.dataTalkSendJsonClientCount : 0);
var DataTalkEventType;
(function(DataTalkEventType2) {
  DataTalkEventType2.VIEW = "VIEW", DataTalkEventType2.CLICK = "CLICK", DataTalkEventType2.ACTION = "ACTION";
})(DataTalkEventType || (DataTalkEventType = {}));
const Enlog = (errorCallback) => {
  const propsDataset = (props) => {
    const findProps = Object.keys(props).filter((key) => key.indexOf("data-") > -1), result = {};
    return findProps.forEach((key) => {
      result[key] = props[key];
    }), result;
  }, checkEnlogLoaded = () => new Promise((resolve) => {
    var _a;
    if (typeof ((_a = window.enlog) === null || _a === void 0 ? void 0 : _a.sendJson) == "function") {
      resolve(!0);
      return;
    }
    let count = 0;
    const loadEnlog = setInterval(() => {
      var _a2;
      if (typeof ((_a2 = window.enlog) === null || _a2 === void 0 ? void 0 : _a2.sendJson) == "function") {
        clearInterval(loadEnlog), resolve(!0);
        return;
      }
      count += 1, count > 200 && (clearInterval(loadEnlog), resolve(!1), console.log("enlog: not working"));
    }, 50);
  });
  return {
    propsDataset,
    enloggingJsonData: (param) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        window.dataTalkSendJsonClientCount += 1;
        const data = Object.assign(Object.assign({}, param), { client: {
          search: window.location.search,
          pathname: window.location.pathname,
          url: window.location.href,
          index: window.dataTalkSendJsonClientCount,
          referrer: document.referrer
        } });
        (yield checkEnlogLoaded()) && window.enlog.sendJson(data);
      } catch (err) {
        errorCallback && errorCallback(err);
      }
    }),
    enloggingDatatalkHit: (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (text = "") {
      try {
        (yield checkEnlogLoaded()) && window.enlog.dataTalk.setHit(text);
      } catch (err) {
        errorCallback && errorCallback(err);
      }
    }),
    enloggingSetViewParam: (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (param = {}) {
      try {
        (yield checkEnlogLoaded()) && window.enlog.dataTalk.setViewParam(param);
      } catch (err) {
        errorCallback && errorCallback(err);
      }
    }),
    enloggingScrollObserver: (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (param = {
      name: ""
    }) {
      if (window.enlogObserverList || (window.enlogObserverList = {}), !window.enlogObserverList[param.name])
        try {
          (yield checkEnlogLoaded()) && (window.enlogObserverList[param.name] = new window.enlog.ScrollObserver(param.options));
        } catch (err) {
          errorCallback && errorCallback(err);
        }
    }),
    enloggingGetHit: () => {
      var _a;
      return api.get("_enlog_datatalk_hit") || ((_a = window?.enlogInitJson) === null || _a === void 0 ? void 0 : _a.currenthit) || "";
    }
  };
}, checkKakaoPixelLoaded = () => new Promise((resolve) => {
  const { _kp_key, kakaoPixel } = window;
  kakaoPixel && resolve({
    kpKey: _kp_key,
    kakaoPixel
  });
  let count = 0;
  const loadKakaoPixel = setInterval(() => {
    const { _kp_key: currentKpKey, kakaoPixel: currentKakaoPixel } = window;
    currentKakaoPixel && (clearInterval(loadKakaoPixel), resolve({
      kpKey: currentKpKey,
      kakaoPixel: currentKakaoPixel
    })), count += 1, count > 200 && (clearInterval(loadKakaoPixel), resolve(null), console.log("카카오 픽셀 스크립트 로드 오류"));
  }, 100);
}), executeKakaoPixel = (tag, errorCallback) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const kakaoPixel = yield checkKakaoPixelLoaded();
    kakaoPixel && window.kakaoPixel(kakaoPixel.kpKey).pageView(tag);
  } catch (err) {
    errorCallback && errorCallback(err);
  }
}), checkFacebookPixelLoaded = () => new Promise((resolve) => {
  const { fbq } = window;
  fbq && resolve({
    fbq
  });
  let count = 0;
  const loadFacebookPixel = setInterval(() => {
    const { fbq: currentFbq } = window;
    currentFbq && (clearInterval(loadFacebookPixel), resolve({
      fbq: currentFbq
    })), count += 1, count > 200 && (clearInterval(loadFacebookPixel), resolve(null), console.log("페이스북 픽셀 스크립트 로드 오류"));
  }, 100);
}), executeFacebookPixel = (tag, type, errorCallback) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const facebookPixel = yield checkFacebookPixelLoaded();
    facebookPixel && facebookPixel.fbq(type || "trackCustom", tag);
  } catch (err) {
    errorCallback && errorCallback(err);
  }
}), pixel = {
  executeKakaoPixel,
  executeFacebookPixel
}, loadScript = (id, path) => new Promise(((resolve) => {
  if (document && document.querySelectorAll(`#${id}`).length === 0) {
    const script = document.createElement("script");
    script.id = id, script.src = path, script.onload = () => resolve(), document.head.appendChild(script);
  } else
    resolve();
})), testName = (str, space) => /^[가-힣a-zA-Z]+$/.test(str) ? !0 : space ? /^[a-zA-Z]+( [a-zA-Z]+)*$/.test(str) : !1, testEmail = (str) => /^[0-9a-zA-Z_]([-_.]?[0-9a-zA-Z_-])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i.test(str), testMobile = (str) => /^01(0|1|[6-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/.test(str), testTel = (str) => {
  const regEx = /(^02|^0502|^0504|^0505|^0506|^1[0-9]{3}|^0[0-9]{2})-?([0-9]+)?-?([0-9]{4})/;
  return !testMobile(str) && regEx.test(str);
}, testNumber = (str) => /^[0-9]+$/.test(str), testId = (str) => /^[a-z0-9]{4,12}$/.test(str), testSalesNumber = (str) => /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9-]+$/.test(str), testKor = (str) => /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(str), testFullUrl = (str) => /^http/g.test(str), testMobileSiteByOrigin = (str) => /(?:\/\/)(m|mnew|mrelease)\.encar|io:83|m\.k8s/g.test(str), testCarNumber = (str) => /^[0-9]{2,3}[가-힣]{1}[0-9]{4}$|^[가-힣]{2}[0-9]{2,3}[가-힣]{1}[0-9]{4}$/.test(str), testEncodedUrl = (str) => /^(?:[a-zA-Z0-9\-_.!~*'()%20]|%[0-9a-fA-F]{2})*$/.test(str), testEmojiRegex = (str = "") => new RegExp("\\p{Emoji_Presentation}|(?<!\\d)\\p{Extended_Pictographic}|&#\\s*\\d+\\s*;", "gu").test(str), ACCESS_TOKEN_KEY = "ENID_ACCESS_TOKEN", AUTH_PLATFORM_KEY = "ENID_PLATFORM", MY_INFO_ACCESS_DATA_KEY = "my_info_access", throttle = (func, waitFor) => {
  let throttleCheck = null;
  return (...args) => {
    throttleCheck || (throttleCheck = window.setTimeout(() => {
      func(...args), throttleCheck = null;
    }, waitFor));
  };
}, ChannelTalk = () => {
  const checkLoaded2 = () => new Promise((resolve) => {
    window.ChannelIOInitialized && resolve(!0);
    let count = 0;
    const loadChannelTalk = setInterval(() => {
      window.ChannelIOInitialized && (clearInterval(loadChannelTalk), resolve(!0)), count += 1, count > 200 && (clearInterval(loadChannelTalk), resolve(!1), console.log("channelTalk: not working"));
    }, 50);
  });
  return {
    boot: (option, callback) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("boot", Object.assign(Object.assign({}, option || !1), !option.pluginKey && { pluginKey: "b8adb4a8-56a8-42da-99db-6ce843bb9fda" }), callback);
      } catch (error) {
        console.log(error);
      }
    }),
    shutDown: () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("shutdown");
      } catch (error) {
        console.log(error);
      }
    }),
    openMessanger: () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("showMessenger");
      } catch (error) {
        console.log(error);
      }
    }),
    closeMessanger: () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("hideMessenger");
      } catch (error) {
        console.log(error);
      }
    }),
    openChat: (chatId, message) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("openChat", chatId, message);
      } catch (error) {
        console.log(error);
      }
    }),
    onOpenMessenger: (callback) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("onShowMessenge", callback);
      } catch (error) {
        console.log(error);
      }
    }),
    onCloseMessenger: (callback) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("onHideMessenger", callback);
      } catch (error) {
        console.log(error);
      }
    }),
    onBadgeChanged: (callback) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("onBadgeChanged", callback);
      } catch (error) {
        console.log(error);
      }
    }),
    onUrlClicked: (callback) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("onUrlClicked", callback);
      } catch (error) {
        console.log(error);
      }
    }),
    onTrack: (eventName, eventProperty) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("track", eventName, eventProperty);
      } catch (error) {
        console.log(error);
      }
    }),
    clearCallbacks: () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) && window.ChannelIO("clearCallbacks");
      } catch (error) {
        console.log(error);
      }
    })
  };
}, NaverAdManager = () => {
  const checkLoaded2 = () => new Promise((resolve) => {
    window.gladsdk && resolve(!0);
    let count = 0;
    const loadInterval = setInterval(() => {
      window.gladsdk && (clearInterval(loadInterval), resolve(!0)), count += 1, count > 200 && (clearInterval(loadInterval), resolve(!1), console.log("NAM: not working"));
    }, 50);
  });
  return {
    displayAd: (option) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        (yield checkLoaded2()) ? window.gladsdk.cmd.push(() => {
          window.gladsdk.addEventListener(window.gladsdk.event.AD_LOADED, option.loadEvent), window.gladsdk.addEventListener(window.gladsdk.event.ERROR, option.errorEvent);
          const adSlot = window.gladsdk.defineAdSlot(option.adSlotInfo);
          window.gladsdk.displayAd(adSlot);
        }) : option.errorEvent();
      } catch (error) {
        console.log(error);
      }
    }),
    destroyAd: (adSlotInfo) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        if (yield checkLoaded2()) {
          window.gladsdk.removeAllEventListener();
          const prevAdSlot = window.gladsdk.findAdSlot(adSlotInfo.adSlotElementId);
          prevAdSlot && window.gladsdk.destroyAdSlots([prevAdSlot]);
        }
      } catch (error) {
        console.log(error);
      }
    })
  };
}, dataUrlToBlob = (b64Data, size) => {
  const sliceSize = size || 512, byteCharacters = atob(b64Data.split(",")[1]), contentType = b64Data.split(",")[0].split(":")[1].split(";")[0], byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize), byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1)
      byteNumbers[i] = slice.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: contentType });
}, urlType = (url) => {
  let type;
  return url.indexOf("data:") !== -1 ? type = "dataurl" : url.indexOf("blob:") !== -1 ? type = "bloburl" : type = "weburl", type;
}, urlToBlob = (url, type) => new Promise((resolve) => {
  const uType = type || urlType(url);
  let blobData;
  uType === "dataurl" ? blobData = dataUrlToBlob(url) : blobData = fetch(url, {
    method: "GET"
  }).then((res) => res.blob()), console.log({ blobData }), resolve(blobData);
});
class ImageConverter {
  constructor({ allowImgTypes, maxFileSize, imageMaxWidth }) {
    this.allowImgTypes = [], this.maxFileSize = 30 * 1024 * 1024, this.imageObj = null, this.fileUrl = "", this.imageMaxWidth = 1920, this.fileType = "", this.readFileToString = (file) => new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        var _a, _b;
        this.fileUrl = String((_a = e.target) === null || _a === void 0 ? void 0 : _a.result), resolve(String((_b = e.target) === null || _b === void 0 ? void 0 : _b.result));
      }, reader.onerror = () => resolve(""), reader.readAsDataURL(file);
    }), this.loadImage = (src) => new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        this.imageObj = image, resolve(image);
      }, image.onerror = (e) => {
        reject(e);
      }, image.src = src;
    }), this.canvasToBlob = (canvas, quality) => new Promise((resolve) => {
      canvas.toBlob((blobData) => {
        blobData && resolve(blobData);
      }, this.fileType, quality || 0.95);
    }), this.resizeImageToBlob = (originImage) => __awaiter(this, void 0, void 0, function* () {
      const canvas = (() => {
        const canvas2 = document.createElement("canvas"), context = canvas2.getContext("2d"), newWidth = Math.max(this.imageMaxWidth, originImage.width), newHeight = newWidth * originImage.height / originImage.width;
        return canvas2.width = newWidth, canvas2.height = newHeight, context?.drawImage(originImage, 0, 0, newWidth, newHeight), canvas2;
      })();
      let cnt = 0;
      const compressUntilUnderLimit = () => __awaiter(this, void 0, void 0, function* () {
        cnt += 1;
        const quality = 0.95 - (cnt - 1) * 0.1, blobData = yield this.canvasToBlob(canvas, quality);
        return blobData.size <= this.maxFileSize || cnt >= 5 ? blobData : compressUntilUnderLimit();
      });
      return yield compressUntilUnderLimit();
    }), this.convert = (file) => __awaiter(this, void 0, void 0, function* () {
      if (!(yield this.isAllowImgType(file)))
        throw new Error("Not Allow Image Type");
      if (!(yield this.checkAbleImageWidthHeight(file)))
        throw new Error("Load Fail Image File");
      if (!this.fileUrl || !this.imageObj)
        throw new Error("Runtime Error In Image Converter");
      if (file.size <= this.maxFileSize)
        return file;
      const blob = yield this.resizeImageToBlob(this.imageObj);
      return new File([blob], `conveted_${file.name}`);
    }), this.getFileUrl = (file) => __awaiter(this, void 0, void 0, function* () {
      return yield this.readFileToString(file);
    }), this.allowImgTypes = allowImgTypes, maxFileSize && (this.maxFileSize = maxFileSize), imageMaxWidth && (this.imageMaxWidth = imageMaxWidth);
  }
  isAllowImgType(file) {
    const result = this.allowImgTypes.includes(file.type);
    return this.fileType = file.type, result;
  }
  checkAbleImageWidthHeight(file) {
    return __awaiter(this, void 0, void 0, function* () {
      const imgSrc = yield this.readFileToString(file);
      if (!imgSrc || typeof imgSrc != "string")
        return !1;
      const image = yield this.loadImage(imgSrc);
      return !(!image || !image.width || !image.height);
    });
  }
}
const encarChatInstance = {};
let encarChatSdkFileLoad = !1;
const loadEncarChatScript = () => {
  var _a;
  if (encarChatSdkFileLoad && typeof window.EncarChatSDK == "function")
    return;
  const scriptElement = document.createElement("script");
  scriptElement.setAttribute("src", `${ENCAR_STATIC_SERVER}/common/sdk/enchat/enchat-1.1.0.js`), scriptElement.setAttribute("async", "async"), (_a = document.querySelector("head")) === null || _a === void 0 || _a.appendChild(scriptElement), encarChatSdkFileLoad = !0;
}, checkLoaded$2 = (func) => new Promise((resolve) => {
  if (func && func()) {
    resolve(!0);
    return;
  }
  let count = 0;
  const loaded = setInterval(() => {
    if (func && func()) {
      clearInterval(loaded), resolve(!0);
      return;
    }
    count += 1, count > 200 && (clearInterval(loaded), resolve(!1), console.log("checkLoaded: not loaded"));
  }, 50);
}), encarChatInit = (type, data) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    if (encarChatInstance[type]) {
      console.log("EncarChat already initialized for type:", type);
      return;
    }
    loadEncarChatScript(), (yield checkLoaded$2(() => typeof window.EncarChatSDK == "function")) && (encarChatInstance[type] = new window.EncarChatSDK(), encarChatInstance[type].init(data));
  } catch (err) {
    console.log("EncarChatSDK: not loaded", err);
  }
}), encarChatSetOptions = (type, data) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded$2(() => typeof encarChatInstance[type] == "object")) && encarChatInstance[type].setOptions(data);
  } catch (err) {
    console.log("EncarChatSDK: not loaded", err);
  }
}), encarChatAddCount = (type) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded$2(() => typeof encarChatInstance[type] == "object")) && encarChatInstance[type].addCount();
  } catch (err) {
    console.log("EncarChatSDK: not loaded", err);
  }
}), encarChatDestroy = (type) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded$2(() => typeof encarChatInstance[type] == "object")) && (encarChatInstance[type].destroy(), delete encarChatInstance[type]);
  } catch (err) {
    console.log("EncarChatSDK: not loaded", err);
  }
}), EncarChat = () => ({
  encarChatInit,
  encarChatSetOptions,
  encarChatAddCount,
  encarChatDestroy
}), encarSurveyInstance = {};
let encarSurveySdkFileLoad = !1;
const loadEncarSurveyScript = () => {
  var _a;
  if (encarSurveySdkFileLoad && typeof window.EncarSurveySDK == "function")
    return;
  const scriptElement = document.createElement("script");
  scriptElement.setAttribute("src", `${ENCAR_STATIC_SERVER}/common/sdk/ensurvey.js`), scriptElement.setAttribute("async", "async"), scriptElement.onload = () => {
    encarSurveySdkFileLoad = !0;
  }, scriptElement.onerror = () => {
    scriptElement.remove();
  }, (_a = document.querySelector("head")) === null || _a === void 0 || _a.appendChild(scriptElement);
}, checkLoaded$1 = (func) => new Promise((resolve) => {
  if (func && func()) {
    resolve(!0);
    return;
  }
  let count = 0;
  const loaded = setInterval(() => {
    if (func && func()) {
      clearInterval(loaded), resolve(!0);
      return;
    }
    count += 1, count > 100 && (clearInterval(loaded), resolve(!1), console.log("checkLoaded: not loaded"));
  }, 50);
}), encarSurveyInit = (instanceKey, data) => __awaiter(void 0, void 0, void 0, function* () {
  var _a, _b;
  try {
    loadEncarSurveyScript();
    const loaded = yield checkLoaded$1(() => typeof window.EncarSurveySDK == "function");
    loaded && (encarSurveyInstance[instanceKey] = new window.EncarSurveySDK(), encarSurveyInstance[instanceKey].init(data)), loaded || (_a = data.onFailValid) === null || _a === void 0 || _a.call(data);
  } catch (err) {
    console.log("EncarSurveySDK: not loaded", err), (_b = data.onFailValid) === null || _b === void 0 || _b.call(data);
  }
}), encarSurveyInvoke = (instanceKey, method, ...args) => __awaiter(void 0, void 0, void 0, function* () {
  var _a, _b, _c, _d, _e, _f;
  try {
    if (method === "destroy") {
      typeof encarSurveyInstance[instanceKey] == "object" && (encarSurveyInstance?.[instanceKey][method](), encarSurveyInstance == null || delete encarSurveyInstance[instanceKey]);
      return;
    }
    if ((yield checkLoaded$1(() => typeof encarSurveyInstance[instanceKey] == "object")) && typeof encarSurveyInstance[instanceKey][method] == "function") {
      encarSurveyInstance[instanceKey][method](...args);
      return;
    }
    (_c = (_b = (_a = encarSurveyInstance?.[instanceKey]) === null || _a === void 0 ? void 0 : _a.option) === null || _b === void 0 ? void 0 : _b.onFailValid) === null || _c === void 0 || _c.call(_b);
  } catch (err) {
    console.log("EncarSurveySDK : not method", err), (_f = (_e = (_d = encarSurveyInstance?.[instanceKey]) === null || _d === void 0 ? void 0 : _d.option) === null || _e === void 0 ? void 0 : _e.onFailValid) === null || _f === void 0 || _f.call(_e);
  }
}), EncarSurvey = () => ({
  encarSurveyInit,
  encarSurveyInvoke
}), downloadBlobFile = (blob, fileName) => {
  const downloadUrl = window.URL.createObjectURL(blob), link = document.createElement("a");
  link.style.display = "none", link.href = downloadUrl, link.download = fileName, link.setAttribute("data-enlog-dt-auto", "false"), document.body.appendChild(link), link.click(), document.body.removeChild(link), window.URL.revokeObjectURL(downloadUrl);
}, truncateFileName = (fileName, maxLength = 10) => {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1)
    return fileName.length > maxLength ? `${fileName.substring(0, maxLength)}...` : fileName;
  const name = fileName.substring(0, lastDotIndex), extension = fileName.substring(lastDotIndex);
  return name.length > maxLength ? `${name.substring(0, maxLength)}...${extension}` : fileName;
}, ONLOAD_CALLBACK = "onTranslatorLoaded", translatorInstances = {};
let TranslatorClass = null, translatorSdkFileLoad = !1;
const loadTranslatorScript = () => {
  if (translatorSdkFileLoad)
    return;
  window[ONLOAD_CALLBACK] = (Ctor) => {
    delete window[ONLOAD_CALLBACK], TranslatorClass = Ctor;
  };
  const script = document.createElement("script");
  script.onload = () => {
    const callback = window[ONLOAD_CALLBACK], Ctor = window.Translator;
    typeof callback == "function" && typeof Ctor == "function" && callback(Ctor);
  }, script.onerror = () => {
    translatorSdkFileLoad = !1, console.error("Translator SDK: script load failed");
  }, script.src = `${ENCAR_STATIC_SERVER}/common/sdk/translator.js?onload=${ONLOAD_CALLBACK}`, document.head.appendChild(script), translatorSdkFileLoad = !0;
}, checkLoaded = (func) => new Promise((resolve) => {
  if (func?.()) {
    resolve(!0);
    return;
  }
  let count = 0;
  const interval = setInterval(() => {
    func?.() && (clearInterval(interval), resolve(!0)), count += 1, count > 200 && (clearInterval(interval), resolve(!1), console.error("checkLoaded: not loaded"));
  }, 50);
}), translatorInit = (type, options) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    if (translatorInstances[type]) {
      console.log("Translator already initialized for type:", type);
      return;
    }
    loadTranslatorScript(), (yield checkLoaded(() => typeof TranslatorClass == "function")) && TranslatorClass ? translatorInstances[type] = new TranslatorClass(options) : console.error("Translator SDK: init timeout — TranslatorClass not ready");
  } catch (err) {
    console.error("Translator SDK: init failed", err);
  }
}), translatorTranslate = (type, root, options) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded(() => typeof translatorInstances[type] == "object")) ? yield translatorInstances[type].translate(root, options) : console.error("Translator SDK: translate timeout — instance not ready");
  } catch (err) {
    console.error("Translator SDK: translate failed", err);
  }
}), translatorTranslateText = (type, texts) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    return (yield checkLoaded(() => typeof translatorInstances[type] == "object")) ? yield translatorInstances[type].translateText(texts) : (console.error("Translator SDK: translateText timeout — instance not ready"), {});
  } catch (err) {
    return console.error("Translator SDK: translateText failed", err), {};
  }
}), translatorObserve = (type, root, observerOptions) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded(() => typeof translatorInstances[type] == "object")) ? translatorInstances[type].observe(root, observerOptions) : console.error("Translator SDK: observe timeout — instance not ready");
  } catch (err) {
    console.error("Translator SDK: observe failed", err);
  }
}), translatorUnobserve = (type, root) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    (yield checkLoaded(() => typeof translatorInstances[type] == "object")) ? translatorInstances[type].unobserve(root) : console.error("Translator SDK: unobserve timeout — instance not ready");
  } catch (err) {
    console.error("Translator SDK: unobserve failed", err);
  }
}), translatorDestroy = (type) => {
  try {
    if (typeof translatorInstances[type] != "object")
      return;
    translatorInstances[type].destroy(), delete translatorInstances[type];
  } catch (err) {
    console.error("Translator SDK: destroy failed", err);
  }
}, EncarTranslator = () => ({
  translatorInit,
  translatorTranslate,
  translatorTranslateText,
  translatorObserve,
  translatorUnobserve,
  translatorDestroy
});
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}
var uaParser$2 = { exports: {} }, uaParser$1 = uaParser$2.exports, hasRequiredUaParser;
function requireUaParser() {
  return hasRequiredUaParser || (hasRequiredUaParser = 1, (function(module, exports$1) {
    (function(window2, undefined$1) {
      var LIBVERSION = "1.0.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500, AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser", extend = function(regexes2, extensions) {
        var mergedRegexes = {};
        for (var i in regexes2)
          extensions[i] && extensions[i].length % 2 === 0 ? mergedRegexes[i] = extensions[i].concat(regexes2[i]) : mergedRegexes[i] = regexes2[i];
        return mergedRegexes;
      }, enumerize = function(arr) {
        for (var enums = {}, i = 0; i < arr.length; i++)
          enums[arr[i].toUpperCase()] = arr[i];
        return enums;
      }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : !1;
      }, lowerize = function(str) {
        return str.toLowerCase();
      }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      }, trim = function(str, len) {
        if (typeof str === STR_TYPE)
          return str = str.replace(/^\s\s*/, EMPTY), typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }, rgxMapper = function(ua, arrays) {
        for (var i = 0, j, k, p, q, matches, match; i < arrays.length && !matches; ) {
          var regex = arrays[i], props = arrays[i + 1];
          for (j = k = 0; j < regex.length && !matches && regex[j]; )
            if (matches = regex[j++].exec(ua), matches)
              for (p = 0; p < props.length; p++)
                match = matches[++k], q = props[p], typeof q === OBJ_TYPE && q.length > 0 ? q.length === 2 ? typeof q[1] == FUNC_TYPE ? this[q[0]] = q[1].call(this, match) : this[q[0]] = q[1] : q.length === 3 ? typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test) ? this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1 : this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1 : q.length === 4 && (this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1) : this[q] = match || undefined$1;
          i += 2;
        }
      }, strMapper = function(str, map) {
        for (var i in map)
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++)
              if (has(map[i][j], str))
                return i === UNKNOWN ? undefined$1 : i;
          } else if (has(map[i], str))
            return i === UNKNOWN ? undefined$1 : i;
        return map.hasOwnProperty("*") ? map["*"] : str;
      }, oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, regexes = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [VERSION, [NAME, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [VERSION, [NAME, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [NAME, VERSION],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [VERSION, [NAME, OPERA + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [VERSION, [NAME, OPERA + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [VERSION, [NAME, OPERA]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [VERSION, [NAME, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [VERSION, [NAME, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [NAME, VERSION],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [VERSION, [NAME, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [VERSION, [NAME, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [VERSION, [NAME, "UC" + BROWSER]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [VERSION, [NAME, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [VERSION, [NAME, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [VERSION, [NAME, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [VERSION, [NAME, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [VERSION, [NAME, "Smart Lenovo " + BROWSER]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [VERSION, [NAME, FIREFOX + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [VERSION, [NAME, OPERA + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [VERSION, [NAME, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [VERSION, [NAME, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [VERSION, [NAME, OPERA + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [VERSION, [NAME, "MIUI" + SUFFIX_BROWSER]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [VERSION, [NAME, FIREFOX]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [VERSION, [NAME, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[NAME, /(.+)/, "$1Browser"], VERSION],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[NAME, /(.+)/, "$1" + SUFFIX_BROWSER], VERSION],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [VERSION, [NAME, SAMSUNG + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [VERSION, [NAME, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[NAME, "Sogou Mobile"], VERSION],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [NAME, VERSION],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [NAME],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [VERSION, NAME],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[NAME, FACEBOOK], VERSION],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [NAME, VERSION],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [VERSION, [NAME, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [VERSION, [NAME, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [VERSION, [NAME, CHROME + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[NAME, CHROME + " WebView"], VERSION],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [VERSION, [NAME, "Android " + BROWSER]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [NAME, VERSION],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [VERSION, [NAME, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [VERSION, NAME],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [NAME, [VERSION, strMapper, oldSafariMap]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [NAME, VERSION],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[NAME, "Netscape"], VERSION],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [NAME, VERSION],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [VERSION, [NAME, FIREFOX + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [NAME, [VERSION, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [NAME, [VERSION, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[ARCHITECTURE, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[ARCHITECTURE, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[ARCHITECTURE, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[ARCHITECTURE, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[ARCHITECTURE, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[ARCHITECTURE, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[ARCHITECTURE, lowerize]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
          [
            /(macintosh);/i
          ],
          [MODEL, [VENDOR, APPLE]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [MODEL, [VENDOR, HONOR], [TYPE, TABLET]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [MODEL, [VENDOR, HONOR], [TYPE, MOBILE]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [MODEL, [VENDOR, OPPO], [TYPE, MOBILE]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [MODEL, [VENDOR, strMapper, { OnePlus: ["304", "403", "203"], "*": OPPO }], [TYPE, TABLET]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [MODEL, [VENDOR, LG], [TYPE, TABLET]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [MODEL, [VENDOR, LENOVO], [TYPE, TABLET]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [VENDOR, MODEL, [TYPE, TABLET]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[MODEL, /_/g, " "], [TYPE, MOBILE], [VENDOR, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [MODEL, [VENDOR, ONEPLUS], [TYPE, MOBILE]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [MODEL, VENDOR, [TYPE, TABLET]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [MODEL, [VENDOR, "TCL"], [TYPE, TABLET]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [MODEL, [VENDOR, "Energizer"], [TYPE, MOBILE]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [MODEL, [VENDOR, "Cat"], [TYPE, MOBILE]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [MODEL, [VENDOR, "Smartfren"], [TYPE, MOBILE]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [MODEL, [VENDOR, "Nothing"], [TYPE, MOBILE]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [MODEL, [VENDOR, "Archos"], [TYPE, TABLET]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [MODEL, [VENDOR, "Archos"], [TYPE, MOBILE]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [VENDOR, MODEL, [TYPE, TABLET]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [VENDOR, MODEL, [TYPE, MOBILE]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [VENDOR, MODEL, [TYPE, TABLET]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [MODEL, [VENDOR, NVIDIA], [TYPE, TABLET]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [VENDOR, MODEL, [TYPE, MOBILE]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [VENDOR, [TYPE, SMARTTV]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[VENDOR, LG], [TYPE, SMARTTV]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [MODEL, [VENDOR, NVIDIA], [TYPE, SMARTTV]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [VENDOR, MODEL, [TYPE, SMARTTV]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [MODEL, [TYPE, SMARTTV]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[TYPE, SMARTTV]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [VENDOR, MODEL, [TYPE, CONSOLE]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [MODEL, [VENDOR, NVIDIA], [TYPE, CONSOLE]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [VENDOR, MODEL, [TYPE, WEARABLE]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [MODEL, [VENDOR, OPPO], [TYPE, WEARABLE]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [MODEL, [VENDOR, ONEPLUS], [TYPE, WEARABLE]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [MODEL, [VENDOR, MOTOROLA], [TYPE, WEARABLE]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [MODEL, [VENDOR, SONY], [TYPE, WEARABLE]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [MODEL, [VENDOR, LG], [TYPE, WEARABLE]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [VENDOR, MODEL, [TYPE, WEARABLE]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [VENDOR, [TYPE, EMBEDDED]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [MODEL, [VENDOR, APPLE], [TYPE, EMBEDDED]],
          [
            /windows iot/i
          ],
          [[TYPE, EMBEDDED]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [MODEL, [TYPE, MOBILE]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [MODEL, [TYPE, TABLET]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[TYPE, TABLET]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[TYPE, MOBILE]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [MODEL, [VENDOR, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [VERSION, [NAME, EDGE + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [NAME, VERSION],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [VERSION, [NAME, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [NAME, VERSION],
          [
            /ladybird\//i
          ],
          [[NAME, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [VERSION, NAME]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [NAME, VERSION],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [NAME, [VERSION, strMapper, windowsVersionMap]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[VERSION, strMapper, windowsVersionMap], [NAME, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[VERSION, /_/g, "."], [NAME, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[NAME, MAC_OS], [VERSION, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [VERSION, NAME],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[NAME, /(.+)/, "$1 Touch"], VERSION],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [NAME, VERSION],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [VERSION, [NAME, BLACKBERRY]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [VERSION, [NAME, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [VERSION, [NAME, FIREFOX + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [VERSION, [NAME, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [VERSION, [NAME, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [VERSION, [NAME, CHROME + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[NAME, CHROMIUM_OS], VERSION],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [NAME, VERSION],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[NAME, "Solaris"], VERSION],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [NAME, VERSION]
        ]
      }, UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE && (extensions = ua, ua = undefined$1), !(this instanceof UAParser))
          return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1, _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY), _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1, _rgxmap = extensions ? extend(regexes, extensions) : regexes, _isSelfNav = _navigator && _navigator.userAgent == _ua;
        return this.getBrowser = function() {
          var _browser = {};
          return _browser[NAME] = undefined$1, _browser[VERSION] = undefined$1, rgxMapper.call(_browser, _ua, _rgxmap.browser), _browser[MAJOR] = majorize(_browser[VERSION]), _isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE && (_browser[NAME] = "Brave"), _browser;
        }, this.getCPU = function() {
          var _cpu = {};
          return _cpu[ARCHITECTURE] = undefined$1, rgxMapper.call(_cpu, _ua, _rgxmap.cpu), _cpu;
        }, this.getDevice = function() {
          var _device = {};
          return _device[VENDOR] = undefined$1, _device[MODEL] = undefined$1, _device[TYPE] = undefined$1, rgxMapper.call(_device, _ua, _rgxmap.device), _isSelfNav && !_device[TYPE] && _uach && _uach.mobile && (_device[TYPE] = MOBILE), _isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2 && (_device[MODEL] = "iPad", _device[TYPE] = TABLET), _device;
        }, this.getEngine = function() {
          var _engine = {};
          return _engine[NAME] = undefined$1, _engine[VERSION] = undefined$1, rgxMapper.call(_engine, _ua, _rgxmap.engine), _engine;
        }, this.getOS = function() {
          var _os = {};
          return _os[NAME] = undefined$1, _os[VERSION] = undefined$1, rgxMapper.call(_os, _ua, _rgxmap.os), _isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown" && (_os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS)), _os;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return _ua;
        }, this.setUA = function(ua2) {
          return _ua = typeof ua2 === STR_TYPE && ua2.length > UA_MAX_LENGTH ? trim(ua2, UA_MAX_LENGTH) : ua2, this;
        }, this.setUA(_ua), this;
      };
      UAParser.VERSION = LIBVERSION, UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]), UAParser.CPU = enumerize([ARCHITECTURE]), UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]), UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]), module.exports && (exports$1 = module.exports = UAParser), exports$1.UAParser = UAParser;
      var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
      if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult(), $.ua.get = function() {
          return parser.getUA();
        }, $.ua.set = function(ua) {
          parser.setUA(ua);
          var result = parser.getResult();
          for (var prop in result)
            $.ua[prop] = result[prop];
        };
      }
    })(typeof window == "object" ? window : uaParser$1);
  })(uaParser$2, uaParser$2.exports)), uaParser$2.exports;
}
var uaParserExports = requireUaParser();
const uaParser = (initialNavigator) => {
  var _a;
  const navigator2 = initialNavigator || (isBrowser ? window.navigator : null);
  if (!navigator2)
    return {
      isApp: !1,
      isEncarPartnerApp: !1,
      isPc: !1,
      isMobile: !1,
      isTablet: !1,
      isMobileOrTablet: !1,
      isIOS: !1,
      isAndroid: !1,
      isIE: !1,
      isSafari: !1,
      isKakao: !1,
      browser: void 0,
      isMac: !1,
      isWindow: !1,
      isBot: !1,
      isKR: !1,
      encarAppVersion: "",
      equalAndroid: (version) => !1,
      lessThanAndroid: (version) => !1,
      greaterThanAndroid: (version) => !1,
      equalIE: (version) => !1,
      lessThanIE: (version) => !1,
      greaterThanIE: (version) => !1,
      lessThanAppVersion: (version) => !1,
      greaterThanAppVersion: (version) => !1,
      osVersion: ""
    };
  const { userAgent: userAgent2 } = navigator2, webViewName = userAgent2?.toLowerCase().match(/(webview)_(android|ios|iphone)/gi), isEncarAppAgent = userAgent2?.indexOf("ENCAR") > -1, isEncarParterAppAgent = userAgent2?.indexOf("Encarpartner") > -1, ua = new uaParserExports.UAParser(userAgent2).getResult(), language = (navigator2.userLanguage || navigator2.language || "ko").toLowerCase().substr(0, 2), appVersionInfo = userAgent2?.match(/version(([0-9].{1,}\d+)?)/g), appVersion = ((_a = appVersionInfo?.toString().match(/[0-9].{1,}\d+?$/g)) === null || _a === void 0 ? void 0 : _a.toString()) || "", osVersion = () => {
    const androidMatch = userAgent2?.match(/Android\s([0-9]+)/), iOSMatch = userAgent2?.match(/(iPhone|iPad|iPod).*OS\s([0-9_]+)/), windowsMatch = userAgent2?.match(/Windows NT ([0-9]+)/), macMatch = userAgent2?.match(/Mac OS X ([0-9_]+)/);
    return androidMatch ? `Android ${androidMatch[1]}` : iOSMatch ? `iOS ${iOSMatch[2].replace(/_/g, ".")}` : windowsMatch ? `Windows ${windowsMatch[1]}` : macMatch ? `Mac ${macMatch[1].replace(/_/g, ".")}` : "Unknown";
  }, isBot = () => /(googlebot|bingbot|gptbot|yeti|yandexbot)/i.test(userAgent2);
  return {
    isApp: webViewName != null && isEncarAppAgent,
    isEncarPartnerApp: webViewName != null && isEncarParterAppAgent,
    isPc: ua.device.type == null,
    isMobile: ua.device.type === "mobile",
    isTablet: ua.device.type === "tablet",
    isMobileOrTablet: ua.device.type === "mobile" || ua.device.type === "tablet",
    isIOS: ua.os.name === "iOS",
    isAndroid: ua.os.name === "Android",
    isIE: ua.browser.name === "IE",
    isSafari: ua.browser.name ? ua.browser.name.indexOf("Safari") > -1 : !1,
    isKakao: ua.ua.indexOf("KAKAOTALK") > -1,
    browser: ua.browser,
    isWindow: ua.os.name === "Windows",
    isMac: ua.os.name === "Mac OS",
    isBot: isBot(),
    isKR: language === "ko",
    encarAppVersion: appVersion,
    equalAndroid: (version) => ua.os.name === "Android" && ua.os.version ? parseInt(ua.os.version, 10) === version : !1,
    lessThanAndroid: (version) => ua.os.name === "Android" && ua.os.version ? parseInt(ua.os.version, 10) < version : !1,
    greaterThanAndroid: (version) => ua.os.name === "Android" && ua.os.version ? parseInt(ua.os.version, 10) > version : !1,
    equalIE: (version) => ua.browser.name === "IE" && ua.browser.major ? parseInt(ua.browser.major, 10) === version : !1,
    lessThanIE: (version) => ua.browser.name === "IE" && ua.browser.major ? parseInt(ua.browser.major, 10) < version : !1,
    greaterThanIE: (version) => ua.browser.name === "IE" && ua.browser.major ? parseInt(ua.browser.major, 10) > version : !1,
    lessThanAppVersion: (version) => webViewName == null ? !1 : appVersion.localeCompare(version) < 0,
    greaterThanAppVersion: (version) => webViewName == null ? !1 : version.localeCompare(appVersion) < 0,
    osVersion: osVersion()
  };
}, userAgent = uaParser, encarMobileAppCheck = () => {
  var _a, webViewName, version, os, toString = function(str) {
    return str == null || str == "" ? "" : str.toString();
  };
  const ua = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
  return webViewName = ua?.toLowerCase().match(/(webview)_(android|ios|iphone)/g), os = toString(toString(webViewName).match(/android|ios|iphone/g)), version = toString(toString(ua?.match(/version(([0-9].{1,}\d+)?)/g)).match(/[0-9].{1,}\d+?$/g)), {
    isApp: webViewName != null,
    appInfo: { os, version },
    version,
    appOs: function() {
      return os == "iphone" && (os = "ios"), os;
    },
    isAndroidApp: os == "android",
    isIosApp: os == "ios",
    isMobile: /iPhone|iPod|iPad|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i.test(ua),
    isAndroidBrowser: /Android/i.test(ua),
    isIosBrowser: /iPhone|iPod|iPad/i.test(ua)
  };
}, mobileAppBridge = function() {
  var _a, _b, _c, _d, webViewName, version, os, toString = function(str) {
    return str == null || str == "" ? "" : str.toString();
  }, ua = (_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.toLowerCase(), isKitkat = ((_d = (_c = window.navigator) === null || _c === void 0 ? void 0 : _c.userAgent) === null || _d === void 0 ? void 0 : _d.search("Android 4.4.2")) > -1, webViewName = toString(ua?.match(/(webview)_(android|ios)/g)), iosJsScheme = "HybridApp:";
  webViewName != null && (os = toString(webViewName.match(/android|ios/g)));
  var v = ua?.match(/version(([0-9].{1,}\d+)?)/g);
  v != null && (version = v.toString().match(/[0-9].{1,}\d+?$/g));
  var appCheck = encarMobileAppCheck(), isEncarPartner = ua?.indexOf("encarpartner") > -1, bindAppCallback = function(callback) {
    var name = "_EncarCb" + +/* @__PURE__ */ new Date();
    return window[name] = function() {
      callback.apply(window, arguments), setTimeout(function() {
        window[name] = null;
      }, 0);
    }, name;
  }, execMobileApp = function(appScheme, host, queryString2) {
    if ((appScheme == "" || appScheme == null || appScheme == null) && (appScheme = "encarapp"), appCheck.isAndroidBrowser == !0) {
      var url = "Intent://" + host + "?" + queryString2 + "#Intent;scheme=" + appScheme + ";action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end";
      window.location = url;
    } else if (appCheck.isIosBrowser == !0) {
      var visitedAt = (/* @__PURE__ */ new Date()).getTime();
      setTimeout(function() {
        (/* @__PURE__ */ new Date()).getTime() - visitedAt < 2e3 && (location.href = "http://itunes.apple.com/kr/app/id404512755?mt=8");
      }, 500), setTimeout(function() {
        location.href = appScheme + "://goweburl?url=" + decodeURI(decodeURIComponent(queryString2));
      }, 0);
    }
  }, _isIos2_0_9_LessAppUser = function() {
    if (os == "ios") {
      var v2 = version.join("").split("."), vs = 0, base = 209;
      return vs += v2[0] * 100, vs += v2[1] * 10, vs += v2[2] * 1, base > vs;
    }
    return !1;
  }, storage = (function() {
    if (isBrowser && window.localStorage)
      try {
        return window.localStorage.setItem("_test_", "ok"), window.localStorage;
      } catch {
      }
    return null;
  })(), storageName = "RecentSearchNavigation#data";
  function getRecentItem() {
    try {
      return storage ? JSON.parse(storage.getItem(storageName) || "[]") : [];
    } catch {
      return [];
    }
  }
  function removeByKey(array, id) {
    return array.some(function(item, index) {
      if (console.log(item.id), array[index].id == id)
        return array.splice(index, 1);
    }), array;
  }
  return {
    /**
     * 플리킹 메뉴 열기
     */
    openFlickingMenu: function(asideActiveTab) {
      var prevAndVersion = 2.2, prevIOSVersion = 1.3, presentVersion = parseFloat(version);
      const activeTab = asideActiveTab === "sell" ? "carSell" : "";
      if (os == "android") {
        const isActiveTab = userAgent().greaterThanAppVersion("6.4.7") && asideActiveTab === "sell";
        return prevAndVersion >= presentVersion ? !0 : (isActiveTab ? window.HybridApp.flickingMenuOpen(activeTab) : window.HybridApp.flickingMenuOpen(), !1);
      } else
        return isNaN(presentVersion) || prevIOSVersion >= presentVersion ? !0 : (window.location = `${iosJsScheme}openFlickingMenu:${activeTab}`, !1);
    },
    /**
     * 플리킹 메뉴 닫기
     */
    closeFlickingMenu: function() {
      os == "android" ? window.HybridApp.flickingMenuClose() : window.location = iosJsScheme + "flickingMenuClose:파라메터1|파라메터2";
    },
    setMessage: function(num, rgsid, photonum) {
      os == "android" ? window.HybridApp.setMessage(num, rgsid, photonum) : window.location = iosJsScheme + "flickingMenuClose:" + num + "|" + rgsid + "|" + photonum;
    },
    /**
     * WEB 에서 로그아웃 될때 앱에서도 로그아웃 처리될수있도록
     * 함수를 호출한다.
     */
    logout: function() {
      var _a2, _b2, _c2, _d2, _e, _f;
      try {
        if (isEncarPartner) {
          os == "android" && ((_b2 = (_a2 = window.Noah) === null || _a2 === void 0 ? void 0 : _a2.logout) === null || _b2 === void 0 || _b2.call(_a2)), os == "ios" && ((_f = (_e = (_d2 = (_c2 = window.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.logout) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, ""));
          return;
        }
        os == "android" ? (window.HybridApp.logout(), window.location.href = `${ENCAR_MOBILE}/co/login.do?method=logout`) : os == "ios" ? window.location = iosJsScheme + "logout" : window.location.href = `${ENCAR_MOBILE}/co/login.do?method=logout`;
      } catch (e) {
        alert(e);
      }
    },
    /**
     * 로그아웃 후 로그인 창이 열리는 브릿지
     * 로그인 후에는 전달된 파라미터에 따라 프로세스가 이어진다.
     */
    logoutAftreLogin: function(jsonParam) {
      var _a2, _b2, _c2, _d2, _e, _f, _g, _h, _j;
      try {
        if (isEncarPartner) {
          os == "android" && ((_b2 = (_a2 = window.Noah) === null || _a2 === void 0 ? void 0 : _a2.logout) === null || _b2 === void 0 || _b2.call(_a2)), os == "ios" && ((_f = (_e = (_d2 = (_c2 = window.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.logout) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, ""));
          return;
        }
        if (os === "android") {
          userAgent().lessThanAppVersion("6.5.6") ? (window.HybridApp.logout(), setTimeout(() => {
            var _a3;
            (_a3 = window?.location) === null || _a3 === void 0 || _a3.reload();
          }, 500)) : window.HybridApp.showLoginPage(JSON.stringify(jsonParam));
          return;
        }
        return os === "ios" && (userAgent().lessThanAppVersion("5.5.1") ? (window.location = iosJsScheme + "logout", setTimeout(() => {
          var _a3;
          (_a3 = window?.location) === null || _a3 === void 0 || _a3.reload();
        }, 500)) : (_j = (_h = (_g = window.webkit) === null || _g === void 0 ? void 0 : _g.messageHandlers) === null || _h === void 0 ? void 0 : _h.showLoginPage) === null || _j === void 0 || _j.postMessage(JSON.stringify(jsonParam))), !0;
      } catch {
        return !1;
      }
    },
    /**
     * 로그인 화면 호출
     * 앱의 로그인 화면을 호출하기위한 함수 로그인후 보내고싶은 페이지의 url 을 인자로 넘기면 해당 url로 이동한다.
     * @parameter backUrl 로그인완료후 호출되어야하는 url 정보
     * @parameter closeUrl 헤더 닫기버튼 클릭시 호출되어야하는 url
     */
    login: function(backUrl = "", iphoneAuthCheck, closeUrl = "") {
      var _a2, _b2, _c2, _d2, _e, _f;
      try {
        if (backUrl == null && (backUrl = ""), isEncarPartner) {
          os == "android" && ((_b2 = (_a2 = window.Noah) === null || _a2 === void 0 ? void 0 : _a2.login) === null || _b2 === void 0 || _b2.call(_a2)), os == "ios" && ((_f = (_e = (_d2 = (_c2 = window.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.login) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, backUrl));
          return;
        }
        if (os == "android")
          userAgent().lessThanAppVersion("5.9.4") ? window.HybridApp.login(backUrl) : window.HybridApp.login(backUrl, closeUrl);
        else if (os == "ios") {
          const encodeBackUrl = backUrl ? `:${encodeURIComponent(backUrl)}:encoded` : "", encodeCloseUrl = closeUrl ? `:${encodeURIComponent(closeUrl)}` : "";
          userAgent().lessThanAppVersion("4.9.4") ? window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}` : window.location = `${iosJsScheme}login:${iphoneAuthCheck}${encodeBackUrl}${encodeCloseUrl}`;
        }
        return !0;
      } catch {
        return !1;
      }
    },
    // 로그인시 파라미터를 json형태로 전달하기 위한 함수: login 함수 대체
    loginWithParam: function(jsonParam, iphoneAuthCheck, skipAble) {
      var _a2, _b2, _c2, _d2, _e, _f, _g, _h, _j, _k, _l, _m;
      try {
        if (isEncarPartner) {
          os == "android" && ((_b2 = (_a2 = window.Noah) === null || _a2 === void 0 ? void 0 : _a2.login) === null || _b2 === void 0 || _b2.call(_a2)), os == "ios" && ((_f = (_e = (_d2 = (_c2 = window.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.login) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, jsonParam?.backUrl || ""));
          return;
        }
        if (os === "android" && (userAgent().lessThanAppVersion("6.4.7") ? window.HybridApp.login(jsonParam?.backUrl, jsonParam?.closeUrl) : window.HybridApp.loginWithParam(JSON.stringify(jsonParam))), os === "ios") {
          if (!((_j = (_h = (_g = window.webkit) === null || _g === void 0 ? void 0 : _g.messageHandlers) === null || _h === void 0 ? void 0 : _h.loginWithParam) === null || _j === void 0) && _j.postMessage)
            return (_m = (_l = (_k = window.webkit) === null || _k === void 0 ? void 0 : _k.messageHandlers) === null || _l === void 0 ? void 0 : _l.loginWithParam) === null || _m === void 0 || _m.postMessage(JSON.stringify(jsonParam)), !0;
          const encodeBackUrl = jsonParam?.backUrl ? `${encodeURIComponent(jsonParam?.backUrl)}:encoded` : ":", encodecloseUrl = jsonParam?.closeUrl ? encodeURIComponent(jsonParam?.closeUrl) : "", encodeService = jsonParam?.service ? encodeURIComponent(jsonParam?.service) : "";
          window.location = `${iosJsScheme}login:${iphoneAuthCheck}:${encodeBackUrl}:${encodecloseUrl}:${encodeService}`;
        }
        return !0;
      } catch {
        return !1;
      }
    },
    /**
     * 특정 외부 앱을 실행 시키기위한 함수
     * @parameter packageNm 실행시키기외한 앱 패키지명 ex) 진단팩 앱 실행 : mobileAppBridge.excuteApp('com.encar.inspectPack')
     */
    excuteApp: function(packageNm) {
      os == "android" ? window.HybridApp.excuteApp(packageNm) : window.location = iosJsScheme + "excuteApp" + (packageNm == "" ? "" : ":") + packageNm;
    },
    getEncarAppVersion: function() {
      return version == null ? "" : version.toString();
    },
    isAndroidKitkat: function() {
      return isKitkat ?? !1;
    },
    androidInputFileCheck: function() {
      var _a2, result = !1;
      if (os == "android") {
        var kitkatVersion = 4.4, deviceAgent = (_a2 = window.navigator) === null || _a2 === void 0 ? void 0 : _a2.userAgent, deviceMatchResult = deviceAgent?.match(/Android\s+([\d\.]+)/), andOsVesion = deviceMatchResult ? deviceMatchResult[1] : `${kitkatVersion}`, floatOsVersion = parseFloat(andOsVesion);
        floatOsVersion >= kitkatVersion ? result = !0 : result = !1;
      }
      return result;
    },
    /**
     * 네이버 라인으로 공유하기 기능
     * @parameter lineText 라인으로 공유하기위한 텍스트정보
     */
    goNaverLine: function(lineText) {
      os == "android" ? window.HybridApp.goNaverLine(lineText) : window.location = iosJsScheme + "goNaverLine:" + lineText;
    },
    /**
     * 네이버 밴드로 공유하기 기능
     * @parameter lineText 공유하기위한 텍스트정보
     */
    goNaverBand: function(bandText) {
      os == "android" ? window.HybridApp.goNaverBand(bandText) : window.location = iosJsScheme + "goNaverBand:" + bandText;
    },
    /**
     * 앱 이용중 팝업 윈도우기능 띄우기위한 기능
     * @parameter url 팝업 윈도우에서 이동하게될 url 정보
     */
    goNewWindow: function(url) {
      if (os == "android")
        window.HybridApp.goNewWindow(url);
      else if (os == "ios")
        window.location = iosJsScheme + "goNewWindow:" + url;
      else
        return window.open(url);
    },
    goExternalPage: function(url) {
      var _a2;
      if (os == "android")
        window.HybridApp.goNewWindow(url);
      else if (os == "ios")
        (_a2 = window.webkit) === null || _a2 === void 0 || _a2.messageHandlers.openExternalBrowser.postMessage(JSON.stringify({ url }));
      else
        return window.open(url);
    },
    goADNewWindow: function(url, target) {
      if (url) {
        target || (target = "_blank");
        try {
          os == "android" ? window.HybridApp.goADNewWindow(url) : os == "ios" ? window.location = iosJsScheme + "goADNewWindow:" + url + ":" + target : window.open(url, target);
        } catch {
          window.open(url, target);
        }
      }
    },
    /**
     * 앱 이용중 마이페이지 차량사진 등록,수정 화면 호출
     * @parameter rgsid 차량 관리키
     * @parameter dirArr 이미지 확장자포함 저장 경로
     */
    modcarimg: function(rgsid, dirArr) {
      rgsid = rgsid ?? "", dirArr = dirArr ?? "", os == "android" ? window.HybridApp.modcarimg(rgsid, dirArr) : window.location = iosJsScheme + "modcarimg:" + rgsid + ":" + dirArr;
    },
    /**
     * 앱 이용중 마이페이지 차량사진 등록,수정 화면 호출
     * @parameter rgsid 차량 관리키
     */
    regcarimg: function(rgsid) {
      rgsid = rgsid ?? "", os == "android" ? window.HybridApp.regcarimg(rgsid, "") : window.location = iosJsScheme + "regcarimg:" + rgsid;
    },
    /**
     * 앱 이용중 프로그레스 다이얼로그를 띄우기위한 기능
     */
    setProgressDialogStyle: function() {
      os == "android" ? window.HybridApp.setProgressDialogStyle() : window.location = iosJsScheme + "setProgressDialogStyle";
    },
    /**
     * 네이티브 앱에서 차량 이미지 업로드된 정보를 얻어온다.
     *
     */
    getUploadImageData: function() {
      os == "android" ? window.HybridApp.getUploadImageData() : window.location = iosJsScheme + "getUploadImageData";
    },
    /**
     * 이미지 업로드완료후 리사이징, 썸네일 생성완료시 토스트메세지를 보여주기위한 함수
     *
     */
    showAppToast: function(comment) {
      comment = comment ?? "", os == "android" ? window.HybridApp.showAppToast(comment) : window.location = iosJsScheme + "showAppToast:" + window.Base64.encode(comment);
    },
    execEncarApp: function(exeUrl, downloadurl) {
      var appScheme = "encarapp", host = "move";
      if (appCheck.isAndroidBrowser == !0) {
        var url = "Intent://" + host + "?" + exeUrl + "#Intent;scheme=" + appScheme + ";action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end";
        window.location.href = url, setTimeout(function() {
          (/* @__PURE__ */ new Date()).getTime() - window.b < 1500 && (window.location.href = downloadurl);
        }, 500);
      } else if (appCheck.isIosBrowser == !0) {
        var visitedAt = (/* @__PURE__ */ new Date()).getTime();
        setTimeout(function() {
          (/* @__PURE__ */ new Date()).getTime() - visitedAt < 2e3 && (location.href = downloadurl);
        }, 500), setTimeout(function() {
          location.href = appScheme + "://goweburl?url=" + decodeURI(decodeURIComponent(exeUrl));
        }, 0);
      }
    },
    goEncarApp: function(exeUrl, returnURL) {
      var appScheme = "encarapp";
      if (appCheck.isAndroidBrowser == !0) {
        const url = `${appScheme}://${exeUrl}`;
        window.location.href = url;
      } else appCheck.isIosBrowser == !0 && (window.location.href = `${appScheme}://goweburl?url=${exeUrl}`);
      setTimeout(function() {
        document.visibilityState !== "hidden" && window.location.replace(returnURL);
      }, 500);
    },
    callBackSuccess: function(data) {
      data.iResult == "0" && (document.form_ipin.enc_data.value = data.enc_data, document.form_ipin.action = "https://cert.vno.co.kr/ipin.cb", document.form_ipin.submit());
    },
    iPin_Submit: function(type) {
      window.$("checkType").value = "checkIpin", window.MUserIpinDWR.checkIpin(window.$("pageid").value, "", "", type, this.callBackSuccess);
    },
    checkplusCheck: function() {
      window.jQuery("checkType").value = "checkName", window.name = "Parent_window", document.ck_checkName.action = "https://check.namecheck.co.kr/mobile2/checkplus.cb", document.ck_checkName.submit();
    },
    regCar: function() {
      var scheme = "encarapp", host = "move", url = `${ENCAR_MOBILE}/rs/regself_v.do`;
      if (appCheck.isApp == !0) {
        if (window.regCarVersionCheck() == !1)
          return;
        if (window.getIsNotHashkey() == !0)
          return window.mLayerFc(".layer_cetify"), !1;
        window.location.href = url;
      } else {
        if (appCheck.isAndroidBrowser == !0)
          host = "rs_sell", url = "key=" + url;
        else if (appCheck.isIosBrowser != !0) {
          alert("셀프등록은 안드로이드/iOS 모바일 앱에서 이용하실 수 있습니다."), window.location.href = "https://m.encar.com/dw/dw_app_down.do";
          return;
        }
        execMobileApp(scheme, host, url);
      }
    },
    /**
     * 기본적으로 앱에서만 서비되는 메뉴의경우 사용함수
     * 현재 앱사용중 여부 및 앱 설치여부를 체크해서 동작한다.
     */
    goUrlApp: function(appScheme, url) {
      if (appCheck.isApp == !0) {
        url != null && url != "" && (window.location.href = url);
        return;
      }
      if (appCheck.isAndroidBrowser == !0 || appCheck.isIosBrowser == !0)
        execMobileApp(appScheme, "move", url);
      else {
        alert("안드로이드, 아이폰 기기에서 이용 가능합니다.");
        return;
      }
    },
    /**
     * 최근 검색조건 데이터 전송
     */
    searchOptionData: function(searchOptionDataList, callback) {
      if (os in { android: 1, ios: 1 }) {
        var checkVersion = 2.6, presentVersion = parseFloat(version);
        os == "android" ? checkVersion = 2.6 : checkVersion = 2.2;
        var optionData = JSON.stringify(searchOptionDataList.slice(0, 3));
        if (checkVersion <= presentVersion && (optionData = JSON.stringify(searchOptionDataList)), os == "android") {
          var prevVersion = 2.3, presentVersion = parseFloat(version);
          if (prevVersion <= presentVersion)
            try {
              window.HybridApp.searchOptionData(optionData, bindAppCallback(callback));
              return;
            } catch (e) {
              console.error(e);
            }
        } else {
          var callbackName = bindAppCallback(callback);
          setTimeout(function() {
            typeof window[callbackName] == "function" && window[callbackName]();
          }, 1500);
          try {
            window.location = iosJsScheme + "searchOptionData:" + callbackName + ":" + window.Base64.encode(_isIos2_0_9_LessAppUser() ? "[]" : optionData);
          } catch (err) {
            alert("ERROR :" + err.message);
          }
          return;
        }
        setTimeout(function() {
          callback();
        }, 500);
      } else
        callback();
    },
    /**
     * 광고 관련
     */
    ad: {
      /**
       * 광고 캡션명 가져오기 (매번 바뀌지 않기 때문에 처음 한번만 가져오면 됨)
       * ex) mobileAppBridge.ad.name('menu_insu')
       */
      name: function(type) {
        return window.AdBanner ? window.AdBanner.name(type) : "";
      },
      /**
       * 광고 클릭시 동작 (click event에 호출만 하면 됨)
       * ex) mobileAppBridge.ad.link('menu_insu')
       */
      link: function(type, link) {
        if (window.AdBanner)
          return window.AdBanner.link(type, link);
      },
      /**
       * 메뉴 확장시 호출(노출수 증가를 위함)
       * ex) mobileAppBridge.ad.refresh()
       */
      refresh: function() {
        if (window.AdBanner)
          return window.AdBanner.refresh();
      }
    },
    /**
     * @function 아이폰앱이면서 2.0.9 이하 버전 사용자인지 여부 반환한다.
     * 		아이폰 앱 등록 Reject으로 인하여 기존 앱 사용자들의 최근검색조건을 날려야 한다. v2.0.9 이하일때만
     * */
    isIos2_0_9_LessAppUser: _isIos2_0_9_LessAppUser,
    appImgUpload: function(rgsid, url) {
      os == "android" && window.HybridApp.imgFileKikatUpload(rgsid, url);
    },
    /**
     * 차량 사진 업로드를 위한 Function
     * @param carid
     * @param funcOld
     * @returns {boolean}
     */
    appCaridPhotoUpload: function(carid, funcOld) {
      var appVersion = this.getEncarAppVersion();
      appVersion = parseInt(appVersion.replace(/\./gi, ""), 10);
      var checkVersion;
      if (os == "android" ? checkVersion = "4.1.6" : checkVersion = "3.0.9", checkVersion = parseInt(checkVersion.replace(/\./gi, "")), appVersion < checkVersion)
        funcOld();
      else
        return os == "android" ? window.HybridApp.photoUploadByCarid(carid) : window.location = iosJsScheme + "photoUploadByCarid:" + carid, !1;
    },
    setTopBarContent: function(title, image) {
      if (/alltire/.test(ua))
        return title = encodeURIComponent(title), image = encodeURIComponent(image), os == "android" ? (window.HybridApp.setTopBarContent("TITLE", title, image), !1) : (window.location = iosJsScheme + "setTopBarContent:" + title + ":" + image, !1);
    },
    deviceDataUpdate: function(phonenum, referrer) {
      var prevIOSVersion = 1.3, presentVersion = parseFloat(version);
      if (os == "android") {
        var appVersion = (version + "").replace(/\./gi, ""), checkVersion = "4.4.6".replace(/\./gi, "");
        appVersion < checkVersion ? window.HybridApp.deviceDataUpdate(phonenum) : window.HybridApp.deviceDataUpdate(phonenum, referrer);
      } else
        return isNaN(presentVersion) || prevIOSVersion >= presentVersion ? !0 : (window.location = iosJsScheme + "deviceDataUpdate:" + phonenum + ":" + referrer, !1);
    },
    getPhoneNumber: function(phonenum) {
      var prevIOSVersion = 1.3, presentVersion = parseFloat(version);
      if (os == "android")
        window.HybridApp.getPhoneNum(phonenum);
      else
        return isNaN(presentVersion) || prevIOSVersion >= presentVersion ? !0 : (window.location = iosJsScheme + "getPhoneNum:" + phonenum, !1);
    },
    getAppCarInfo: function(rgsid, userid, sellernum, appWtHit) {
      let wtHitCase;
      switch (appWtHit) {
        case "ca_car":
          wtHitCase = "0";
          break;
        case "ca_car_pop":
          wtHitCase = "1";
          break;
        default:
          wtHitCase = appWtHit;
      }
      const prevAndVersion = "5.5.4".replace(/\./gi, ""), presentVersion = (version + "").replace(/\./gi, "");
      os === "android" ? prevAndVersion > presentVersion ? window.HybridApp.getAppCarInfo(rgsid, userid, sellernum) : window.HybridApp.getAppCarInfo(rgsid, userid, sellernum, wtHitCase) : os === "ios" && (window.location = `${iosJsScheme}getAppCarInfo:${rgsid}:${userid}:${sellernum}:${wtHitCase}`);
    },
    openChatRoom: function(rgsid, chatid) {
      var appVersion = version + "";
      if (appVersion = appVersion.replace(/\./gi, ""), os == "android") {
        var checkVersion = "2.4.5".replace(/\./gi, "");
        if (appVersion < checkVersion)
          if (confirm(`앱 업데이트 후 확인하실 수 있습니다.
업데이트하시겠습니까?`))
            location.href = "market://details?id=com.encar.encarMobileApp";
          else
            return !0;
        else
          window.HybridApp.openChatRoom(rgsid, chatid);
      } else {
        var checkVersion = "2.1.4".replace(/\./gi, "");
        return appVersion < checkVersion ? (alert("앱 업데이트 후 사용 가능합니다."), !0) : (window.location = iosJsScheme + "openChatRoom:" + rgsid + ":" + chatid, !1);
      }
    },
    inquiryDateList: function() {
      os == "android" ? window.HybridApp.goInquiryList() : window.location.href = `${ENCAR_MOBILE}/my/my_index.do?method=buyInquiryDateList`;
    },
    getAppUuid: function() {
      os == "android" ? window.HybridApp.getAppUuid() : window.location = iosJsScheme + "getAppUuid";
    },
    beforeOpenAlert: function() {
      var checkVersion = "2.1.4".replace(/\./gi, ""), appVersion = version + "";
      return appVersion = appVersion.replace(/\./gi, ""), os == "ios" && appVersion < checkVersion ? (alert("앱 업데이트 후 사용 가능합니다."), !0) : (window.location.href = `${ENCAR_MOBILE}/ca/cardetail.do?method=authDirect`, !1);
    },
    goParamRun: function(r_param, r_redirect) {
      r_param = decodeURIComponent(r_param), r_redirect = decodeURIComponent(r_redirect), window.jQuery.getScript("/js/encarapp/lib/require.js", function() {
        window.requirejs.config({
          baseUrl: "/js/encarapp",
          paths: {
            ko: "lib/knockout-3.3.0",
            "ko-switch": "lib/knockout/switch-case/knockout-switch-case.min",
            "jquery-broker": "helper/jquery-broker",
            "ko-broker": "helper/ko-broker"
          },
          map: {
            "*": {
              jquery: "jquery-broker",
              ko: "ko-broker"
            },
            "jquery-broker": {
              jquery: "jquery"
            },
            "ko-broker": {
              ko: "ko"
            },
            "ko-switch": {
              knockout: "ko"
            }
          }
        }), window.requirejs(["/js/encarapp/module/recent/recent.all.js"], function(RP) {
          var param = JSON.parse(r_param);
          param.title = decodeURIComponent(param.title), new RP.SearchNavigation().addAndAppSync(param, function() {
            location.href = r_redirect;
          });
        });
      });
    },
    recentSearchRemoveItem: function(id) {
      var itemList = getRecentItem();
      removeByKey(itemList, id), storage && storage.setItem(storageName, JSON.stringify(itemList)), itemList = getRecentItem(), this.searchOptionData(itemList, function() {
      });
    },
    carSearchChangeSort: function(sortType, flag) {
      var appVersion = version + "";
      appVersion = appVersion.replace(/\./gi, "");
      try {
        if (os == "android") {
          var checkVersion = "2.4.5".replace(/\./gi, "");
          if (appVersion < checkVersion)
            if (confirm(`앱 업데이트 후 확인하실 수 있습니다.
업데이트하시겠습니까?`))
              location.href = "market://details?id=com.encar.encarMobileApp";
            else
              return !0;
          else
            window.HybridApp.carSearchChangeSort(sortType, flag);
        } else {
          var checkVersion = "2.1.4".replace(/\./gi, "");
          return appVersion < checkVersion ? (alert(`앱 업데이트 후 확인하실 수 있습니다.
업데이트하시겠습니까?`), !0) : !1;
        }
      } catch {
      }
    },
    setVisibleIndexEventLayer: function(layerType) {
      var appVersion = version + "";
      appVersion = appVersion.replace(/\./gi, "");
      try {
        if (os == "android") {
          var checkVersion = "2.4.5".replace(/\./gi, "");
          if (appVersion < checkVersion)
            if (confirm(`앱 업데이트 후 확인하실 수 있습니다.
업데이트하시겠습니까?`))
              location.href = "market://details?id=com.encar.encarMobileApp";
            else
              return !0;
          else
            window.HybridApp.setVisibleIndexEventLayer(layerType);
        } else {
          var checkVersion = "2.1.4".replace(/\./gi, "");
          return appVersion < checkVersion ? (alert(`앱 업데이트 후 확인하실 수 있습니다.
업데이트하시겠습니까?`), !0) : (window.location = iosJsScheme + "setVisibleIndexEventLayer:" + layerType, !1);
        }
      } catch {
      }
    },
    getEncarpayLimitCheck: function({ carId, clientName, carMaximumLimit, creditMaximumLimit, expiredAt, interestRate }) {
      if (os === "android") {
        if (window.HybridApp.getEncarpayLimitCheck === void 0)
          return;
        window.HybridApp.getEncarpayLimitCheck(carId, clientName, carMaximumLimit, creditMaximumLimit, expiredAt, interestRate);
      } else os === "ios" && (window.location = `${iosJsScheme}getEncarpayLimitCheck:${carId}:${clientName}:${carMaximumLimit}:${creditMaximumLimit}:${expiredAt}:${interestRate}`);
    },
    /**
     * 앱 탭바 hide 처리
     */
    hideTabBar: function() {
      try {
        os == "android" ? window.HybridApp.hideTabBar() : os == "ios" && (window.location = iosJsScheme + "hideTabBar");
      } catch {
      }
    },
    /**
      * 앱 탭바 show 처리
      */
    showTabBar: function() {
      try {
        os == "android" ? window.HybridApp.showTabBar() : os == "ios" && (window.location = iosJsScheme + "showTabBar");
      } catch {
      }
    },
    /**
     * iOS 뒤로가기 hide 처리
     */
    hideBackButton: function() {
      try {
        os == "ios" && (window.location = iosJsScheme + "hideBackButton");
      } catch {
      }
    },
    /**
     * iOS 뒤로가기 show 처리
     */
    showBackButton: function() {
      try {
        os == "ios" && (window.location = iosJsScheme + "showBackButton");
      } catch {
      }
    },
    /**
     * 당겨서 새로고침 enabled/disabled 설정
     */
    setEnabledPullToRefresh: function(enabled) {
      try {
        os == "android" ? window.HybridApp.pullToRefresh && window.HybridApp.pullToRefresh(enabled) : os == "ios" && (window.location = iosJsScheme + "pullToRefresh:" + enabled);
      } catch {
      }
    },
    goNativeWindow: function(url, method, param, isReload) {
      try {
        os == "android" ? window.HybridApp.goNativeWindow(url, method, param, isReload) : os == "ios" && (window.location = iosJsScheme + "goNativeWindow:" + url + ":" + method + ":" + param + ":" + isReload);
      } catch {
      }
    },
    /**
     * 마이페이지 최근검색
     */
    recentSearch: function() {
      var appVersion = version + "";
      appVersion = appVersion.replace(/\./gi, "");
      try {
        os == "android" && appVersion >= "4.3.6".replace(/\./gi, "") ? window.HybridApp.recentSearch() : os == "ios" && appVersion >= "3.2.5".replace(/\./gi, "") ? window.location = iosJsScheme + "recentSearch" : window.location = "/my/my_index.do?method=viewRecentsearch";
      } catch {
      }
    },
    /**
     * 웹뷰 닫기
     */
    destroyWebView: function() {
      var _a2, _b2, _c2, _d2, _e, _f;
      try {
        if (isEncarPartner) {
          os == "android" && ((_b2 = (_a2 = window.Noah) === null || _a2 === void 0 ? void 0 : _a2.destroyWebView) === null || _b2 === void 0 || _b2.call(_a2)), os == "ios" && ((_f = (_e = (_d2 = (_c2 = window.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.destroyWebView) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, ""));
          return;
        }
        if (os == "android")
          window.HybridApp.destroyWebView();
        else if (os == "ios") {
          window.location = iosJsScheme + "destroyWebView";
          return;
        } else
          window.close();
      } catch {
      }
    },
    /**
     * 새창 닫기
     */
    destroyNativeWindow: function(param) {
      try {
        os == "android" ? window.HybridApp.destroyNativeWindow(param) : window.close();
      } catch {
      }
    },
    /**
     * 중고차론 대출 개월 수, 선납금 전달
     */
    setLoanIndexInfo: function(info) {
      try {
        os == "android" ? window.HybridApp.setLoanIndexInfo(info) : os == "ios" && (window.location = iosJsScheme + "setLoanIndexInfo:" + btoa(info));
      } catch {
      }
    },
    /**
     * 웹에서 로그인 후에 앱에 알리기 위한 호출
     */
    loginComplete: function(platform, token2, toUrl) {
      try {
        if (os == "android")
          window.HybridApp.loginComplete(JSON.stringify({ platform, token: token2, returnUrl: toUrl }));
        else if (os == "ios") {
          if (userAgent().lessThanAppVersion("4.1.0"))
            return !1;
          window.location = iosJsScheme + "loginComplete:" + platform + ":" + token2 + ":" + encodeURIComponent(toUrl);
        }
        return !0;
      } catch {
        return !1;
      }
    },
    /**
     * 로그인 완료 후 앱에 알리기 위한 호출
     * @param platform 플랫폼(ENCAR, KAKAO, NAVER, GOOGLE, APPLE)
     * @param token ACCESS TOKEN
     * @returns boolean
     */
    completeLogin: function(platform, token2) {
      let appVersion = version + "";
      appVersion = appVersion.replace(/\./gi, "");
      try {
        if (os == "android") {
          let checkVersion = "7.4.5".replace(/\./gi, "");
          return appVersion < checkVersion ? !1 : (window.HybridApp.completeLogin(JSON.stringify({ platform, token: token2 })), !0);
        } else if (os == "ios") {
          let checkVersion = "6.4.9".replace(/\./gi, "");
          return appVersion < checkVersion ? !1 : (window.webkit.messageHandlers.completeLogin.postMessage(JSON.stringify({ platform, token: token2 })), !0);
        }
        return !1;
      } catch {
        return !1;
      }
    },
    /**
     * 로그인 완료 후 리다이렉트 URL로 이동하기 위한 호출
     * @param returnUrl 리다이렉트 할 URL
     * @returns boolean
     */
    completeLoginToReturnURL: function(returnUrl) {
      let appVersion = version + "";
      appVersion = appVersion.replace(/\./gi, "");
      try {
        if (os == "android") {
          let checkVersion = "7.4.5".replace(/\./gi, "");
          return appVersion < checkVersion ? !1 : (window.HybridApp.completeLoginToReturnURL(JSON.stringify({ returnUrl })), !0);
        } else if (os == "ios") {
          let checkVersion = "6.4.9".replace(/\./gi, "");
          return appVersion < checkVersion ? !1 : (window.webkit.messageHandlers.completeLoginToReturnURL.postMessage(JSON.stringify({ returnUrl })), !0);
        }
        return !1;
      } catch {
        return !1;
      }
    },
    /**
     * 기존 회원 신규 마케팅 동의 유도
     */
    goMarketingAgreePopup: function() {
      os == "android" ? window.HybridApp.goMarketingAgreePopup() : window.location = iosJsScheme + "goMarketingAgreePopup";
    },
    /**
     * 안드로이드 앱에서 callback url 이용시 호출하기 위한 함수
     */
    appleLoginComplete: function(token2) {
      try {
        return os == "android" ? window.HybridApp.appleLoginComplete(token2) : !0;
      } catch {
        return !1;
      }
    },
    /**
     * 구글인증 화면 호출
     */
    verifyGoogle: function() {
      try {
        if (os == "android")
          window.HybridApp.verifyGoogle();
        else if (os == "ios") {
          if (userAgent().lessThanAppVersion("4.1.0"))
            return !1;
          window.location = iosJsScheme + "verifyGoogle";
        }
        return !0;
      } catch {
        return !1;
      }
    },
    /**
     * 애플인증 화면 호출
     */
    verifyApple: function() {
      try {
        return os == "android" ? window.HybridApp.verifyApple() : os == "ios" && (window.location = iosJsScheme + "verifyApple"), !0;
      } catch {
        return !1;
      }
    },
    /**
     * 사용자 정보 갱신
     */
    refreshUserInfo: function(successUrl) {
      try {
        if (os == "android")
          window.HybridApp.refreshUserInfo(successUrl);
        else if (os == "ios") {
          if (userAgent().lessThanAppVersion("4.1.0"))
            return !1;
          window.location = iosJsScheme + "refreshUserInfo:" + encodeURIComponent(successUrl);
        }
        return !0;
      } catch {
        return !1;
      }
    },
    /**
     * 안드로이드 OTP 문자 발송시 호출함수
     */
    openSmsRetriever: function() {
      try {
        os == "android" && window.HybridApp.openSmsRetriever();
      } catch {
      }
    },
    /**
     * AppsFlyer
     */
    sendAppsflyerEvent(eventName) {
      try {
        os === "android" ? window.HybridApp.sendAppsflyerEvent(eventName) : os === "ios" && window.webkit.messageHandlers.event.postMessage(eventName);
      } catch {
        return !1;
      }
    },
    /**
     * 당신의 다음차 에상 대출 견적 화면 전환
     */
    goLoanEstimate: function() {
      try {
        os == "android" ? window.HybridApp.goLoanEstimate() : os == "ios" && (window.location = iosJsScheme + "goLoanEstimate");
      } catch {
        return !1;
      }
    },
    /**
     * 최상단 스크롤 버튼 노출/비노출
     */
    setVisibleTopBtn: function(visible) {
      try {
        os == "android" && window.HybridApp.setVisibleTopBtn(visible);
      } catch {
        return !1;
      }
    },
    /**
     * 앱실행
     */
    appLauncher: function(appUrl) {
      if (appCheck.isAndroidBrowser == !0) {
        var url = "Intent://" + appUrl + "#Intent;scheme=encarapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.encar.encarMobileApp;end";
        window.location.replace(url);
        return;
      }
      if (appCheck.isIosBrowser == !0) {
        location.href = "encarapp://" + appUrl, setTimeout(function() {
          window.location.replace("http://itunes.apple.com/kr/app/id404512755?mt=8");
        }, 1e3);
        return;
      }
    },
    /**
     * 앱다운로드
     */
    appDownload: function(appUrl) {
      if (appCheck.isAndroidBrowser == !0) {
        window.location.replace("https://play.google.com/store/apps/details?id=com.encar.encarMobileApp");
        return;
      }
      if (appCheck.isIosBrowser == !0) {
        window.location.replace("http://itunes.apple.com/kr/app/id404512755?mt=8");
        return;
      }
    },
    isGoogleRelease: function() {
      try {
        if (os == "android")
          return window.HybridApp.isGoogleRelease();
      } catch {
      }
    },
    /**
     * 모바일 팀에서 결제 목록 구성을 위한 용도,호출만 하면 됨
     * @param {*} paymentType {carType,categoryType}
     * carType : 'CAR_IMPORT' : 'CAR_DOMESTIC'
     * categoryType : 현재 SELF만 사용, 다른 상품일때는 BE에 카테고리 타입문의해야
     */
    readyGoogleInappBilling: function(paymentType) {
      try {
        os == "android" && window.HybridApp.readyGoogleInappBilling(paymentType);
      } catch {
      }
    },
    /**
     * 모바일진단앱에서 차량검수완료후 웹예약리스트 갱신
     */
    setSavedNativeCarInfo: function() {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.setSavedNativeCarInfo) !== void 0 && window.DiagnosisApp.setSavedNativeCarInfo();
    },
    /**
     * 차량검수 웹뷰 — 이미지(들)를 네이티브 갤러리에 저장 (반환값 없음, 결과는 앱 토스트)
     * 배열이면 JSON 문자열로, 단일 문자열이면 그대로 전달(네이티브가 두 형식 모두 허용)
     * @param (string | string[]) imageUrls 저장할 이미지 URL(들)
     */
    downloadImages: function(imageUrls) {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.downloadImages) !== void 0 && window.DiagnosisApp.downloadImages(Array.isArray(imageUrls) ? JSON.stringify(imageUrls) : imageUrls);
    },
    /**
     * 차량검수 웹뷰 — 이미지 crop(16:9) 후 업로드, 결과 URL 을 전역 콜백(JSON 문자열)으로 반환
     * @param (string) imageUrl crop 대상 이미지 URL
     * @param (string) callbackName 결과를 받을 전역 JS 함수명
     */
    cropAndUploadImage: function(imageUrl, callbackName) {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.cropAndUploadImage) !== void 0 && window.DiagnosisApp.cropAndUploadImage(imageUrl, callbackName);
    },
    /**
     * 차량검수 웹뷰 — 검수 메모 입력 네이티브 화면 오픈 (플로팅 메모 버튼)
     */
    openVerificationMemo: function() {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.openVerificationMemo) !== void 0 && window.DiagnosisApp.openVerificationMemo();
    },
    /**
     * 차량검수 웹뷰 — 현재 탭을 넘겨 네이티브 카메라 오픈 (플로팅 카메라 버튼)
     * @param (string) category 현재 검수 탭 (BASIC | DETAIL | NOTICE)
     */
    openVerificationCamera: function(category) {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.openVerificationCamera) !== void 0 && window.DiagnosisApp.openVerificationCamera(category);
    },
    /**
     * 차량검수 웹뷰 — 이미지 피커 최대 선택 장수 설정 (선택한 카테고리의 제한 장수)
     * @param (number) count 선택 가능한 최대 장수
     */
    setImagePickerMaxCount: function(count) {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.setImagePickerMaxCount) !== void 0 && window.DiagnosisApp.setImagePickerMaxCount(count);
    },
    /**
     * 차량검수 웹뷰 — 검수 웹뷰 닫기 (앱버전↔데이터 version 불일치 안내 확인 시). 엔카앱 destroyWebView 와 별개(진단앱 전용).
     */
    destroyVerificationWebView: function() {
      var _a2;
      ((_a2 = window.DiagnosisApp) === null || _a2 === void 0 ? void 0 : _a2.destroyWebView) !== void 0 && window.DiagnosisApp.destroyWebView();
    },
    /**
     * 인풋 아이디를 전달하면 그 네이티브 코드로 인풋에 포커스를 잡아 vitual keyboard를 오픈시킨다
     * @param (string) inputId
     */
    inputFocusWithKeyboardUp: function(inputId) {
      var _a2, _b2, _c2, _d2, _e, _f;
      const $dom = document.getElementById(inputId);
      try {
        $dom && (os === "android" ? (_b2 = (_a2 = window?.HybridApp) === null || _a2 === void 0 ? void 0 : _a2.showKeyboardInputText) === null || _b2 === void 0 || _b2.call(_a2, inputId) : os === "ios" ? (_f = (_e = (_d2 = (_c2 = window?.webkit) === null || _c2 === void 0 ? void 0 : _c2.messageHandlers) === null || _d2 === void 0 ? void 0 : _d2.showKeyboardInputText) === null || _e === void 0 ? void 0 : _e.postMessage) === null || _f === void 0 || _f.call(_e, inputId) : $dom.focus());
      } catch {
      }
    },
    /**
     * 홈서비스 1:1 채팅문의 채팅방 오픈 함수
     * @param (string) rgsid 차량 관리키
     * @param (string) applicationId 홈서비스 신청서 id
     * @param (string) appWtHit 지표
     */
    openEncarMeetgoChatRoom: function(jsonParam) {
      var _a2, _b2;
      const presentVersion = (version + "").replace(/\./gi, "");
      if (os === "android") {
        var checkVersion = "6.7.8".replace(/\./gi, "");
        if (presentVersion < checkVersion)
          if (confirm("앱 업데이트 후 사용 가능합니다.")) {
            location.href = "https://play.google.com/store/apps/details?id=com.encar.encarMobileApp";
            return;
          } else
            return;
        window.HybridApp.openEncarMeetgoChatRoom(JSON.stringify(jsonParam));
      } else if (os === "ios") {
        var checkVersion = "5.7.3".replace(/\./gi, "");
        if (presentVersion < checkVersion)
          if (confirm("앱 업데이트 후 사용 가능합니다.")) {
            location.href = "https://apps.apple.com/app/id404512755";
            return;
          } else
            return;
        (_b2 = (_a2 = window.webkit) === null || _a2 === void 0 ? void 0 : _a2.messageHandlers) === null || _b2 === void 0 || _b2.openEncarMeetgoChatRoom.postMessage(JSON.stringify(jsonParam));
      }
    },
    /**
    * 구글 API 사용하는 외부 결제 호출 브릿지
    */
    launchBillingFlow: function(body) {
      var _a2, _b2;
      (_b2 = (_a2 = window?.HybridApp) === null || _a2 === void 0 ? void 0 : _a2.launchBillingFlow) === null || _b2 === void 0 || _b2.call(_a2, JSON.stringify(body));
    },
    /**
     * showStarRatingPop
     * @desc 앱 평점팝업 네이티브레이어 노출 (앱 정책상 2회이상 호출하면 노출 안될수있음)
     */
    showStarRatingPop: function(dtAttribute) {
      var _a2, _b2;
      os == "android" ? userAgent().greaterThanAppVersion("7.5.0") ? window.HybridApp.showStarRatingPop(dtAttribute) : (_b2 = (_a2 = window.HybridApp).showStarRatingPop) === null || _b2 === void 0 || _b2.call(_a2) : os == "ios" && (window.location = iosJsScheme + `showStarRatingPop:${dtAttribute}`);
    },
    /**
     * 모바일 네이티브 인덱스 내차팔기 탭 오픈
     */
    goEstimateIndex: function(param, lowVersionWebUrl) {
      var _a2, _b2, _c2, _d2;
      try {
        if (os == "android" && (!((_a2 = window?.HybridApp) === null || _a2 === void 0) && _a2.goEstimateIndex)) {
          window.HybridApp.goEstimateIndex(JSON.stringify(param));
          return;
        } else if (os === "ios" && (!((_d2 = (_c2 = (_b2 = window?.webkit) === null || _b2 === void 0 ? void 0 : _b2.messageHandlers) === null || _c2 === void 0 ? void 0 : _c2.goEstimateIndex) === null || _d2 === void 0) && _d2.postMessage)) {
          window.webkit.messageHandlers.goEstimateIndex.postMessage(JSON.stringify(param));
          return;
        }
        window.location.replace(lowVersionWebUrl);
      } catch {
        setTimeout(() => {
          window.location.replace(lowVersionWebUrl);
        }, 1e3);
      }
    }
  };
};
function appsflyerEvent(eventName) {
  if (!eventName)
    throw new Error("Appsflyer EventName is Required");
  if (uaParser().isApp)
    mobileAppBridge().sendAppsflyerEvent(eventName);
  else {
    let count = 0;
    const intervalId = setInterval(() => {
      const { AF } = window;
      AF && (AF("pba", "event", { eventType: "EVENT", eventName }), clearInterval(intervalId));
      try {
        if (count += 1, count > 50)
          throw clearInterval(intervalId), new Error("Appsflyer 스크립트 로드 오류");
      } catch (err) {
        err instanceof Error && console.log(err.message);
      }
    }, 100);
  }
}
const getClientIp = (req) => {
  var _a, _b, _c;
  const forwardedFor = (_a = req?.headers) === null || _a === void 0 ? void 0 : _a["x-forwarded-for"];
  return (((_b = Array.isArray(forwardedFor) ? forwardedFor[0] : forwardedFor) === null || _b === void 0 ? void 0 : _b.split(",")[0]) || ((_c = req?.socket) === null || _c === void 0 ? void 0 : _c.remoteAddress) || "").trim().replace(/^::ffff:/i, "").replace(/[^0-9a-fA-F.:]/g, "");
}, token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
  try {
    return [decodeURIComponent(components.join(""))];
  } catch {
  }
  if (components.length === 1)
    return components;
  split = split || 1;
  const left = components.slice(0, split), right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode$1(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher) || [];
    for (let i = 1; i < tokens.length; i++)
      input = decodeComponents(tokens, i).join(""), tokens = input.match(singleMatcher) || [];
    return input;
  }
}
function customDecodeURIComponent(input) {
  const replaceMap = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let match = multiMatcher.exec(input);
  for (; match; ) {
    try {
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$1(match[0]);
      result !== match[0] && (replaceMap[match[0]] = result);
    }
    match = multiMatcher.exec(input);
  }
  replaceMap["%C2"] = "�";
  const entries = Object.keys(replaceMap);
  for (const key of entries)
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  return input;
}
function decodeUriComponent(encodedURI) {
  if (typeof encodedURI != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return customDecodeURIComponent(encodedURI);
  }
}
function splitOnFirst(string, separator) {
  if (!(typeof string == "string" && typeof separator == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (string === "" || separator === "")
    return [];
  const separatorIndex = string.indexOf(separator);
  return separatorIndex === -1 ? [] : [
    string.slice(0, separatorIndex),
    string.slice(separatorIndex + separator.length)
  ];
}
function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate))
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      descriptor?.enumerable && Object.defineProperty(result, key, descriptor);
    }
  else
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        predicate(key, value, object) && Object.defineProperty(result, key, descriptor);
      }
    }
  return result;
}
const isNullOrUndefined = (value) => value == null, strictUriEncode = (string) => encodeURIComponent(string).replace(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`), encodeFragmentIdentifier = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case "index":
      return (key) => (result, value) => {
        const index = result.length;
        return value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
          ...result,
          [encode(key, options), "[", index, "]"].join("")
        ] : [
          ...result,
          [encode(key, options), "[", encode(index, options), "]=", encode(value, options)].join("")
        ];
      };
    case "bracket":
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        [encode(key, options), "[]"].join("")
      ] : [
        ...result,
        [encode(key, options), "[]=", encode(value, options)].join("")
      ];
    case "colon-list-separator":
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        [encode(key, options), ":list="].join("")
      ] : [
        ...result,
        [encode(key, options), ":list=", encode(value, options)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : (value = value === null ? "" : value, result.length === 0 ? [[encode(key, options), keyValueSep, encode(value, options)].join("")] : [[result, encode(value, options)].join(options.arrayFormatSeparator)]);
    }
    default:
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        encode(key, options)
      ] : [
        ...result,
        [encode(key, options), "=", encode(value, options)].join("")
      ];
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case "index":
      return (key, value, accumulator) => {
        if (result = /\[(\d*)]$/.exec(key), key = key.replace(/\[\d*]$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        accumulator[key] === void 0 && (accumulator[key] = {}), accumulator[key][result[1]] = value;
      };
    case "bracket":
      return (key, value, accumulator) => {
        if (result = /(\[])$/.exec(key), key = key.replace(/\[]$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    case "colon-list-separator":
      return (key, value, accumulator) => {
        if (result = /(:list)$/.exec(key), key = key.replace(/:list$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    case "comma":
    case "separator":
      return (key, value, accumulator) => {
        const isArray = typeof value == "string" && value.includes(options.arrayFormatSeparator), isEncodedArray = typeof value == "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
        value = isEncodedArray ? decode(value, options) : value;
        const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item) => decode(item, options)) : value === null ? value : decode(value, options);
        accumulator[key] = newValue;
      };
    case "bracket-separator":
      return (key, value, accumulator) => {
        const isArray = /(\[])$/.test(key);
        if (key = key.replace(/\[]$/, ""), !isArray) {
          accumulator[key] = value && decode(value, options);
          return;
        }
        const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item) => decode(item, options));
        if (accumulator[key] === void 0) {
          accumulator[key] = arrayValue;
          return;
        }
        accumulator[key] = [...accumulator[key], ...arrayValue];
      };
    default:
      return (key, value, accumulator) => {
        if (accumulator[key] === void 0) {
          accumulator[key] = value;
          return;
        }
        accumulator[key] = [...[accumulator[key]].flat(), value];
      };
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value != "string" || value.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
  return options.encode ? options.strict ? strictUriEncode(value) : encodeURIComponent(value) : value;
}
function decode(value, options) {
  return options.decode ? decodeUriComponent(value) : value;
}
function keysSorter(input) {
  return Array.isArray(input) ? input.sort() : typeof input == "object" ? keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map((key) => input[key]) : input;
}
function removeHash(input) {
  const hashStart = input.indexOf("#");
  return hashStart !== -1 && (input = input.slice(0, hashStart)), input;
}
function getHash(url) {
  let hash = "";
  const hashStart = url.indexOf("#");
  return hashStart !== -1 && (hash = url.slice(hashStart)), hash;
}
function parseValue(value, options) {
  return options.parseNumbers && !Number.isNaN(Number(value)) && typeof value == "string" && value.trim() !== "" ? value = Number(value) : options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false") && (value = value.toLowerCase() === "true"), value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf("?");
  return queryStart === -1 ? "" : input.slice(queryStart + 1);
}
function parse(query, options) {
  options = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...options
  }, validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options), returnValue = /* @__PURE__ */ Object.create(null);
  if (typeof query != "string" || (query = query.trim().replace(/^[?#&]/, ""), !query))
    return returnValue;
  for (const parameter of query.split("&")) {
    if (parameter === "")
      continue;
    const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
    let [key, value] = splitOnFirst(parameter_, "=");
    key === void 0 && (key = parameter_), value = value === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? value : decode(value, options), formatter(decode(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue))
    if (typeof value == "object" && value !== null)
      for (const [key2, value2] of Object.entries(value))
        value[key2] = parseValue(value2, options);
    else
      returnValue[key] = parseValue(value, options);
  return options.sort === !1 ? returnValue : (options.sort === !0 ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    return result[key] = value && typeof value == "object" && !Array.isArray(value) ? keysSorter(value) : value, result;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify(object, options) {
  if (!object)
    return "";
  options = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...options
  }, validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = (key) => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "", formatter = encoderForArrayFormat(options), objectCopy = {};
  for (const [key, value] of Object.entries(object))
    shouldFilter(key) || (objectCopy[key] = value);
  const keys = Object.keys(objectCopy);
  return options.sort !== !1 && keys.sort(options.sort), keys.map((key) => {
    const value = object[key];
    return value === void 0 ? "" : value === null ? encode(key, options) : Array.isArray(value) ? value.length === 0 && options.arrayFormat === "bracket-separator" ? encode(key, options) + "[]" : value.reduce(formatter(key), []).join("&") : encode(key, options) + "=" + encode(value, options);
  }).filter((x) => x.length > 0).join("&");
}
function parseUrl(url, options) {
  options = {
    decode: !0,
    ...options
  };
  let [url_, hash] = splitOnFirst(url, "#");
  return url_ === void 0 && (url_ = url), {
    url: url_?.split("?")?.[0] ?? "",
    query: parse(extract(url), options),
    ...options && options.parseFragmentIdentifier && hash ? { fragmentIdentifier: decode(hash, options) } : {}
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: !0,
    strict: !0,
    [encodeFragmentIdentifier]: !0,
    ...options
  };
  const url = removeHash(object.url).split("?")[0] || "", queryFromUrl = extract(object.url), query = {
    ...parse(queryFromUrl, { sort: !1 }),
    ...object.query
  };
  let queryString2 = stringify(query, options);
  queryString2 && (queryString2 = `?${queryString2}`);
  let hash = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier, hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString2}${hash}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: !0,
    [encodeFragmentIdentifier]: !1,
    ...options
  };
  const { url, query, fragmentIdentifier } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  const exclusionFilter = Array.isArray(filter) ? (key) => !filter.includes(key) : (key, value) => !filter(key, value);
  return pick(input, exclusionFilter, options);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse,
  parseUrl,
  pick,
  stringify,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" })), setDsClickCodeReset = () => api.set("_dsClick", "", {
  domain: getCookieDomain(),
  expires: 1 / 1440
  // 1min
}), getDsClickCode = () => api.get("_dsClick"), setDsClickCode = (text) => api.set("_dsClick", text, {
  domain: getCookieDomain()
}), handleDsClickUriChange = (value) => {
  api.set("_dsClick", value, {
    domain: getCookieDomain(),
    expires: 1 / 1440
    // 1min
  });
}, handleDsClickUriUnchange = (value, options) => {
  const { pathname = document.location.pathname } = options || {}, searchParams = queryString.parse(document.location.search), customSearchParams = queryString.parse(value), mergedValue = Object.assign(searchParams, customSearchParams), valueParam = `?${queryString.stringify(mergedValue)}`;
  typeof window.n_click_logging == "function" && window.n_click_logging(`${document.location.protocol}//${document.location.host}/click${pathname}${valueParam}`);
}, handleDsCustom = (value = "") => {
  const cookie = getDsClickCode() ? `${getDsClickCode()}&` : getDsClickCode();
  let checkJsLoadTime;
  try {
    let count = 0;
    checkJsLoadTime = setInterval(() => {
      typeof window.n_logging == "function" && (window.n_logging(`${cookie}${value}`), setDsClickCodeReset(), clearInterval(checkJsLoadTime)), count += 1, count > 50 && (setDsClickCodeReset(), clearInterval(checkJsLoadTime), console.log("dsLog: not working"));
    }, 150);
  } catch (err) {
    console.log(err);
  }
};
var dayjs_min$1 = { exports: {} }, dayjs_min = dayjs_min$1.exports, hasRequiredDayjs_min;
function requireDayjs_min() {
  return hasRequiredDayjs_min || (hasRequiredDayjs_min = 1, (function(module, exports$1) {
    (function(t, e) {
      module.exports = e();
    })(dayjs_min, (function() {
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date()) return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return t2 === void 0;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _2 || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2) return g;
        if (typeof e2 == "string") {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1) return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2)) return t2.clone();
        var n2 = typeof e2 == "object" ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _2(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _2 = (function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, !0), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = !0;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = (function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (e2 === null) return /* @__PURE__ */ new Date(NaN);
            if (b.u(e2)) return /* @__PURE__ */ new Date();
            if (e2 instanceof Date) return new Date(e2);
            if (typeof e2 == "string" && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          })(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return this.$d.toString() !== l;
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, !1);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c) return this.set(c, this.$M + r2);
          if ($2 === h) return this.set(h, this.$y + r2);
          if ($2 === a) return y2(1);
          if ($2 === o) return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid()) return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, (function(t3, r3) {
            return r3 || (function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, !0);
                case "A":
                  return $2(s2, u2, !1);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            })(t3) || i2.replace(":", "");
          }));
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2) return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, !0);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      })(), k = _2.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach((function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      })), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _2, O), t2.$i = !0), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    }));
  })(dayjs_min$1)), dayjs_min$1.exports;
}
var dayjs_minExports = requireDayjs_min();
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var advancedFormat$2 = { exports: {} }, advancedFormat$1 = advancedFormat$2.exports, hasRequiredAdvancedFormat;
function requireAdvancedFormat() {
  return hasRequiredAdvancedFormat || (hasRequiredAdvancedFormat = 1, (function(module, exports$1) {
    (function(e, t) {
      module.exports = t();
    })(advancedFormat$1, (function() {
      return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e2) {
          var t2 = this, r2 = this.$locale();
          if (!this.isValid()) return n.bind(this)(e2);
          var s = this.$utils(), a = (e2 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(e3) {
            switch (e3) {
              case "Q":
                return Math.ceil((t2.$M + 1) / 3);
              case "Do":
                return r2.ordinal(t2.$D);
              case "gggg":
                return t2.weekYear();
              case "GGGG":
                return t2.isoWeekYear();
              case "wo":
                return r2.ordinal(t2.week(), "W");
              case "w":
              case "ww":
                return s.s(t2.week(), e3 === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return s.s(t2.isoWeek(), e3 === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return s.s(String(t2.$H === 0 ? 24 : t2.$H), e3 === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(t2.$d.getTime() / 1e3);
              case "x":
                return t2.$d.getTime();
              case "z":
                return "[" + t2.offsetName() + "]";
              case "zzz":
                return "[" + t2.offsetName("long") + "]";
              default:
                return e3;
            }
          }));
          return n.bind(this)(a);
        };
      };
    }));
  })(advancedFormat$2)), advancedFormat$2.exports;
}
var advancedFormatExports = requireAdvancedFormat();
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
var customParseFormat$2 = { exports: {} }, customParseFormat$1 = customParseFormat$2.exports, hasRequiredCustomParseFormat;
function requireCustomParseFormat() {
  return hasRequiredCustomParseFormat || (hasRequiredCustomParseFormat = 1, (function(module, exports$1) {
    (function(e, t) {
      module.exports = t();
    })(customParseFormat$1, (function() {
      var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e2) {
        return (e2 = +e2) + (e2 > 68 ? 1900 : 2e3);
      }, f = function(e2) {
        return function(t2) {
          this[e2] = +t2;
        };
      }, h = [/[+-]\d\d:?(\d\d)?|Z/, function(e2) {
        (this.zone || (this.zone = {})).offset = (function(e3) {
          if (!e3 || e3 === "Z") return 0;
          var t2 = e3.match(/([+-]|\d\d)/g), n2 = 60 * t2[1] + (+t2[2] || 0);
          return n2 === 0 ? 0 : t2[0] === "+" ? -n2 : n2;
        })(e2);
      }], u = function(e2) {
        var t2 = s[e2];
        return t2 && (t2.indexOf ? t2 : t2.s.concat(t2.f));
      }, d = function(e2, t2) {
        var n2, r2 = s.meridiem;
        if (r2) {
          for (var i2 = 1; i2 <= 24; i2 += 1) if (e2.indexOf(r2(i2, 0, t2)) > -1) {
            n2 = i2 > 12;
            break;
          }
        } else n2 = e2 === (t2 ? "pm" : "PM");
        return n2;
      }, c = { A: [o, function(e2) {
        this.afternoon = d(e2, !1);
      }], a: [o, function(e2) {
        this.afternoon = d(e2, !0);
      }], Q: [n, function(e2) {
        this.month = 3 * (e2 - 1) + 1;
      }], S: [n, function(e2) {
        this.milliseconds = 100 * +e2;
      }], SS: [r, function(e2) {
        this.milliseconds = 10 * +e2;
      }], SSS: [/\d{3}/, function(e2) {
        this.milliseconds = +e2;
      }], s: [i, f("seconds")], ss: [i, f("seconds")], m: [i, f("minutes")], mm: [i, f("minutes")], H: [i, f("hours")], h: [i, f("hours")], HH: [i, f("hours")], hh: [i, f("hours")], D: [i, f("day")], DD: [r, f("day")], Do: [o, function(e2) {
        var t2 = s.ordinal, n2 = e2.match(/\d+/);
        if (this.day = n2[0], t2) for (var r2 = 1; r2 <= 31; r2 += 1) t2(r2).replace(/\[|\]/g, "") === e2 && (this.day = r2);
      }], w: [i, f("week")], ww: [r, f("week")], M: [i, f("month")], MM: [r, f("month")], MMM: [o, function(e2) {
        var t2 = u("months"), n2 = (u("monthsShort") || t2.map((function(e3) {
          return e3.slice(0, 3);
        }))).indexOf(e2) + 1;
        if (n2 < 1) throw new Error();
        this.month = n2 % 12 || n2;
      }], MMMM: [o, function(e2) {
        var t2 = u("months").indexOf(e2) + 1;
        if (t2 < 1) throw new Error();
        this.month = t2 % 12 || t2;
      }], Y: [/[+-]?\d+/, f("year")], YY: [r, function(e2) {
        this.year = a(e2);
      }], YYYY: [/\d{4}/, f("year")], Z: h, ZZ: h };
      function l(n2) {
        var r2, i2;
        r2 = n2, i2 = s && s.formats;
        for (var o2 = (n2 = r2.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t2, n3, r3) {
          var o3 = r3 && r3.toUpperCase();
          return n3 || i2[r3] || e[r3] || i2[o3].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e2, t3, n4) {
            return t3 || n4.slice(1);
          }));
        }))).match(t), a2 = o2.length, f2 = 0; f2 < a2; f2 += 1) {
          var h2 = o2[f2], u2 = c[h2], d2 = u2 && u2[0], l2 = u2 && u2[1];
          o2[f2] = l2 ? { regex: d2, parser: l2 } : h2.replace(/^\[|\]$/g, "");
        }
        return function(e2) {
          for (var t2 = {}, n3 = 0, r3 = 0; n3 < a2; n3 += 1) {
            var i3 = o2[n3];
            if (typeof i3 == "string") r3 += i3.length;
            else {
              var s2 = i3.regex, f3 = i3.parser, h3 = e2.slice(r3), u3 = s2.exec(h3)[0];
              f3.call(t2, u3), e2 = e2.replace(u3, "");
            }
          }
          return (function(e3) {
            var t3 = e3.afternoon;
            if (t3 !== void 0) {
              var n4 = e3.hours;
              t3 ? n4 < 12 && (e3.hours += 12) : n4 === 12 && (e3.hours = 0), delete e3.afternoon;
            }
          })(t2), t2;
        };
      }
      return function(e2, t2, n2) {
        n2.p.customParseFormat = !0, e2 && e2.parseTwoDigitYear && (a = e2.parseTwoDigitYear);
        var r2 = t2.prototype, i2 = r2.parse;
        r2.parse = function(e3) {
          var t3 = e3.date, r3 = e3.utc, o2 = e3.args;
          this.$u = r3;
          var a2 = o2[1];
          if (typeof a2 == "string") {
            var f2 = o2[2] === !0, h2 = o2[3] === !0, u2 = f2 || h2, d2 = o2[2];
            h2 && (d2 = o2[2]), s = this.$locale(), !f2 && d2 && (s = n2.Ls[d2]), this.$d = (function(e4, t4, n3, r4) {
              try {
                if (["x", "X"].indexOf(t4) > -1) return new Date((t4 === "X" ? 1e3 : 1) * e4);
                var i3 = l(t4)(e4), o3 = i3.year, s2 = i3.month, a3 = i3.day, f3 = i3.hours, h3 = i3.minutes, u3 = i3.seconds, d3 = i3.milliseconds, c3 = i3.zone, m2 = i3.week, M2 = /* @__PURE__ */ new Date(), Y = a3 || (o3 || s2 ? 1 : M2.getDate()), p = o3 || M2.getFullYear(), v = 0;
                o3 && !s2 || (v = s2 > 0 ? s2 - 1 : M2.getMonth());
                var D, w = f3 || 0, g = h3 || 0, y = u3 || 0, L = d3 || 0;
                return c3 ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c3.offset * 1e3)) : n3 ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m2 && (D = r4(D).week(m2).toDate()), D);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            })(t3, a2, r3, n2), this.init(), d2 && d2 !== !0 && (this.$L = this.locale(d2).$L), u2 && t3 != this.format(a2) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
          } else if (a2 instanceof Array) for (var c2 = a2.length, m = 1; m <= c2; m += 1) {
            o2[1] = a2[m - 1];
            var M = n2.apply(this, o2);
            if (M.isValid()) {
              this.$d = M.$d, this.$L = M.$L, this.init();
              break;
            }
            m === c2 && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else i2.call(this, e3);
        };
      };
    }));
  })(customParseFormat$2)), customParseFormat$2.exports;
}
var customParseFormatExports = requireCustomParseFormat();
const customParseFormat = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
var isSameOrAfter$2 = { exports: {} }, isSameOrAfter$1 = isSameOrAfter$2.exports, hasRequiredIsSameOrAfter;
function requireIsSameOrAfter() {
  return hasRequiredIsSameOrAfter || (hasRequiredIsSameOrAfter = 1, (function(module, exports$1) {
    (function(e, t) {
      module.exports = t();
    })(isSameOrAfter$1, (function() {
      return function(e, t) {
        t.prototype.isSameOrAfter = function(e2, t2) {
          return this.isSame(e2, t2) || this.isAfter(e2, t2);
        };
      };
    }));
  })(isSameOrAfter$2)), isSameOrAfter$2.exports;
}
var isSameOrAfterExports = requireIsSameOrAfter();
const isSameOrAfter = /* @__PURE__ */ getDefaultExportFromCjs(isSameOrAfterExports);
var isSameOrBefore$2 = { exports: {} }, isSameOrBefore$1 = isSameOrBefore$2.exports, hasRequiredIsSameOrBefore;
function requireIsSameOrBefore() {
  return hasRequiredIsSameOrBefore || (hasRequiredIsSameOrBefore = 1, (function(module, exports$1) {
    (function(e, i) {
      module.exports = i();
    })(isSameOrBefore$1, (function() {
      return function(e, i) {
        i.prototype.isSameOrBefore = function(e2, i2) {
          return this.isSame(e2, i2) || this.isBefore(e2, i2);
        };
      };
    }));
  })(isSameOrBefore$2)), isSameOrBefore$2.exports;
}
var isSameOrBeforeExports = requireIsSameOrBefore();
const isSameOrBefore = /* @__PURE__ */ getDefaultExportFromCjs(isSameOrBeforeExports);
var updateLocale$2 = { exports: {} }, updateLocale$1 = updateLocale$2.exports, hasRequiredUpdateLocale;
function requireUpdateLocale() {
  return hasRequiredUpdateLocale || (hasRequiredUpdateLocale = 1, (function(module, exports$1) {
    (function(e, n) {
      module.exports = n();
    })(updateLocale$1, (function() {
      return function(e, n, t) {
        t.updateLocale = function(e2, n2) {
          var o = t.Ls[e2];
          if (o) return (n2 ? Object.keys(n2) : []).forEach((function(e3) {
            o[e3] = n2[e3];
          })), o;
        };
      };
    }));
  })(updateLocale$2)), updateLocale$2.exports;
}
var updateLocaleExports = requireUpdateLocale();
const updateLocale = /* @__PURE__ */ getDefaultExportFromCjs(updateLocaleExports);
var objectSupport$2 = { exports: {} }, objectSupport$1 = objectSupport$2.exports, hasRequiredObjectSupport;
function requireObjectSupport() {
  return hasRequiredObjectSupport || (hasRequiredObjectSupport = 1, (function(module, exports$1) {
    (function(t, n) {
      module.exports = n();
    })(objectSupport$1, (function() {
      return function(t, n, e) {
        var i = n.prototype, r = function(t2) {
          var n2, r2 = t2.date, o2 = t2.utc, u2 = {};
          if (!((n2 = r2) === null || n2 instanceof Date || n2 instanceof Array || i.$utils().u(n2) || n2.constructor.name !== "Object")) {
            if (!Object.keys(r2).length) return /* @__PURE__ */ new Date();
            var a2 = o2 ? e.utc() : e();
            Object.keys(r2).forEach((function(t3) {
              var n3, e2;
              u2[n3 = t3, e2 = i.$utils().p(n3), e2 === "date" ? "day" : e2] = r2[t3];
            }));
            var c2 = u2.day || (u2.year || u2.month >= 0 ? 1 : a2.date()), s2 = u2.year || a2.year(), d = u2.month >= 0 ? u2.month : u2.year || u2.day ? 0 : a2.month(), f = u2.hour || 0, b = u2.minute || 0, h = u2.second || 0, y = u2.millisecond || 0;
            return o2 ? new Date(Date.UTC(s2, d, c2, f, b, h, y)) : new Date(s2, d, c2, f, b, h, y);
          }
          return r2;
        }, o = i.parse;
        i.parse = function(t2) {
          t2.date = r.bind(this)(t2), o.bind(this)(t2);
        };
        var u = i.set, a = i.add, c = i.subtract, s = function(t2, n2, e2, i2) {
          i2 === void 0 && (i2 = 1);
          var r2 = Object.keys(n2), o2 = this;
          return r2.forEach((function(e3) {
            o2 = t2.bind(o2)(n2[e3] * i2, e3);
          })), o2;
        };
        i.set = function(t2, n2) {
          return n2 = n2 === void 0 ? t2 : n2, t2.constructor.name === "Object" ? s.bind(this)((function(t3, n3) {
            return u.bind(this)(n3, t3);
          }), n2, t2) : u.bind(this)(t2, n2);
        }, i.add = function(t2, n2) {
          return t2.constructor.name === "Object" ? s.bind(this)(a, t2, n2) : a.bind(this)(t2, n2);
        }, i.subtract = function(t2, n2) {
          return t2.constructor.name === "Object" ? s.bind(this)(a, t2, n2, -1) : c.bind(this)(t2, n2);
        };
      };
    }));
  })(objectSupport$2)), objectSupport$2.exports;
}
var objectSupportExports = requireObjectSupport();
const objectSupport = /* @__PURE__ */ getDefaultExportFromCjs(objectSupportExports);
var isBetween$2 = { exports: {} }, isBetween$1 = isBetween$2.exports, hasRequiredIsBetween;
function requireIsBetween() {
  return hasRequiredIsBetween || (hasRequiredIsBetween = 1, (function(module, exports$1) {
    (function(e, i) {
      module.exports = i();
    })(isBetween$1, (function() {
      return function(e, i, t) {
        i.prototype.isBetween = function(e2, i2, s, f) {
          var n = t(e2), o = t(i2), r = (f = f || "()")[0] === "(", u = f[1] === ")";
          return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
      };
    }));
  })(isBetween$2)), isBetween$2.exports;
}
var isBetweenExports = requireIsBetween();
const isBetween = /* @__PURE__ */ getDefaultExportFromCjs(isBetweenExports);
var isToday$2 = { exports: {} }, isToday$1 = isToday$2.exports, hasRequiredIsToday;
function requireIsToday() {
  return hasRequiredIsToday || (hasRequiredIsToday = 1, (function(module, exports$1) {
    (function(e, o) {
      module.exports = o();
    })(isToday$1, (function() {
      return function(e, o, t) {
        o.prototype.isToday = function() {
          var e2 = "YYYY-MM-DD", o2 = t();
          return this.format(e2) === o2.format(e2);
        };
      };
    }));
  })(isToday$2)), isToday$2.exports;
}
var isTodayExports = requireIsToday();
const isToday = /* @__PURE__ */ getDefaultExportFromCjs(isTodayExports);
var duration$2 = { exports: {} }, duration$1 = duration$2.exports, hasRequiredDuration;
function requireDuration() {
  return hasRequiredDuration || (hasRequiredDuration = 1, (function(module, exports$1) {
    (function(t, s) {
      module.exports = s();
    })(duration$1, (function() {
      var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = { years: u, months: d, days: r, hours: e, minutes: i, seconds: n, milliseconds: 1, weeks: 6048e5 }, c = function(t2) {
        return t2 instanceof g;
      }, f = function(t2, s2, n2) {
        return new g(t2, n2, s2.$l);
      }, m = function(t2) {
        return s.p(t2) + "s";
      }, l = function(t2) {
        return t2 < 0;
      }, $ = function(t2) {
        return l(t2) ? Math.ceil(t2) : Math.floor(t2);
      }, y = function(t2) {
        return Math.abs(t2);
      }, v = function(t2, s2) {
        return t2 ? l(t2) ? { negative: !0, format: "" + y(t2) + s2 } : { negative: !1, format: "" + t2 + s2 } : { negative: !1, format: "" };
      }, g = (function() {
        function l2(t2, s2, n2) {
          var i2 = this;
          if (this.$d = {}, this.$l = n2, t2 === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), s2) return f(t2 * h[m(s2)], this);
          if (typeof t2 == "number") return this.$ms = t2, this.parseFromMilliseconds(), this;
          if (typeof t2 == "object") return Object.keys(t2).forEach((function(s3) {
            i2.$d[m(s3)] = t2[s3];
          })), this.calMilliseconds(), this;
          if (typeof t2 == "string") {
            var e2 = t2.match(a);
            if (e2) {
              var r2 = e2.slice(2).map((function(t3) {
                return t3 != null ? Number(t3) : 0;
              }));
              return this.$d.years = r2[0], this.$d.months = r2[1], this.$d.weeks = r2[2], this.$d.days = r2[3], this.$d.hours = r2[4], this.$d.minutes = r2[5], this.$d.seconds = r2[6], this.calMilliseconds(), this;
            }
          }
          return this;
        }
        var y2 = l2.prototype;
        return y2.calMilliseconds = function() {
          var t2 = this;
          this.$ms = Object.keys(this.$d).reduce((function(s2, n2) {
            return s2 + (t2.$d[n2] || 0) * h[n2];
          }), 0);
        }, y2.parseFromMilliseconds = function() {
          var t2 = this.$ms;
          this.$d.years = $(t2 / u), t2 %= u, this.$d.months = $(t2 / d), t2 %= d, this.$d.days = $(t2 / r), t2 %= r, this.$d.hours = $(t2 / e), t2 %= e, this.$d.minutes = $(t2 / i), t2 %= i, this.$d.seconds = $(t2 / n), t2 %= n, this.$d.milliseconds = t2;
        }, y2.toISOString = function() {
          var t2 = v(this.$d.years, "Y"), s2 = v(this.$d.months, "M"), n2 = +this.$d.days || 0;
          this.$d.weeks && (n2 += 7 * this.$d.weeks);
          var i2 = v(n2, "D"), e2 = v(this.$d.hours, "H"), r2 = v(this.$d.minutes, "M"), o2 = this.$d.seconds || 0;
          this.$d.milliseconds && (o2 += this.$d.milliseconds / 1e3, o2 = Math.round(1e3 * o2) / 1e3);
          var u2 = v(o2, "S"), d2 = t2.negative || s2.negative || i2.negative || e2.negative || r2.negative || u2.negative, a2 = e2.format || r2.format || u2.format ? "T" : "", h2 = (d2 ? "-" : "") + "P" + t2.format + s2.format + i2.format + a2 + e2.format + r2.format + u2.format;
          return h2 === "P" || h2 === "-P" ? "P0D" : h2;
        }, y2.toJSON = function() {
          return this.toISOString();
        }, y2.format = function(t2) {
          var n2 = t2 || "YYYY-MM-DDTHH:mm:ss", i2 = { Y: this.$d.years, YY: s.s(this.$d.years, 2, "0"), YYYY: s.s(this.$d.years, 4, "0"), M: this.$d.months, MM: s.s(this.$d.months, 2, "0"), D: this.$d.days, DD: s.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: s.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: s.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: s.s(this.$d.seconds, 2, "0"), SSS: s.s(this.$d.milliseconds, 3, "0") };
          return n2.replace(o, (function(t3, s2) {
            return s2 || String(i2[t3]);
          }));
        }, y2.as = function(t2) {
          return this.$ms / h[m(t2)];
        }, y2.get = function(t2) {
          var s2 = this.$ms, n2 = m(t2);
          return n2 === "milliseconds" ? s2 %= 1e3 : s2 = n2 === "weeks" ? $(s2 / h[n2]) : this.$d[n2], s2 || 0;
        }, y2.add = function(t2, s2, n2) {
          var i2;
          return i2 = s2 ? t2 * h[m(s2)] : c(t2) ? t2.$ms : f(t2, this).$ms, f(this.$ms + i2 * (n2 ? -1 : 1), this);
        }, y2.subtract = function(t2, s2) {
          return this.add(t2, s2, !0);
        }, y2.locale = function(t2) {
          var s2 = this.clone();
          return s2.$l = t2, s2;
        }, y2.clone = function() {
          return f(this.$ms, this);
        }, y2.humanize = function(s2) {
          return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s2);
        }, y2.valueOf = function() {
          return this.asMilliseconds();
        }, y2.milliseconds = function() {
          return this.get("milliseconds");
        }, y2.asMilliseconds = function() {
          return this.as("milliseconds");
        }, y2.seconds = function() {
          return this.get("seconds");
        }, y2.asSeconds = function() {
          return this.as("seconds");
        }, y2.minutes = function() {
          return this.get("minutes");
        }, y2.asMinutes = function() {
          return this.as("minutes");
        }, y2.hours = function() {
          return this.get("hours");
        }, y2.asHours = function() {
          return this.as("hours");
        }, y2.days = function() {
          return this.get("days");
        }, y2.asDays = function() {
          return this.as("days");
        }, y2.weeks = function() {
          return this.get("weeks");
        }, y2.asWeeks = function() {
          return this.as("weeks");
        }, y2.months = function() {
          return this.get("months");
        }, y2.asMonths = function() {
          return this.as("months");
        }, y2.years = function() {
          return this.get("years");
        }, y2.asYears = function() {
          return this.as("years");
        }, l2;
      })(), p = function(t2, s2, n2) {
        return t2.add(s2.years() * n2, "y").add(s2.months() * n2, "M").add(s2.days() * n2, "d").add(s2.hours() * n2, "h").add(s2.minutes() * n2, "m").add(s2.seconds() * n2, "s").add(s2.milliseconds() * n2, "ms");
      };
      return function(n2, i2, e2) {
        t = e2, s = e2().$utils(), e2.duration = function(t2, s2) {
          var n3 = e2.locale();
          return f(t2, { $l: n3 }, s2);
        }, e2.isDuration = c;
        var r2 = i2.prototype.add, o2 = i2.prototype.subtract;
        i2.prototype.add = function(t2, s2) {
          return c(t2) ? p(this, t2, 1) : r2.bind(this)(t2, s2);
        }, i2.prototype.subtract = function(t2, s2) {
          return c(t2) ? p(this, t2, -1) : o2.bind(this)(t2, s2);
        };
      };
    }));
  })(duration$2)), duration$2.exports;
}
var durationExports = requireDuration();
const duration = /* @__PURE__ */ getDefaultExportFromCjs(durationExports), dayjsCustomPlugin = (o, c, f) => {
  const saveParse = c.prototype.parse;
  c.prototype.parse = function(cfg) {
    return cfg?.date === null && (cfg.date = /* @__PURE__ */ new Date(NaN)), saveParse.bind(this)(cfg);
  };
};
var ko$1 = { exports: {} }, ko = ko$1.exports, hasRequiredKo;
function requireKo() {
  return hasRequiredKo || (hasRequiredKo = 1, (function(module, exports$1) {
    (function(e, _2) {
      module.exports = _2(requireDayjs_min());
    })(ko, (function(e) {
      function _2(e2) {
        return e2 && typeof e2 == "object" && "default" in e2 ? e2 : { default: e2 };
      }
      var d = _2(e), t = { name: "ko", weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"), weekdaysShort: "일_월_화_수_목_금_토".split("_"), weekdaysMin: "일_월_화_수_목_금_토".split("_"), months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"), ordinal: function(e2) {
        return e2 + "일";
      }, formats: { LT: "A h:mm", LTS: "A h:mm:ss", L: "YYYY.MM.DD.", LL: "YYYY년 MMMM D일", LLL: "YYYY년 MMMM D일 A h:mm", LLLL: "YYYY년 MMMM D일 dddd A h:mm", l: "YYYY.MM.DD.", ll: "YYYY년 MMMM D일", lll: "YYYY년 MMMM D일 A h:mm", llll: "YYYY년 MMMM D일 dddd A h:mm" }, meridiem: function(e2) {
        return e2 < 12 ? "오전" : "오후";
      }, relativeTime: { future: "%s 후", past: "%s 전", s: "몇 초", m: "1분", mm: "%d분", h: "한 시간", hh: "%d시간", d: "하루", dd: "%d일", M: "한 달", MM: "%d달", y: "일 년", yy: "%d년" } };
      return d.default.locale(t, null, !0), t;
    }));
  })(ko$1)), ko$1.exports;
}
requireKo();
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(updateLocale);
dayjs.updateLocale("ko", {
  ordinal: (number) => `${number}일`
});
dayjs.extend(objectSupport);
dayjs.extend(dayjsCustomPlugin);
dayjs.extend(isBetween);
dayjs.extend(isToday);
dayjs.extend(duration);
const REPORT_ENTRY = {
  /** 차량상세 — 진단+ 패널 · 차량관리상태 모두보기 */
  CAR_DETAIL: "CAR_DETAIL",
  /** 차량상세 수출 리드 (해외 IP) */
  CAR_DETAIL_GLOBAL: "CAR_DETAIL_GLOBAL",
  /** 믿고 방문 고객 — 예약상세 · 알림톡 */
  FREE_MEETGO_VISIT_CUSTOMER: "FREE_MEETGO_VISIT_CUSTOMER",
  /** 믿고 배송 고객 — h3 절차페이지 · 알림톡 */
  FREE_MEETGO_DELIVERY_CUSTOMER: "FREE_MEETGO_DELIVERY_CUSTOMER",
  /** 유료 — 구매 후 즉시 열람 · 마이페이지 · 구매 고객 알림톡 */
  PAID_CUSTOMER: "PAID_CUSTOMER"
}, ROUTE = {
  [REPORT_ENTRY.CAR_DETAIL]: "/car-report/cushion",
  [REPORT_ENTRY.CAR_DETAIL_GLOBAL]: "/car-report/cushion",
  [REPORT_ENTRY.FREE_MEETGO_VISIT_CUSTOMER]: "/car-report/free",
  [REPORT_ENTRY.FREE_MEETGO_DELIVERY_CUSTOMER]: "/car-report/free",
  [REPORT_ENTRY.PAID_CUSTOMER]: "/car-report/paid"
}, carReportUrl = ({ entry, carId, query = {} }) => {
  const params = new URLSearchParams({ inflow: entry });
  return Object.entries(query).forEach(([key, value]) => {
    value != null && value !== "" && params.set(key, String(value));
  }), `${ENCAR_FEM_CAR}${ROUTE[entry]}/${carId}?${params.toString()}`;
}, carReportIntroUrl = ({ carId, reportVersion, sample, query = {} }) => {
  const params = new URLSearchParams({ reportVersion: String(reportVersion) });
  return sample && params.set("sample", sample), Object.entries(query).forEach(([key, value]) => {
    value != null && value !== "" && params.set(key, String(value));
  }), `${ENCAR_FEM_CAR}/car-report/intro/${carId}?${params.toString()}`;
};
function encarUrlBuilder(navigator2) {
  let pcPathname = "", mobilePathname = "";
  const build = () => {
    const encarPC = ENCAR_PC || "https://new.encar.com", encarMobile = ENCAR_MOBILE || "https://mnew.encar.com";
    return uaParser(navigator2).isMobile || uaParser(navigator2).isApp ? `${encarMobile}${mobilePathname}` : `${encarPC}${pcPathname}`;
  };
  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pc(pathname) {
      return pcPathname = pathname, mobilePathname ? build() : this;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mobile(pathname) {
      return mobilePathname = pathname, pcPathname ? build() : this;
    }
  };
}
const goHome = (replace = !1, isPromotion = !1) => {
  if (isServer)
    return;
  const homeUrl = uaParser().isPc ? `${ENCAR_PC}/index.do?WT.hit=unknown` : isPromotion ? `${ENCAR_FEM_CAR}?tab=sell` : ENCAR_FEM_CAR;
  replace ? window.location.replace(homeUrl) : window.location.href = homeUrl;
}, goErrorPage = () => {
  window.location.href = "/error.html";
}, getSiteTypeByEncarHostname = () => {
  const hostname = api.get("_encar_hostname");
  return hostname ? hostname && testMobileSiteByOrigin(hostname) ? "mobile" : "pc" : null;
}, goLegacyPageByEncarHostname = (pathname = "") => {
  const hostname = api.get("_encar_hostname"), nextPath = hostname ? `${hostname}${pathname}` : encarUrlBuilder().pc(pathname).mobile(pathname);
  window.location.replace(nextPath);
}, goMyPage = (replace = !1) => {
  const myPageUrl = encarUrlBuilder().pc("/my/my_index.do").mobile("/my/my_index.do");
  replace ? window.location.replace(myPageUrl) : window.location.href = myPageUrl;
}, windowPopupWithApp = (target, fulUrl, width = "1024", height = "1024") => {
  !!uaParser().isApp ? mobileAppBridge().goNativeWindow(fulUrl, "get", "") : window.open(fulUrl, target, `width=${width},height=${height},scrollbars=yes`);
}, windowOpenWithAppRouting = (target, fullUrl, width, height) => {
  const { isApp, isIOS } = uaParser();
  isApp && isIOS ? mobileAppBridge().goNativeWindow(fullUrl, "get", "") : window.open(fullUrl, target, width && height ? `width=${width},height=${height},scrollbars=yes` : void 0);
}, getSessionItem = (key) => isBrowser && window.sessionStorage ? JSON.parse(window.sessionStorage.getItem(key) || "null") : void 0, setSessionItem = (key, data) => isBrowser && window.sessionStorage && window.sessionStorage.setItem(key, JSON.stringify(data)), removeSessionItem = (key) => isBrowser && window.sessionStorage ? window.sessionStorage.removeItem(key) : {}, getLocalItem = (key) => isBrowser && window.localStorage ? JSON.parse(window.localStorage.getItem(key) || "null") : void 0, setLocalItem = (key, data) => isBrowser && window.localStorage && window.localStorage.setItem(key, JSON.stringify(data)), removeLocalItem = (key) => isBrowser && window.localStorage ? window.localStorage.removeItem(key) : {}, clearAuthInfo = () => {
  api.remove("X-Auth-Token-Encar", { domain: getCookieDomain() }), api.remove(ACCESS_TOKEN_KEY, { domain: getCookieDomain() }), api.remove(AUTH_PLATFORM_KEY, { domain: getCookieDomain() }), api.remove("USERID", { domain: getCookieDomain() }), api.remove("USERNAME", { domain: getCookieDomain() }), api.remove("USERTYPE", { domain: getCookieDomain() });
  try {
    removeSessionItem(MY_INFO_ACCESS_DATA_KEY);
  } catch (e) {
    console.error(e);
  }
}, uniq = (carIds) => [...new Set(carIds)], MAX_RECENTLY_VIEWED_COUNT = 30, RECENTLY_VIEWED_CAR_COOKIE_EXPIRE_DAYS = 30, RECENTLY_VIEWED_CAR_KEY = "RecentViewCar", RECENTLY_VIEWED_TRUCK_KEY = "RecentViewTruck", ALL_RECENTLY_VIEWED_CAR_KEY = "RecentViewAllCar", parseRecentViewIds = (raw) => raw ? uaParser().isApp ? raw.replace(/["']/g, "").split(/%2C|,/i).map((id) => id.trim()).filter(Boolean) : raw.split(",").filter(Boolean) : [], getRecentViewIds = () => ({
  viewedCarIds: parseRecentViewIds(api.get(RECENTLY_VIEWED_CAR_KEY)),
  viewedTruckIds: parseRecentViewIds(api.get(RECENTLY_VIEWED_TRUCK_KEY)),
  allViewedCarIds: parseRecentViewIds(api.get(ALL_RECENTLY_VIEWED_CAR_KEY))
}), regRecentViewIds = (carId, vehicleType) => {
  const { viewedCarIds, viewedTruckIds, allViewedCarIds } = getRecentViewIds(), keyCar = vehicleType === "CAR" ? RECENTLY_VIEWED_CAR_KEY : RECENTLY_VIEWED_TRUCK_KEY, newAllViewedCarIds = uniq([carId, ...allViewedCarIds]).slice(0, MAX_RECENTLY_VIEWED_COUNT), setCookieOption = {
    domain: getCookieDomain(),
    expires: new Date((/* @__PURE__ */ new Date()).getTime() + 1e3 * 60 * 60 * 24 * RECENTLY_VIEWED_CAR_COOKIE_EXPIRE_DAYS)
  }, newViewedCarIds = (keyCar === RECENTLY_VIEWED_CAR_KEY ? uniq([carId, ...viewedCarIds]) : viewedCarIds).slice(0, 20), newViewedTruckIds = (keyCar === RECENTLY_VIEWED_TRUCK_KEY ? uniq([carId, ...viewedTruckIds]) : viewedTruckIds).slice(0, 20);
  api.set(ALL_RECENTLY_VIEWED_CAR_KEY, newAllViewedCarIds.join(","), setCookieOption), api.set(RECENTLY_VIEWED_CAR_KEY, newViewedCarIds.join(","), setCookieOption), api.set(RECENTLY_VIEWED_TRUCK_KEY, newViewedTruckIds.join(","), setCookieOption);
};
var lodash_min$1 = { exports: {} };
var lodash_min = lodash_min$1.exports, hasRequiredLodash_min;
function requireLodash_min() {
  return hasRequiredLodash_min || (hasRequiredLodash_min = 1, (function(module, exports$1) {
    (function() {
      function n(n2, t2, r2) {
        switch (r2.length) {
          case 0:
            return n2.call(t2);
          case 1:
            return n2.call(t2, r2[0]);
          case 2:
            return n2.call(t2, r2[0], r2[1]);
          case 3:
            return n2.call(t2, r2[0], r2[1], r2[2]);
        }
        return n2.apply(t2, r2);
      }
      function t(n2, t2, r2, e2) {
        for (var u2 = -1, i2 = n2 == null ? 0 : n2.length; ++u2 < i2; ) {
          var o2 = n2[u2];
          t2(e2, o2, r2(o2), n2);
        }
        return e2;
      }
      function r(n2, t2) {
        for (var r2 = -1, e2 = n2 == null ? 0 : n2.length; ++r2 < e2 && t2(n2[r2], r2, n2) !== !1; ) ;
        return n2;
      }
      function e(n2, t2) {
        for (var r2 = n2 == null ? 0 : n2.length; r2-- && t2(n2[r2], r2, n2) !== !1; ) ;
        return n2;
      }
      function u(n2, t2) {
        for (var r2 = -1, e2 = n2 == null ? 0 : n2.length; ++r2 < e2; ) if (!t2(n2[r2], r2, n2)) return !1;
        return !0;
      }
      function i(n2, t2) {
        for (var r2 = -1, e2 = n2 == null ? 0 : n2.length, u2 = 0, i2 = []; ++r2 < e2; ) {
          var o2 = n2[r2];
          t2(o2, r2, n2) && (i2[u2++] = o2);
        }
        return i2;
      }
      function o(n2, t2) {
        return !!(n2 != null && n2.length) && y(n2, t2, 0) > -1;
      }
      function f(n2, t2, r2) {
        for (var e2 = -1, u2 = n2 == null ? 0 : n2.length; ++e2 < u2; ) if (r2(t2, n2[e2])) return !0;
        return !1;
      }
      function c(n2, t2) {
        for (var r2 = -1, e2 = n2 == null ? 0 : n2.length, u2 = Array(e2); ++r2 < e2; ) u2[r2] = t2(n2[r2], r2, n2);
        return u2;
      }
      function a(n2, t2) {
        for (var r2 = -1, e2 = t2.length, u2 = n2.length; ++r2 < e2; ) n2[u2 + r2] = t2[r2];
        return n2;
      }
      function l(n2, t2, r2, e2) {
        var u2 = -1, i2 = n2 == null ? 0 : n2.length;
        for (e2 && i2 && (r2 = n2[++u2]); ++u2 < i2; ) r2 = t2(r2, n2[u2], u2, n2);
        return r2;
      }
      function s(n2, t2, r2, e2) {
        var u2 = n2 == null ? 0 : n2.length;
        for (e2 && u2 && (r2 = n2[--u2]); u2--; ) r2 = t2(r2, n2[u2], u2, n2);
        return r2;
      }
      function h(n2, t2) {
        for (var r2 = -1, e2 = n2 == null ? 0 : n2.length; ++r2 < e2; ) if (t2(n2[r2], r2, n2)) return !0;
        return !1;
      }
      function p(n2) {
        return n2.split("");
      }
      function _2(n2) {
        return n2.match($t) || [];
      }
      function v(n2, t2, r2) {
        var e2;
        return r2(n2, function(n3, r3, u2) {
          if (t2(n3, r3, u2)) return e2 = r3, !1;
        }), e2;
      }
      function g(n2, t2, r2, e2) {
        for (var u2 = n2.length, i2 = r2 + (e2 ? 1 : -1); e2 ? i2-- : ++i2 < u2; ) if (t2(n2[i2], i2, n2)) return i2;
        return -1;
      }
      function y(n2, t2, r2) {
        return t2 === t2 ? Z(n2, t2, r2) : g(n2, b, r2);
      }
      function d(n2, t2, r2, e2) {
        for (var u2 = r2 - 1, i2 = n2.length; ++u2 < i2; ) if (e2(n2[u2], t2)) return u2;
        return -1;
      }
      function b(n2) {
        return n2 !== n2;
      }
      function w(n2, t2) {
        var r2 = n2 == null ? 0 : n2.length;
        return r2 ? k(n2, t2) / r2 : Cn;
      }
      function m(n2) {
        return function(t2) {
          return t2 == null ? X : t2[n2];
        };
      }
      function x(n2) {
        return function(t2) {
          return n2 == null ? X : n2[t2];
        };
      }
      function j(n2, t2, r2, e2, u2) {
        return u2(n2, function(n3, u3, i2) {
          r2 = e2 ? (e2 = !1, n3) : t2(r2, n3, u3, i2);
        }), r2;
      }
      function A(n2, t2) {
        var r2 = n2.length;
        for (n2.sort(t2); r2--; ) n2[r2] = n2[r2].value;
        return n2;
      }
      function k(n2, t2) {
        for (var r2, e2 = -1, u2 = n2.length; ++e2 < u2; ) {
          var i2 = t2(n2[e2]);
          i2 !== X && (r2 = r2 === X ? i2 : r2 + i2);
        }
        return r2;
      }
      function O(n2, t2) {
        for (var r2 = -1, e2 = Array(n2); ++r2 < n2; ) e2[r2] = t2(r2);
        return e2;
      }
      function I(n2, t2) {
        return c(t2, function(t3) {
          return [t3, n2[t3]];
        });
      }
      function R(n2) {
        return n2 && n2.slice(0, H(n2) + 1).replace(Lt, "");
      }
      function z(n2) {
        return function(t2) {
          return n2(t2);
        };
      }
      function E(n2, t2) {
        return c(t2, function(t3) {
          return n2[t3];
        });
      }
      function S(n2, t2) {
        return n2.has(t2);
      }
      function W(n2, t2) {
        for (var r2 = -1, e2 = n2.length; ++r2 < e2 && y(t2, n2[r2], 0) > -1; ) ;
        return r2;
      }
      function L(n2, t2) {
        for (var r2 = n2.length; r2-- && y(t2, n2[r2], 0) > -1; ) ;
        return r2;
      }
      function C(n2, t2) {
        for (var r2 = n2.length, e2 = 0; r2--; ) n2[r2] === t2 && ++e2;
        return e2;
      }
      function U(n2) {
        return "\\" + Yr[n2];
      }
      function B(n2, t2) {
        return n2 == null ? X : n2[t2];
      }
      function T(n2) {
        return Nr.test(n2);
      }
      function $(n2) {
        return Pr.test(n2);
      }
      function D(n2) {
        for (var t2, r2 = []; !(t2 = n2.next()).done; ) r2.push(t2.value);
        return r2;
      }
      function M(n2) {
        var t2 = -1, r2 = Array(n2.size);
        return n2.forEach(function(n3, e2) {
          r2[++t2] = [e2, n3];
        }), r2;
      }
      function F(n2, t2) {
        return function(r2) {
          return n2(t2(r2));
        };
      }
      function N(n2, t2) {
        for (var r2 = -1, e2 = n2.length, u2 = 0, i2 = []; ++r2 < e2; ) {
          var o2 = n2[r2];
          o2 !== t2 && o2 !== cn || (n2[r2] = cn, i2[u2++] = r2);
        }
        return i2;
      }
      function P(n2) {
        var t2 = -1, r2 = Array(n2.size);
        return n2.forEach(function(n3) {
          r2[++t2] = n3;
        }), r2;
      }
      function q(n2) {
        var t2 = -1, r2 = Array(n2.size);
        return n2.forEach(function(n3) {
          r2[++t2] = [n3, n3];
        }), r2;
      }
      function Z(n2, t2, r2) {
        for (var e2 = r2 - 1, u2 = n2.length; ++e2 < u2; ) if (n2[e2] === t2) return e2;
        return -1;
      }
      function K(n2, t2, r2) {
        for (var e2 = r2 + 1; e2--; ) if (n2[e2] === t2) return e2;
        return e2;
      }
      function V(n2) {
        return T(n2) ? J(n2) : _e(n2);
      }
      function G(n2) {
        return T(n2) ? Y(n2) : p(n2);
      }
      function H(n2) {
        for (var t2 = n2.length; t2-- && Ct.test(n2.charAt(t2)); ) ;
        return t2;
      }
      function J(n2) {
        for (var t2 = Mr.lastIndex = 0; Mr.test(n2); ) ++t2;
        return t2;
      }
      function Y(n2) {
        return n2.match(Mr) || [];
      }
      function Q(n2) {
        return n2.match(Fr) || [];
      }
      var X, nn = "4.17.23", tn = 200, rn = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", en = "Expected a function", un = "Invalid `variable` option passed into `_.template`", on = "__lodash_hash_undefined__", fn = 500, cn = "__lodash_placeholder__", an = 1, ln = 2, sn = 4, hn = 1, pn = 2, _n = 1, vn = 2, gn = 4, yn = 8, dn = 16, bn = 32, wn = 64, mn = 128, xn = 256, jn = 512, An = 30, kn = "...", On = 800, In = 16, Rn = 1, zn = 2, En = 3, Sn = 1 / 0, Wn = 9007199254740991, Ln = 17976931348623157e292, Cn = NaN, Un = 4294967295, Bn = Un - 1, Tn = Un >>> 1, $n = [["ary", mn], ["bind", _n], ["bindKey", vn], ["curry", yn], ["curryRight", dn], ["flip", jn], ["partial", bn], ["partialRight", wn], ["rearg", xn]], Dn = "[object Arguments]", Mn = "[object Array]", Fn = "[object AsyncFunction]", Nn = "[object Boolean]", Pn = "[object Date]", qn = "[object DOMException]", Zn = "[object Error]", Kn = "[object Function]", Vn = "[object GeneratorFunction]", Gn = "[object Map]", Hn = "[object Number]", Jn = "[object Null]", Yn = "[object Object]", Qn = "[object Promise]", Xn = "[object Proxy]", nt = "[object RegExp]", tt = "[object Set]", rt = "[object String]", et = "[object Symbol]", ut = "[object Undefined]", it = "[object WeakMap]", ot = "[object WeakSet]", ft = "[object ArrayBuffer]", ct = "[object DataView]", at = "[object Float32Array]", lt = "[object Float64Array]", st = "[object Int8Array]", ht = "[object Int16Array]", pt = "[object Int32Array]", _t = "[object Uint8Array]", vt = "[object Uint8ClampedArray]", gt = "[object Uint16Array]", yt = "[object Uint32Array]", dt = /\b__p \+= '';/g, bt = /\b(__p \+=) '' \+/g, wt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mt = /&(?:amp|lt|gt|quot|#39);/g, xt = /[&<>"']/g, jt = RegExp(mt.source), At = RegExp(xt.source), kt = /<%-([\s\S]+?)%>/g, Ot = /<%([\s\S]+?)%>/g, It = /<%=([\s\S]+?)%>/g, Rt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zt = /^\w*$/, Et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, St = /[\\^$.*+?()[\]{}|]/g, Wt = RegExp(St.source), Lt = /^\s+/, Ct = /\s/, Ut = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Bt = /\{\n\/\* \[wrapped with (.+)\] \*/, Tt = /,? & /, $t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Dt = /[()=,{}\[\]\/\s]/, Mt = /\\(\\)?/g, Ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nt = /\w*$/, Pt = /^[-+]0x[0-9a-f]+$/i, qt = /^0b[01]+$/i, Zt = /^\[object .+?Constructor\]$/, Kt = /^0o[0-7]+$/i, Vt = /^(?:0|[1-9]\d*)$/, Gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ht = /($^)/, Jt = /['\n\r\u2028\u2029\\]/g, Yt = "\\ud800-\\udfff", Qt = "\\u0300-\\u036f", Xt = "\\ufe20-\\ufe2f", nr = "\\u20d0-\\u20ff", tr = Qt + Xt + nr, rr = "\\u2700-\\u27bf", er = "a-z\\xdf-\\xf6\\xf8-\\xff", ur = "\\xac\\xb1\\xd7\\xf7", ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", or = "\\u2000-\\u206f", fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cr = "A-Z\\xc0-\\xd6\\xd8-\\xde", ar = "\\ufe0e\\ufe0f", lr = ur + ir + or + fr, sr = "['’]", hr = "[" + Yt + "]", pr = "[" + lr + "]", _r = "[" + tr + "]", vr = "\\d+", gr = "[" + rr + "]", yr = "[" + er + "]", dr = "[^" + Yt + lr + vr + rr + er + cr + "]", br = "\\ud83c[\\udffb-\\udfff]", wr = "(?:" + _r + "|" + br + ")", mr = "[^" + Yt + "]", xr = "(?:\\ud83c[\\udde6-\\uddff]){2}", jr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ar = "[" + cr + "]", kr = "\\u200d", Or = "(?:" + yr + "|" + dr + ")", Ir = "(?:" + Ar + "|" + dr + ")", Rr = "(?:" + sr + "(?:d|ll|m|re|s|t|ve))?", zr = "(?:" + sr + "(?:D|LL|M|RE|S|T|VE))?", Er = wr + "?", Sr = "[" + ar + "]?", Wr = "(?:" + kr + "(?:" + [mr, xr, jr].join("|") + ")" + Sr + Er + ")*", Lr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Cr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ur = Sr + Er + Wr, Br = "(?:" + [gr, xr, jr].join("|") + ")" + Ur, Tr = "(?:" + [mr + _r + "?", _r, xr, jr, hr].join("|") + ")", $r = RegExp(sr, "g"), Dr = RegExp(_r, "g"), Mr = RegExp(br + "(?=" + br + ")|" + Tr + Ur, "g"), Fr = RegExp([Ar + "?" + yr + "+" + Rr + "(?=" + [pr, Ar, "$"].join("|") + ")", Ir + "+" + zr + "(?=" + [pr, Ar + Or, "$"].join("|") + ")", Ar + "?" + Or + "+" + Rr, Ar + "+" + zr, Cr, Lr, vr, Br].join("|"), "g"), Nr = RegExp("[" + kr + Yt + tr + ar + "]"), Pr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qr = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Zr = -1, Kr = {};
      Kr[at] = Kr[lt] = Kr[st] = Kr[ht] = Kr[pt] = Kr[_t] = Kr[vt] = Kr[gt] = Kr[yt] = !0, Kr[Dn] = Kr[Mn] = Kr[ft] = Kr[Nn] = Kr[ct] = Kr[Pn] = Kr[Zn] = Kr[Kn] = Kr[Gn] = Kr[Hn] = Kr[Yn] = Kr[nt] = Kr[tt] = Kr[rt] = Kr[it] = !1;
      var Vr = {};
      Vr[Dn] = Vr[Mn] = Vr[ft] = Vr[ct] = Vr[Nn] = Vr[Pn] = Vr[at] = Vr[lt] = Vr[st] = Vr[ht] = Vr[pt] = Vr[Gn] = Vr[Hn] = Vr[Yn] = Vr[nt] = Vr[tt] = Vr[rt] = Vr[et] = Vr[_t] = Vr[vt] = Vr[gt] = Vr[yt] = !0, Vr[Zn] = Vr[Kn] = Vr[it] = !1;
      var Gr = {
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Hr = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Jr = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Yr = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Qr = parseFloat, Xr = parseInt, ne = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, te = typeof self == "object" && self && self.Object === Object && self, re = ne || te || Function("return this")(), ee = exports$1 && !exports$1.nodeType && exports$1, ue = ee && !0 && module && !module.nodeType && module, ie = ue && ue.exports === ee, oe = ie && ne.process, fe = (function() {
        try {
          var n2 = ue && ue.require && ue.require("util").types;
          return n2 || oe && oe.binding && oe.binding("util");
        } catch {
        }
      })(), ce = fe && fe.isArrayBuffer, ae = fe && fe.isDate, le = fe && fe.isMap, se = fe && fe.isRegExp, he = fe && fe.isSet, pe = fe && fe.isTypedArray, _e = m("length"), ve = x(Gr), ge = x(Hr), ye = x(Jr), de = function p2(x2) {
        function Z2(n2) {
          if (cc(n2) && !bh(n2) && !(n2 instanceof Ct2)) {
            if (n2 instanceof Y2) return n2;
            if (bl.call(n2, "__wrapped__")) return eo(n2);
          }
          return new Y2(n2);
        }
        function J2() {
        }
        function Y2(n2, t2) {
          this.__wrapped__ = n2, this.__actions__ = [], this.__chain__ = !!t2, this.__index__ = 0, this.__values__ = X;
        }
        function Ct2(n2) {
          this.__wrapped__ = n2, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Un, this.__views__ = [];
        }
        function $t2() {
          var n2 = new Ct2(this.__wrapped__);
          return n2.__actions__ = Tu(this.__actions__), n2.__dir__ = this.__dir__, n2.__filtered__ = this.__filtered__, n2.__iteratees__ = Tu(this.__iteratees__), n2.__takeCount__ = this.__takeCount__, n2.__views__ = Tu(this.__views__), n2;
        }
        function Yt2() {
          if (this.__filtered__) {
            var n2 = new Ct2(this);
            n2.__dir__ = -1, n2.__filtered__ = !0;
          } else n2 = this.clone(), n2.__dir__ *= -1;
          return n2;
        }
        function Qt2() {
          var n2 = this.__wrapped__.value(), t2 = this.__dir__, r2 = bh(n2), e2 = t2 < 0, u2 = r2 ? n2.length : 0, i2 = Oi(0, u2, this.__views__), o2 = i2.start, f2 = i2.end, c2 = f2 - o2, a2 = e2 ? f2 : o2 - 1, l2 = this.__iteratees__, s2 = l2.length, h2 = 0, p3 = Hl(c2, this.__takeCount__);
          if (!r2 || !e2 && u2 == c2 && p3 == c2) return wu(n2, this.__actions__);
          var _3 = [];
          n: for (; c2-- && h2 < p3; ) {
            a2 += t2;
            for (var v2 = -1, g2 = n2[a2]; ++v2 < s2; ) {
              var y2 = l2[v2], d2 = y2.iteratee, b2 = y2.type, w2 = d2(g2);
              if (b2 == zn) g2 = w2;
              else if (!w2) {
                if (b2 == Rn) continue n;
                break n;
              }
            }
            _3[h2++] = g2;
          }
          return _3;
        }
        function Xt2(n2) {
          var t2 = -1, r2 = n2 == null ? 0 : n2.length;
          for (this.clear(); ++t2 < r2; ) {
            var e2 = n2[t2];
            this.set(e2[0], e2[1]);
          }
        }
        function nr2() {
          this.__data__ = is ? is(null) : {}, this.size = 0;
        }
        function tr2(n2) {
          var t2 = this.has(n2) && delete this.__data__[n2];
          return this.size -= t2 ? 1 : 0, t2;
        }
        function rr2(n2) {
          var t2 = this.__data__;
          if (is) {
            var r2 = t2[n2];
            return r2 === on ? X : r2;
          }
          return bl.call(t2, n2) ? t2[n2] : X;
        }
        function er2(n2) {
          var t2 = this.__data__;
          return is ? t2[n2] !== X : bl.call(t2, n2);
        }
        function ur2(n2, t2) {
          var r2 = this.__data__;
          return this.size += this.has(n2) ? 0 : 1, r2[n2] = is && t2 === X ? on : t2, this;
        }
        function ir2(n2) {
          var t2 = -1, r2 = n2 == null ? 0 : n2.length;
          for (this.clear(); ++t2 < r2; ) {
            var e2 = n2[t2];
            this.set(e2[0], e2[1]);
          }
        }
        function or2() {
          this.__data__ = [], this.size = 0;
        }
        function fr2(n2) {
          var t2 = this.__data__, r2 = Wr2(t2, n2);
          return !(r2 < 0) && (r2 == t2.length - 1 ? t2.pop() : Ll.call(t2, r2, 1), --this.size, !0);
        }
        function cr2(n2) {
          var t2 = this.__data__, r2 = Wr2(t2, n2);
          return r2 < 0 ? X : t2[r2][1];
        }
        function ar2(n2) {
          return Wr2(this.__data__, n2) > -1;
        }
        function lr2(n2, t2) {
          var r2 = this.__data__, e2 = Wr2(r2, n2);
          return e2 < 0 ? (++this.size, r2.push([n2, t2])) : r2[e2][1] = t2, this;
        }
        function sr2(n2) {
          var t2 = -1, r2 = n2 == null ? 0 : n2.length;
          for (this.clear(); ++t2 < r2; ) {
            var e2 = n2[t2];
            this.set(e2[0], e2[1]);
          }
        }
        function hr2() {
          this.size = 0, this.__data__ = { hash: new Xt2(), map: new (ts || ir2)(), string: new Xt2() };
        }
        function pr2(n2) {
          var t2 = xi(this, n2).delete(n2);
          return this.size -= t2 ? 1 : 0, t2;
        }
        function _r2(n2) {
          return xi(this, n2).get(n2);
        }
        function vr2(n2) {
          return xi(this, n2).has(n2);
        }
        function gr2(n2, t2) {
          var r2 = xi(this, n2), e2 = r2.size;
          return r2.set(n2, t2), this.size += r2.size == e2 ? 0 : 1, this;
        }
        function yr2(n2) {
          var t2 = -1, r2 = n2 == null ? 0 : n2.length;
          for (this.__data__ = new sr2(); ++t2 < r2; ) this.add(n2[t2]);
        }
        function dr2(n2) {
          return this.__data__.set(n2, on), this;
        }
        function br2(n2) {
          return this.__data__.has(n2);
        }
        function wr2(n2) {
          this.size = (this.__data__ = new ir2(n2)).size;
        }
        function mr2() {
          this.__data__ = new ir2(), this.size = 0;
        }
        function xr2(n2) {
          var t2 = this.__data__, r2 = t2.delete(n2);
          return this.size = t2.size, r2;
        }
        function jr2(n2) {
          return this.__data__.get(n2);
        }
        function Ar2(n2) {
          return this.__data__.has(n2);
        }
        function kr2(n2, t2) {
          var r2 = this.__data__;
          if (r2 instanceof ir2) {
            var e2 = r2.__data__;
            if (!ts || e2.length < tn - 1) return e2.push([n2, t2]), this.size = ++r2.size, this;
            r2 = this.__data__ = new sr2(e2);
          }
          return r2.set(n2, t2), this.size = r2.size, this;
        }
        function Or2(n2, t2) {
          var r2 = bh(n2), e2 = !r2 && dh(n2), u2 = !r2 && !e2 && mh(n2), i2 = !r2 && !e2 && !u2 && Oh(n2), o2 = r2 || e2 || u2 || i2, f2 = o2 ? O(n2.length, hl) : [], c2 = f2.length;
          for (var a2 in n2) !t2 && !bl.call(n2, a2) || o2 && (a2 == "length" || u2 && (a2 == "offset" || a2 == "parent") || i2 && (a2 == "buffer" || a2 == "byteLength" || a2 == "byteOffset") || Ci(a2, c2)) || f2.push(a2);
          return f2;
        }
        function Ir2(n2) {
          var t2 = n2.length;
          return t2 ? n2[tu(0, t2 - 1)] : X;
        }
        function Rr2(n2, t2) {
          return Xi(Tu(n2), Mr2(t2, 0, n2.length));
        }
        function zr2(n2) {
          return Xi(Tu(n2));
        }
        function Er2(n2, t2, r2) {
          (r2 === X || Gf(n2[t2], r2)) && (r2 !== X || t2 in n2) || Br2(n2, t2, r2);
        }
        function Sr2(n2, t2, r2) {
          var e2 = n2[t2];
          bl.call(n2, t2) && Gf(e2, r2) && (r2 !== X || t2 in n2) || Br2(n2, t2, r2);
        }
        function Wr2(n2, t2) {
          for (var r2 = n2.length; r2--; ) if (Gf(n2[r2][0], t2)) return r2;
          return -1;
        }
        function Lr2(n2, t2, r2, e2) {
          return ys(n2, function(n3, u2, i2) {
            t2(e2, n3, r2(n3), i2);
          }), e2;
        }
        function Cr2(n2, t2) {
          return n2 && $u(t2, Pc(t2), n2);
        }
        function Ur2(n2, t2) {
          return n2 && $u(t2, qc(t2), n2);
        }
        function Br2(n2, t2, r2) {
          t2 == "__proto__" && Tl ? Tl(n2, t2, { configurable: !0, enumerable: !0, value: r2, writable: !0 }) : n2[t2] = r2;
        }
        function Tr2(n2, t2) {
          for (var r2 = -1, e2 = t2.length, u2 = il(e2), i2 = n2 == null; ++r2 < e2; ) u2[r2] = i2 ? X : Mc(n2, t2[r2]);
          return u2;
        }
        function Mr2(n2, t2, r2) {
          return n2 === n2 && (r2 !== X && (n2 = n2 <= r2 ? n2 : r2), t2 !== X && (n2 = n2 >= t2 ? n2 : t2)), n2;
        }
        function Fr2(n2, t2, e2, u2, i2, o2) {
          var f2, c2 = t2 & an, a2 = t2 & ln, l2 = t2 & sn;
          if (e2 && (f2 = i2 ? e2(n2, u2, i2, o2) : e2(n2)), f2 !== X) return f2;
          if (!fc(n2)) return n2;
          var s2 = bh(n2);
          if (s2) {
            if (f2 = zi(n2), !c2) return Tu(n2, f2);
          } else {
            var h2 = zs(n2), p3 = h2 == Kn || h2 == Vn;
            if (mh(n2)) return Iu(n2, c2);
            if (h2 == Yn || h2 == Dn || p3 && !i2) {
              if (f2 = a2 || p3 ? {} : Ei(n2), !c2) return a2 ? Mu(n2, Ur2(f2, n2)) : Du(n2, Cr2(f2, n2));
            } else {
              if (!Vr[h2]) return i2 ? n2 : {};
              f2 = Si(n2, h2, c2);
            }
          }
          o2 || (o2 = new wr2());
          var _3 = o2.get(n2);
          if (_3) return _3;
          o2.set(n2, f2), kh(n2) ? n2.forEach(function(r2) {
            f2.add(Fr2(r2, t2, e2, r2, n2, o2));
          }) : jh(n2) && n2.forEach(function(r2, u3) {
            f2.set(u3, Fr2(r2, t2, e2, u3, n2, o2));
          });
          var v2 = l2 ? a2 ? di : yi : a2 ? qc : Pc, g2 = s2 ? X : v2(n2);
          return r(g2 || n2, function(r2, u3) {
            g2 && (u3 = r2, r2 = n2[u3]), Sr2(f2, u3, Fr2(r2, t2, e2, u3, n2, o2));
          }), f2;
        }
        function Nr2(n2) {
          var t2 = Pc(n2);
          return function(r2) {
            return Pr2(r2, n2, t2);
          };
        }
        function Pr2(n2, t2, r2) {
          var e2 = r2.length;
          if (n2 == null) return !e2;
          for (n2 = ll(n2); e2--; ) {
            var u2 = r2[e2], i2 = t2[u2], o2 = n2[u2];
            if (o2 === X && !(u2 in n2) || !i2(o2)) return !1;
          }
          return !0;
        }
        function Gr2(n2, t2, r2) {
          if (typeof n2 != "function") throw new pl(en);
          return Ws(function() {
            n2.apply(X, r2);
          }, t2);
        }
        function Hr2(n2, t2, r2, e2) {
          var u2 = -1, i2 = o, a2 = !0, l2 = n2.length, s2 = [], h2 = t2.length;
          if (!l2) return s2;
          r2 && (t2 = c(t2, z(r2))), e2 ? (i2 = f, a2 = !1) : t2.length >= tn && (i2 = S, a2 = !1, t2 = new yr2(t2));
          n: for (; ++u2 < l2; ) {
            var p3 = n2[u2], _3 = r2 == null ? p3 : r2(p3);
            if (p3 = e2 || p3 !== 0 ? p3 : 0, a2 && _3 === _3) {
              for (var v2 = h2; v2--; ) if (t2[v2] === _3) continue n;
              s2.push(p3);
            } else i2(t2, _3, e2) || s2.push(p3);
          }
          return s2;
        }
        function Jr2(n2, t2) {
          var r2 = !0;
          return ys(n2, function(n3, e2, u2) {
            return r2 = !!t2(n3, e2, u2);
          }), r2;
        }
        function Yr2(n2, t2, r2) {
          for (var e2 = -1, u2 = n2.length; ++e2 < u2; ) {
            var i2 = n2[e2], o2 = t2(i2);
            if (o2 != null && (f2 === X ? o2 === o2 && !bc(o2) : r2(o2, f2))) var f2 = o2, c2 = i2;
          }
          return c2;
        }
        function ne2(n2, t2, r2, e2) {
          var u2 = n2.length;
          for (r2 = kc(r2), r2 < 0 && (r2 = -r2 > u2 ? 0 : u2 + r2), e2 = e2 === X || e2 > u2 ? u2 : kc(e2), e2 < 0 && (e2 += u2), e2 = r2 > e2 ? 0 : Oc(e2); r2 < e2; ) n2[r2++] = t2;
          return n2;
        }
        function te2(n2, t2) {
          var r2 = [];
          return ys(n2, function(n3, e2, u2) {
            t2(n3, e2, u2) && r2.push(n3);
          }), r2;
        }
        function ee2(n2, t2, r2, e2, u2) {
          var i2 = -1, o2 = n2.length;
          for (r2 || (r2 = Li), u2 || (u2 = []); ++i2 < o2; ) {
            var f2 = n2[i2];
            t2 > 0 && r2(f2) ? t2 > 1 ? ee2(f2, t2 - 1, r2, e2, u2) : a(u2, f2) : e2 || (u2[u2.length] = f2);
          }
          return u2;
        }
        function ue2(n2, t2) {
          return n2 && bs(n2, t2, Pc);
        }
        function oe2(n2, t2) {
          return n2 && ws(n2, t2, Pc);
        }
        function fe2(n2, t2) {
          return i(t2, function(t3) {
            return uc(n2[t3]);
          });
        }
        function _e2(n2, t2) {
          t2 = ku(t2, n2);
          for (var r2 = 0, e2 = t2.length; n2 != null && r2 < e2; ) n2 = n2[no(t2[r2++])];
          return r2 && r2 == e2 ? n2 : X;
        }
        function de2(n2, t2, r2) {
          var e2 = t2(n2);
          return bh(n2) ? e2 : a(e2, r2(n2));
        }
        function we(n2) {
          return n2 == null ? n2 === X ? ut : Jn : Bl && Bl in ll(n2) ? ki(n2) : Ki(n2);
        }
        function me(n2, t2) {
          return n2 > t2;
        }
        function xe(n2, t2) {
          return n2 != null && bl.call(n2, t2);
        }
        function je(n2, t2) {
          return n2 != null && t2 in ll(n2);
        }
        function Ae(n2, t2, r2) {
          return n2 >= Hl(t2, r2) && n2 < Gl(t2, r2);
        }
        function ke(n2, t2, r2) {
          for (var e2 = r2 ? f : o, u2 = n2[0].length, i2 = n2.length, a2 = i2, l2 = il(i2), s2 = 1 / 0, h2 = []; a2--; ) {
            var p3 = n2[a2];
            a2 && t2 && (p3 = c(p3, z(t2))), s2 = Hl(p3.length, s2), l2[a2] = !r2 && (t2 || u2 >= 120 && p3.length >= 120) ? new yr2(a2 && p3) : X;
          }
          p3 = n2[0];
          var _3 = -1, v2 = l2[0];
          n: for (; ++_3 < u2 && h2.length < s2; ) {
            var g2 = p3[_3], y2 = t2 ? t2(g2) : g2;
            if (g2 = r2 || g2 !== 0 ? g2 : 0, !(v2 ? S(v2, y2) : e2(h2, y2, r2))) {
              for (a2 = i2; --a2; ) {
                var d2 = l2[a2];
                if (!(d2 ? S(d2, y2) : e2(n2[a2], y2, r2))) continue n;
              }
              v2 && v2.push(y2), h2.push(g2);
            }
          }
          return h2;
        }
        function Oe(n2, t2, r2, e2) {
          return ue2(n2, function(n3, u2, i2) {
            t2(e2, r2(n3), u2, i2);
          }), e2;
        }
        function Ie(t2, r2, e2) {
          r2 = ku(r2, t2), t2 = Gi(t2, r2);
          var u2 = t2 == null ? t2 : t2[no(jo(r2))];
          return u2 == null ? X : n(u2, t2, e2);
        }
        function Re(n2) {
          return cc(n2) && we(n2) == Dn;
        }
        function ze(n2) {
          return cc(n2) && we(n2) == ft;
        }
        function Ee(n2) {
          return cc(n2) && we(n2) == Pn;
        }
        function Se(n2, t2, r2, e2, u2) {
          return n2 === t2 || (n2 == null || t2 == null || !cc(n2) && !cc(t2) ? n2 !== n2 && t2 !== t2 : We(n2, t2, r2, e2, Se, u2));
        }
        function We(n2, t2, r2, e2, u2, i2) {
          var o2 = bh(n2), f2 = bh(t2), c2 = o2 ? Mn : zs(n2), a2 = f2 ? Mn : zs(t2);
          c2 = c2 == Dn ? Yn : c2, a2 = a2 == Dn ? Yn : a2;
          var l2 = c2 == Yn, s2 = a2 == Yn, h2 = c2 == a2;
          if (h2 && mh(n2)) {
            if (!mh(t2)) return !1;
            o2 = !0, l2 = !1;
          }
          if (h2 && !l2) return i2 || (i2 = new wr2()), o2 || Oh(n2) ? pi(n2, t2, r2, e2, u2, i2) : _i(n2, t2, c2, r2, e2, u2, i2);
          if (!(r2 & hn)) {
            var p3 = l2 && bl.call(n2, "__wrapped__"), _3 = s2 && bl.call(t2, "__wrapped__");
            if (p3 || _3) {
              var v2 = p3 ? n2.value() : n2, g2 = _3 ? t2.value() : t2;
              return i2 || (i2 = new wr2()), u2(v2, g2, r2, e2, i2);
            }
          }
          return !!h2 && (i2 || (i2 = new wr2()), vi(n2, t2, r2, e2, u2, i2));
        }
        function Le(n2) {
          return cc(n2) && zs(n2) == Gn;
        }
        function Ce(n2, t2, r2, e2) {
          var u2 = r2.length, i2 = u2, o2 = !e2;
          if (n2 == null) return !i2;
          for (n2 = ll(n2); u2--; ) {
            var f2 = r2[u2];
            if (o2 && f2[2] ? f2[1] !== n2[f2[0]] : !(f2[0] in n2)) return !1;
          }
          for (; ++u2 < i2; ) {
            f2 = r2[u2];
            var c2 = f2[0], a2 = n2[c2], l2 = f2[1];
            if (o2 && f2[2]) {
              if (a2 === X && !(c2 in n2)) return !1;
            } else {
              var s2 = new wr2();
              if (e2) var h2 = e2(a2, l2, c2, n2, t2, s2);
              if (!(h2 === X ? Se(l2, a2, hn | pn, e2, s2) : h2)) return !1;
            }
          }
          return !0;
        }
        function Ue(n2) {
          return !(!fc(n2) || Di(n2)) && (uc(n2) ? kl : Zt).test(to(n2));
        }
        function Be(n2) {
          return cc(n2) && we(n2) == nt;
        }
        function Te(n2) {
          return cc(n2) && zs(n2) == tt;
        }
        function $e(n2) {
          return cc(n2) && oc(n2.length) && !!Kr[we(n2)];
        }
        function De(n2) {
          return typeof n2 == "function" ? n2 : n2 == null ? La : typeof n2 == "object" ? bh(n2) ? Ze(n2[0], n2[1]) : qe(n2) : Fa(n2);
        }
        function Me(n2) {
          if (!Mi(n2)) return Vl(n2);
          var t2 = [];
          for (var r2 in ll(n2)) bl.call(n2, r2) && r2 != "constructor" && t2.push(r2);
          return t2;
        }
        function Fe(n2) {
          if (!fc(n2)) return Zi(n2);
          var t2 = Mi(n2), r2 = [];
          for (var e2 in n2) (e2 != "constructor" || !t2 && bl.call(n2, e2)) && r2.push(e2);
          return r2;
        }
        function Ne(n2, t2) {
          return n2 < t2;
        }
        function Pe(n2, t2) {
          var r2 = -1, e2 = Hf(n2) ? il(n2.length) : [];
          return ys(n2, function(n3, u2, i2) {
            e2[++r2] = t2(n3, u2, i2);
          }), e2;
        }
        function qe(n2) {
          var t2 = ji(n2);
          return t2.length == 1 && t2[0][2] ? Ni(t2[0][0], t2[0][1]) : function(r2) {
            return r2 === n2 || Ce(r2, n2, t2);
          };
        }
        function Ze(n2, t2) {
          return Bi(n2) && Fi(t2) ? Ni(no(n2), t2) : function(r2) {
            var e2 = Mc(r2, n2);
            return e2 === X && e2 === t2 ? Nc(r2, n2) : Se(t2, e2, hn | pn);
          };
        }
        function Ke(n2, t2, r2, e2, u2) {
          n2 !== t2 && bs(t2, function(i2, o2) {
            if (u2 || (u2 = new wr2()), fc(i2)) Ve(n2, t2, o2, r2, Ke, e2, u2);
            else {
              var f2 = e2 ? e2(Ji(n2, o2), i2, o2 + "", n2, t2, u2) : X;
              f2 === X && (f2 = i2), Er2(n2, o2, f2);
            }
          }, qc);
        }
        function Ve(n2, t2, r2, e2, u2, i2, o2) {
          var f2 = Ji(n2, r2), c2 = Ji(t2, r2), a2 = o2.get(c2);
          if (a2) return Er2(n2, r2, a2), X;
          var l2 = i2 ? i2(f2, c2, r2 + "", n2, t2, o2) : X, s2 = l2 === X;
          if (s2) {
            var h2 = bh(c2), p3 = !h2 && mh(c2), _3 = !h2 && !p3 && Oh(c2);
            l2 = c2, h2 || p3 || _3 ? bh(f2) ? l2 = f2 : Jf(f2) ? l2 = Tu(f2) : p3 ? (s2 = !1, l2 = Iu(c2, !0)) : _3 ? (s2 = !1, l2 = Wu(c2, !0)) : l2 = [] : gc(c2) || dh(c2) ? (l2 = f2, dh(f2) ? l2 = Rc(f2) : fc(f2) && !uc(f2) || (l2 = Ei(c2))) : s2 = !1;
          }
          s2 && (o2.set(c2, l2), u2(l2, c2, e2, i2, o2), o2.delete(c2)), Er2(n2, r2, l2);
        }
        function Ge(n2, t2) {
          var r2 = n2.length;
          if (r2) return t2 += t2 < 0 ? r2 : 0, Ci(t2, r2) ? n2[t2] : X;
        }
        function He(n2, t2, r2) {
          t2 = t2.length ? c(t2, function(n3) {
            return bh(n3) ? function(t3) {
              return _e2(t3, n3.length === 1 ? n3[0] : n3);
            } : n3;
          }) : [La];
          var e2 = -1;
          return t2 = c(t2, z(mi())), A(Pe(n2, function(n3, r3, u2) {
            return { criteria: c(t2, function(t3) {
              return t3(n3);
            }), index: ++e2, value: n3 };
          }), function(n3, t3) {
            return Cu(n3, t3, r2);
          });
        }
        function Je(n2, t2) {
          return Ye(n2, t2, function(t3, r2) {
            return Nc(n2, r2);
          });
        }
        function Ye(n2, t2, r2) {
          for (var e2 = -1, u2 = t2.length, i2 = {}; ++e2 < u2; ) {
            var o2 = t2[e2], f2 = _e2(n2, o2);
            r2(f2, o2) && fu(i2, ku(o2, n2), f2);
          }
          return i2;
        }
        function Qe(n2) {
          return function(t2) {
            return _e2(t2, n2);
          };
        }
        function Xe(n2, t2, r2, e2) {
          var u2 = e2 ? d : y, i2 = -1, o2 = t2.length, f2 = n2;
          for (n2 === t2 && (t2 = Tu(t2)), r2 && (f2 = c(n2, z(r2))); ++i2 < o2; ) for (var a2 = 0, l2 = t2[i2], s2 = r2 ? r2(l2) : l2; (a2 = u2(f2, s2, a2, e2)) > -1; ) f2 !== n2 && Ll.call(f2, a2, 1), Ll.call(n2, a2, 1);
          return n2;
        }
        function nu(n2, t2) {
          for (var r2 = n2 ? t2.length : 0, e2 = r2 - 1; r2--; ) {
            var u2 = t2[r2];
            if (r2 == e2 || u2 !== i2) {
              var i2 = u2;
              Ci(u2) ? Ll.call(n2, u2, 1) : yu(n2, u2);
            }
          }
          return n2;
        }
        function tu(n2, t2) {
          return n2 + Nl(Ql() * (t2 - n2 + 1));
        }
        function ru(n2, t2, r2, e2) {
          for (var u2 = -1, i2 = Gl(Fl((t2 - n2) / (r2 || 1)), 0), o2 = il(i2); i2--; ) o2[e2 ? i2 : ++u2] = n2, n2 += r2;
          return o2;
        }
        function eu(n2, t2) {
          var r2 = "";
          if (!n2 || t2 < 1 || t2 > Wn) return r2;
          do
            t2 % 2 && (r2 += n2), t2 = Nl(t2 / 2), t2 && (n2 += n2);
          while (t2);
          return r2;
        }
        function uu(n2, t2) {
          return Ls(Vi(n2, t2, La), n2 + "");
        }
        function iu(n2) {
          return Ir2(ra(n2));
        }
        function ou(n2, t2) {
          var r2 = ra(n2);
          return Xi(r2, Mr2(t2, 0, r2.length));
        }
        function fu(n2, t2, r2, e2) {
          if (!fc(n2)) return n2;
          t2 = ku(t2, n2);
          for (var u2 = -1, i2 = t2.length, o2 = i2 - 1, f2 = n2; f2 != null && ++u2 < i2; ) {
            var c2 = no(t2[u2]), a2 = r2;
            if (c2 === "__proto__" || c2 === "constructor" || c2 === "prototype") return n2;
            if (u2 != o2) {
              var l2 = f2[c2];
              a2 = e2 ? e2(l2, c2, f2) : X, a2 === X && (a2 = fc(l2) ? l2 : Ci(t2[u2 + 1]) ? [] : {});
            }
            Sr2(f2, c2, a2), f2 = f2[c2];
          }
          return n2;
        }
        function cu(n2) {
          return Xi(ra(n2));
        }
        function au(n2, t2, r2) {
          var e2 = -1, u2 = n2.length;
          t2 < 0 && (t2 = -t2 > u2 ? 0 : u2 + t2), r2 = r2 > u2 ? u2 : r2, r2 < 0 && (r2 += u2), u2 = t2 > r2 ? 0 : r2 - t2 >>> 0, t2 >>>= 0;
          for (var i2 = il(u2); ++e2 < u2; ) i2[e2] = n2[e2 + t2];
          return i2;
        }
        function lu(n2, t2) {
          var r2;
          return ys(n2, function(n3, e2, u2) {
            return r2 = t2(n3, e2, u2), !r2;
          }), !!r2;
        }
        function su(n2, t2, r2) {
          var e2 = 0, u2 = n2 == null ? e2 : n2.length;
          if (typeof t2 == "number" && t2 === t2 && u2 <= Tn) {
            for (; e2 < u2; ) {
              var i2 = e2 + u2 >>> 1, o2 = n2[i2];
              o2 !== null && !bc(o2) && (r2 ? o2 <= t2 : o2 < t2) ? e2 = i2 + 1 : u2 = i2;
            }
            return u2;
          }
          return hu(n2, t2, La, r2);
        }
        function hu(n2, t2, r2, e2) {
          var u2 = 0, i2 = n2 == null ? 0 : n2.length;
          if (i2 === 0) return 0;
          t2 = r2(t2);
          for (var o2 = t2 !== t2, f2 = t2 === null, c2 = bc(t2), a2 = t2 === X; u2 < i2; ) {
            var l2 = Nl((u2 + i2) / 2), s2 = r2(n2[l2]), h2 = s2 !== X, p3 = s2 === null, _3 = s2 === s2, v2 = bc(s2);
            if (o2) var g2 = e2 || _3;
            else g2 = a2 ? _3 && (e2 || h2) : f2 ? _3 && h2 && (e2 || !p3) : c2 ? _3 && h2 && !p3 && (e2 || !v2) : !p3 && !v2 && (e2 ? s2 <= t2 : s2 < t2);
            g2 ? u2 = l2 + 1 : i2 = l2;
          }
          return Hl(i2, Bn);
        }
        function pu(n2, t2) {
          for (var r2 = -1, e2 = n2.length, u2 = 0, i2 = []; ++r2 < e2; ) {
            var o2 = n2[r2], f2 = t2 ? t2(o2) : o2;
            if (!r2 || !Gf(f2, c2)) {
              var c2 = f2;
              i2[u2++] = o2 === 0 ? 0 : o2;
            }
          }
          return i2;
        }
        function _u(n2) {
          return typeof n2 == "number" ? n2 : bc(n2) ? Cn : +n2;
        }
        function vu(n2) {
          if (typeof n2 == "string") return n2;
          if (bh(n2)) return c(n2, vu) + "";
          if (bc(n2)) return vs ? vs.call(n2) : "";
          var t2 = n2 + "";
          return t2 == "0" && 1 / n2 == -Sn ? "-0" : t2;
        }
        function gu(n2, t2, r2) {
          var e2 = -1, u2 = o, i2 = n2.length, c2 = !0, a2 = [], l2 = a2;
          if (r2) c2 = !1, u2 = f;
          else if (i2 >= tn) {
            var s2 = t2 ? null : ks(n2);
            if (s2) return P(s2);
            c2 = !1, u2 = S, l2 = new yr2();
          } else l2 = t2 ? [] : a2;
          n: for (; ++e2 < i2; ) {
            var h2 = n2[e2], p3 = t2 ? t2(h2) : h2;
            if (h2 = r2 || h2 !== 0 ? h2 : 0, c2 && p3 === p3) {
              for (var _3 = l2.length; _3--; ) if (l2[_3] === p3) continue n;
              t2 && l2.push(p3), a2.push(h2);
            } else u2(l2, p3, r2) || (l2 !== a2 && l2.push(p3), a2.push(h2));
          }
          return a2;
        }
        function yu(n2, t2) {
          t2 = ku(t2, n2);
          var r2 = -1, e2 = t2.length;
          if (!e2) return !0;
          for (var u2 = n2 == null || typeof n2 != "object" && typeof n2 != "function"; ++r2 < e2; ) {
            var i2 = t2[r2];
            if (typeof i2 == "string") {
              if (i2 === "__proto__" && !bl.call(n2, "__proto__")) return !1;
              if (i2 === "constructor" && r2 + 1 < e2 && typeof t2[r2 + 1] == "string" && t2[r2 + 1] === "prototype") {
                if (u2 && r2 === 0) continue;
                return !1;
              }
            }
          }
          var o2 = Gi(n2, t2);
          return o2 == null || delete o2[no(jo(t2))];
        }
        function du(n2, t2, r2, e2) {
          return fu(n2, t2, r2(_e2(n2, t2)), e2);
        }
        function bu(n2, t2, r2, e2) {
          for (var u2 = n2.length, i2 = e2 ? u2 : -1; (e2 ? i2-- : ++i2 < u2) && t2(n2[i2], i2, n2); ) ;
          return r2 ? au(n2, e2 ? 0 : i2, e2 ? i2 + 1 : u2) : au(n2, e2 ? i2 + 1 : 0, e2 ? u2 : i2);
        }
        function wu(n2, t2) {
          var r2 = n2;
          return r2 instanceof Ct2 && (r2 = r2.value()), l(t2, function(n3, t3) {
            return t3.func.apply(t3.thisArg, a([n3], t3.args));
          }, r2);
        }
        function mu(n2, t2, r2) {
          var e2 = n2.length;
          if (e2 < 2) return e2 ? gu(n2[0]) : [];
          for (var u2 = -1, i2 = il(e2); ++u2 < e2; ) for (var o2 = n2[u2], f2 = -1; ++f2 < e2; ) f2 != u2 && (i2[u2] = Hr2(i2[u2] || o2, n2[f2], t2, r2));
          return gu(ee2(i2, 1), t2, r2);
        }
        function xu(n2, t2, r2) {
          for (var e2 = -1, u2 = n2.length, i2 = t2.length, o2 = {}; ++e2 < u2; )
            r2(o2, n2[e2], e2 < i2 ? t2[e2] : X);
          return o2;
        }
        function ju(n2) {
          return Jf(n2) ? n2 : [];
        }
        function Au(n2) {
          return typeof n2 == "function" ? n2 : La;
        }
        function ku(n2, t2) {
          return bh(n2) ? n2 : Bi(n2, t2) ? [n2] : Cs(Ec(n2));
        }
        function Ou(n2, t2, r2) {
          var e2 = n2.length;
          return r2 = r2 === X ? e2 : r2, !t2 && r2 >= e2 ? n2 : au(n2, t2, r2);
        }
        function Iu(n2, t2) {
          if (t2) return n2.slice();
          var r2 = n2.length, e2 = zl ? zl(r2) : new n2.constructor(r2);
          return n2.copy(e2), e2;
        }
        function Ru(n2) {
          var t2 = new n2.constructor(n2.byteLength);
          return new Rl(t2).set(new Rl(n2)), t2;
        }
        function zu(n2, t2) {
          return new n2.constructor(t2 ? Ru(n2.buffer) : n2.buffer, n2.byteOffset, n2.byteLength);
        }
        function Eu(n2) {
          var t2 = new n2.constructor(n2.source, Nt.exec(n2));
          return t2.lastIndex = n2.lastIndex, t2;
        }
        function Su(n2) {
          return _s ? ll(_s.call(n2)) : {};
        }
        function Wu(n2, t2) {
          return new n2.constructor(t2 ? Ru(n2.buffer) : n2.buffer, n2.byteOffset, n2.length);
        }
        function Lu(n2, t2) {
          if (n2 !== t2) {
            var r2 = n2 !== X, e2 = n2 === null, u2 = n2 === n2, i2 = bc(n2), o2 = t2 !== X, f2 = t2 === null, c2 = t2 === t2, a2 = bc(t2);
            if (!f2 && !a2 && !i2 && n2 > t2 || i2 && o2 && c2 && !f2 && !a2 || e2 && o2 && c2 || !r2 && c2 || !u2) return 1;
            if (!e2 && !i2 && !a2 && n2 < t2 || a2 && r2 && u2 && !e2 && !i2 || f2 && r2 && u2 || !o2 && u2 || !c2) return -1;
          }
          return 0;
        }
        function Cu(n2, t2, r2) {
          for (var e2 = -1, u2 = n2.criteria, i2 = t2.criteria, o2 = u2.length, f2 = r2.length; ++e2 < o2; ) {
            var c2 = Lu(u2[e2], i2[e2]);
            if (c2)
              return e2 >= f2 ? c2 : c2 * (r2[e2] == "desc" ? -1 : 1);
          }
          return n2.index - t2.index;
        }
        function Uu(n2, t2, r2, e2) {
          for (var u2 = -1, i2 = n2.length, o2 = r2.length, f2 = -1, c2 = t2.length, a2 = Gl(i2 - o2, 0), l2 = il(c2 + a2), s2 = !e2; ++f2 < c2; ) l2[f2] = t2[f2];
          for (; ++u2 < o2; ) (s2 || u2 < i2) && (l2[r2[u2]] = n2[u2]);
          for (; a2--; ) l2[f2++] = n2[u2++];
          return l2;
        }
        function Bu(n2, t2, r2, e2) {
          for (var u2 = -1, i2 = n2.length, o2 = -1, f2 = r2.length, c2 = -1, a2 = t2.length, l2 = Gl(i2 - f2, 0), s2 = il(l2 + a2), h2 = !e2; ++u2 < l2; ) s2[u2] = n2[u2];
          for (var p3 = u2; ++c2 < a2; ) s2[p3 + c2] = t2[c2];
          for (; ++o2 < f2; ) (h2 || u2 < i2) && (s2[p3 + r2[o2]] = n2[u2++]);
          return s2;
        }
        function Tu(n2, t2) {
          var r2 = -1, e2 = n2.length;
          for (t2 || (t2 = il(e2)); ++r2 < e2; ) t2[r2] = n2[r2];
          return t2;
        }
        function $u(n2, t2, r2, e2) {
          var u2 = !r2;
          r2 || (r2 = {});
          for (var i2 = -1, o2 = t2.length; ++i2 < o2; ) {
            var f2 = t2[i2], c2 = e2 ? e2(r2[f2], n2[f2], f2, r2, n2) : X;
            c2 === X && (c2 = n2[f2]), u2 ? Br2(r2, f2, c2) : Sr2(r2, f2, c2);
          }
          return r2;
        }
        function Du(n2, t2) {
          return $u(n2, Is(n2), t2);
        }
        function Mu(n2, t2) {
          return $u(n2, Rs(n2), t2);
        }
        function Fu(n2, r2) {
          return function(e2, u2) {
            var i2 = bh(e2) ? t : Lr2, o2 = r2 ? r2() : {};
            return i2(e2, n2, mi(u2, 2), o2);
          };
        }
        function Nu(n2) {
          return uu(function(t2, r2) {
            var e2 = -1, u2 = r2.length, i2 = u2 > 1 ? r2[u2 - 1] : X, o2 = u2 > 2 ? r2[2] : X;
            for (i2 = n2.length > 3 && typeof i2 == "function" ? (u2--, i2) : X, o2 && Ui(r2[0], r2[1], o2) && (i2 = u2 < 3 ? X : i2, u2 = 1), t2 = ll(t2); ++e2 < u2; ) {
              var f2 = r2[e2];
              f2 && n2(t2, f2, e2, i2);
            }
            return t2;
          });
        }
        function Pu(n2, t2) {
          return function(r2, e2) {
            if (r2 == null) return r2;
            if (!Hf(r2)) return n2(r2, e2);
            for (var u2 = r2.length, i2 = t2 ? u2 : -1, o2 = ll(r2); (t2 ? i2-- : ++i2 < u2) && e2(o2[i2], i2, o2) !== !1; ) ;
            return r2;
          };
        }
        function qu(n2) {
          return function(t2, r2, e2) {
            for (var u2 = -1, i2 = ll(t2), o2 = e2(t2), f2 = o2.length; f2--; ) {
              var c2 = o2[n2 ? f2 : ++u2];
              if (r2(i2[c2], c2, i2) === !1) break;
            }
            return t2;
          };
        }
        function Zu(n2, t2, r2) {
          function e2() {
            return (this && this !== re && this instanceof e2 ? i2 : n2).apply(u2 ? r2 : this, arguments);
          }
          var u2 = t2 & _n, i2 = Gu(n2);
          return e2;
        }
        function Ku(n2) {
          return function(t2) {
            t2 = Ec(t2);
            var r2 = T(t2) ? G(t2) : X, e2 = r2 ? r2[0] : t2.charAt(0), u2 = r2 ? Ou(r2, 1).join("") : t2.slice(1);
            return e2[n2]() + u2;
          };
        }
        function Vu(n2) {
          return function(t2) {
            return l(Ra(ca(t2).replace($r, "")), n2, "");
          };
        }
        function Gu(n2) {
          return function() {
            var t2 = arguments;
            switch (t2.length) {
              case 0:
                return new n2();
              case 1:
                return new n2(t2[0]);
              case 2:
                return new n2(t2[0], t2[1]);
              case 3:
                return new n2(t2[0], t2[1], t2[2]);
              case 4:
                return new n2(t2[0], t2[1], t2[2], t2[3]);
              case 5:
                return new n2(t2[0], t2[1], t2[2], t2[3], t2[4]);
              case 6:
                return new n2(t2[0], t2[1], t2[2], t2[3], t2[4], t2[5]);
              case 7:
                return new n2(t2[0], t2[1], t2[2], t2[3], t2[4], t2[5], t2[6]);
            }
            var r2 = gs(n2.prototype), e2 = n2.apply(r2, t2);
            return fc(e2) ? e2 : r2;
          };
        }
        function Hu(t2, r2, e2) {
          function u2() {
            for (var o2 = arguments.length, f2 = il(o2), c2 = o2, a2 = wi(u2); c2--; ) f2[c2] = arguments[c2];
            var l2 = o2 < 3 && f2[0] !== a2 && f2[o2 - 1] !== a2 ? [] : N(f2, a2);
            return o2 -= l2.length, o2 < e2 ? oi(t2, r2, Qu, u2.placeholder, X, f2, l2, X, X, e2 - o2) : n(this && this !== re && this instanceof u2 ? i2 : t2, this, f2);
          }
          var i2 = Gu(t2);
          return u2;
        }
        function Ju(n2) {
          return function(t2, r2, e2) {
            var u2 = ll(t2);
            if (!Hf(t2)) {
              var i2 = mi(r2, 3);
              t2 = Pc(t2), r2 = function(n3) {
                return i2(u2[n3], n3, u2);
              };
            }
            var o2 = n2(t2, r2, e2);
            return o2 > -1 ? u2[i2 ? t2[o2] : o2] : X;
          };
        }
        function Yu(n2) {
          return gi(function(t2) {
            var r2 = t2.length, e2 = r2, u2 = Y2.prototype.thru;
            for (n2 && t2.reverse(); e2--; ) {
              var i2 = t2[e2];
              if (typeof i2 != "function") throw new pl(en);
              if (u2 && !o2 && bi(i2) == "wrapper") var o2 = new Y2([], !0);
            }
            for (e2 = o2 ? e2 : r2; ++e2 < r2; ) {
              i2 = t2[e2];
              var f2 = bi(i2), c2 = f2 == "wrapper" ? Os(i2) : X;
              o2 = c2 && $i(c2[0]) && c2[1] == (mn | yn | bn | xn) && !c2[4].length && c2[9] == 1 ? o2[bi(c2[0])].apply(o2, c2[3]) : i2.length == 1 && $i(i2) ? o2[f2]() : o2.thru(i2);
            }
            return function() {
              var n3 = arguments, e3 = n3[0];
              if (o2 && n3.length == 1 && bh(e3)) return o2.plant(e3).value();
              for (var u3 = 0, i3 = r2 ? t2[u3].apply(this, n3) : e3; ++u3 < r2; ) i3 = t2[u3].call(this, i3);
              return i3;
            };
          });
        }
        function Qu(n2, t2, r2, e2, u2, i2, o2, f2, c2, a2) {
          function l2() {
            for (var y2 = arguments.length, d2 = il(y2), b2 = y2; b2--; ) d2[b2] = arguments[b2];
            if (_3) var w2 = wi(l2), m2 = C(d2, w2);
            if (e2 && (d2 = Uu(d2, e2, u2, _3)), i2 && (d2 = Bu(d2, i2, o2, _3)), y2 -= m2, _3 && y2 < a2)
              return oi(n2, t2, Qu, l2.placeholder, r2, d2, N(d2, w2), f2, c2, a2 - y2);
            var x3 = h2 ? r2 : this, j2 = p3 ? x3[n2] : n2;
            return y2 = d2.length, f2 ? d2 = Hi(d2, f2) : v2 && y2 > 1 && d2.reverse(), s2 && c2 < y2 && (d2.length = c2), this && this !== re && this instanceof l2 && (j2 = g2 || Gu(j2)), j2.apply(x3, d2);
          }
          var s2 = t2 & mn, h2 = t2 & _n, p3 = t2 & vn, _3 = t2 & (yn | dn), v2 = t2 & jn, g2 = p3 ? X : Gu(n2);
          return l2;
        }
        function Xu(n2, t2) {
          return function(r2, e2) {
            return Oe(r2, n2, t2(e2), {});
          };
        }
        function ni(n2, t2) {
          return function(r2, e2) {
            var u2;
            if (r2 === X && e2 === X) return t2;
            if (r2 !== X && (u2 = r2), e2 !== X) {
              if (u2 === X) return e2;
              typeof r2 == "string" || typeof e2 == "string" ? (r2 = vu(r2), e2 = vu(e2)) : (r2 = _u(r2), e2 = _u(e2)), u2 = n2(r2, e2);
            }
            return u2;
          };
        }
        function ti(t2) {
          return gi(function(r2) {
            return r2 = c(r2, z(mi())), uu(function(e2) {
              var u2 = this;
              return t2(r2, function(t3) {
                return n(t3, u2, e2);
              });
            });
          });
        }
        function ri(n2, t2) {
          t2 = t2 === X ? " " : vu(t2);
          var r2 = t2.length;
          if (r2 < 2) return r2 ? eu(t2, n2) : t2;
          var e2 = eu(t2, Fl(n2 / V(t2)));
          return T(t2) ? Ou(G(e2), 0, n2).join("") : e2.slice(0, n2);
        }
        function ei(t2, r2, e2, u2) {
          function i2() {
            for (var r3 = -1, c2 = arguments.length, a2 = -1, l2 = u2.length, s2 = il(l2 + c2), h2 = this && this !== re && this instanceof i2 ? f2 : t2; ++a2 < l2; ) s2[a2] = u2[a2];
            for (; c2--; ) s2[a2++] = arguments[++r3];
            return n(h2, o2 ? e2 : this, s2);
          }
          var o2 = r2 & _n, f2 = Gu(t2);
          return i2;
        }
        function ui(n2) {
          return function(t2, r2, e2) {
            return e2 && typeof e2 != "number" && Ui(t2, r2, e2) && (r2 = e2 = X), t2 = Ac(t2), r2 === X ? (r2 = t2, t2 = 0) : r2 = Ac(r2), e2 = e2 === X ? t2 < r2 ? 1 : -1 : Ac(e2), ru(t2, r2, e2, n2);
          };
        }
        function ii(n2) {
          return function(t2, r2) {
            return typeof t2 == "string" && typeof r2 == "string" || (t2 = Ic(t2), r2 = Ic(r2)), n2(t2, r2);
          };
        }
        function oi(n2, t2, r2, e2, u2, i2, o2, f2, c2, a2) {
          var l2 = t2 & yn, s2 = l2 ? o2 : X, h2 = l2 ? X : o2, p3 = l2 ? i2 : X, _3 = l2 ? X : i2;
          t2 |= l2 ? bn : wn, t2 &= ~(l2 ? wn : bn), t2 & gn || (t2 &= -4);
          var v2 = [n2, t2, u2, p3, s2, _3, h2, f2, c2, a2], g2 = r2.apply(X, v2);
          return $i(n2) && Ss(g2, v2), g2.placeholder = e2, Yi(g2, n2, t2);
        }
        function fi(n2) {
          var t2 = al[n2];
          return function(n3, r2) {
            if (n3 = Ic(n3), r2 = r2 == null ? 0 : Hl(kc(r2), 292), r2 && Zl(n3)) {
              var e2 = (Ec(n3) + "e").split("e");
              return e2 = (Ec(t2(e2[0] + "e" + (+e2[1] + r2))) + "e").split("e"), +(e2[0] + "e" + (+e2[1] - r2));
            }
            return t2(n3);
          };
        }
        function ci2(n2) {
          return function(t2) {
            var r2 = zs(t2);
            return r2 == Gn ? M(t2) : r2 == tt ? q(t2) : I(t2, n2(t2));
          };
        }
        function ai(n2, t2, r2, e2, u2, i2, o2, f2) {
          var c2 = t2 & vn;
          if (!c2 && typeof n2 != "function") throw new pl(en);
          var a2 = e2 ? e2.length : 0;
          if (a2 || (t2 &= -97, e2 = u2 = X), o2 = o2 === X ? o2 : Gl(kc(o2), 0), f2 = f2 === X ? f2 : kc(f2), a2 -= u2 ? u2.length : 0, t2 & wn) {
            var l2 = e2, s2 = u2;
            e2 = u2 = X;
          }
          var h2 = c2 ? X : Os(n2), p3 = [n2, t2, r2, e2, u2, l2, s2, i2, o2, f2];
          if (h2 && qi(p3, h2), n2 = p3[0], t2 = p3[1], r2 = p3[2], e2 = p3[3], u2 = p3[4], f2 = p3[9] = p3[9] === X ? c2 ? 0 : n2.length : Gl(p3[9] - a2, 0), !f2 && t2 & (yn | dn) && (t2 &= -25), t2 && t2 != _n) _3 = t2 == yn || t2 == dn ? Hu(n2, t2, f2) : t2 != bn && t2 != (_n | bn) || u2.length ? Qu.apply(X, p3) : ei(n2, t2, r2, e2);
          else var _3 = Zu(n2, t2, r2);
          return Yi((h2 ? ms : Ss)(_3, p3), n2, t2);
        }
        function li(n2, t2, r2, e2) {
          return n2 === X || Gf(n2, gl[r2]) && !bl.call(e2, r2) ? t2 : n2;
        }
        function si(n2, t2, r2, e2, u2, i2) {
          return fc(n2) && fc(t2) && (i2.set(t2, n2), Ke(n2, t2, X, si, i2), i2.delete(t2)), n2;
        }
        function hi(n2) {
          return gc(n2) ? X : n2;
        }
        function pi(n2, t2, r2, e2, u2, i2) {
          var o2 = r2 & hn, f2 = n2.length, c2 = t2.length;
          if (f2 != c2 && !(o2 && c2 > f2)) return !1;
          var a2 = i2.get(n2), l2 = i2.get(t2);
          if (a2 && l2) return a2 == t2 && l2 == n2;
          var s2 = -1, p3 = !0, _3 = r2 & pn ? new yr2() : X;
          for (i2.set(n2, t2), i2.set(t2, n2); ++s2 < f2; ) {
            var v2 = n2[s2], g2 = t2[s2];
            if (e2) var y2 = o2 ? e2(g2, v2, s2, t2, n2, i2) : e2(v2, g2, s2, n2, t2, i2);
            if (y2 !== X) {
              if (y2) continue;
              p3 = !1;
              break;
            }
            if (_3) {
              if (!h(t2, function(n3, t3) {
                if (!S(_3, t3) && (v2 === n3 || u2(v2, n3, r2, e2, i2))) return _3.push(t3);
              })) {
                p3 = !1;
                break;
              }
            } else if (v2 !== g2 && !u2(v2, g2, r2, e2, i2)) {
              p3 = !1;
              break;
            }
          }
          return i2.delete(n2), i2.delete(t2), p3;
        }
        function _i(n2, t2, r2, e2, u2, i2, o2) {
          switch (r2) {
            case ct:
              if (n2.byteLength != t2.byteLength || n2.byteOffset != t2.byteOffset) return !1;
              n2 = n2.buffer, t2 = t2.buffer;
            case ft:
              return !(n2.byteLength != t2.byteLength || !i2(new Rl(n2), new Rl(t2)));
            case Nn:
            case Pn:
            case Hn:
              return Gf(+n2, +t2);
            case Zn:
              return n2.name == t2.name && n2.message == t2.message;
            case nt:
            case rt:
              return n2 == t2 + "";
            case Gn:
              var f2 = M;
            case tt:
              var c2 = e2 & hn;
              if (f2 || (f2 = P), n2.size != t2.size && !c2) return !1;
              var a2 = o2.get(n2);
              if (a2) return a2 == t2;
              e2 |= pn, o2.set(n2, t2);
              var l2 = pi(f2(n2), f2(t2), e2, u2, i2, o2);
              return o2.delete(n2), l2;
            case et:
              if (_s) return _s.call(n2) == _s.call(t2);
          }
          return !1;
        }
        function vi(n2, t2, r2, e2, u2, i2) {
          var o2 = r2 & hn, f2 = yi(n2), c2 = f2.length;
          if (c2 != yi(t2).length && !o2) return !1;
          for (var a2 = c2; a2--; ) {
            var l2 = f2[a2];
            if (!(o2 ? l2 in t2 : bl.call(t2, l2))) return !1;
          }
          var s2 = i2.get(n2), h2 = i2.get(t2);
          if (s2 && h2) return s2 == t2 && h2 == n2;
          var p3 = !0;
          i2.set(n2, t2), i2.set(t2, n2);
          for (var _3 = o2; ++a2 < c2; ) {
            l2 = f2[a2];
            var v2 = n2[l2], g2 = t2[l2];
            if (e2) var y2 = o2 ? e2(g2, v2, l2, t2, n2, i2) : e2(v2, g2, l2, n2, t2, i2);
            if (!(y2 === X ? v2 === g2 || u2(v2, g2, r2, e2, i2) : y2)) {
              p3 = !1;
              break;
            }
            _3 || (_3 = l2 == "constructor");
          }
          if (p3 && !_3) {
            var d2 = n2.constructor, b2 = t2.constructor;
            d2 != b2 && "constructor" in n2 && "constructor" in t2 && !(typeof d2 == "function" && d2 instanceof d2 && typeof b2 == "function" && b2 instanceof b2) && (p3 = !1);
          }
          return i2.delete(n2), i2.delete(t2), p3;
        }
        function gi(n2) {
          return Ls(Vi(n2, X, _o), n2 + "");
        }
        function yi(n2) {
          return de2(n2, Pc, Is);
        }
        function di(n2) {
          return de2(n2, qc, Rs);
        }
        function bi(n2) {
          for (var t2 = n2.name + "", r2 = fs[t2], e2 = bl.call(fs, t2) ? r2.length : 0; e2--; ) {
            var u2 = r2[e2], i2 = u2.func;
            if (i2 == null || i2 == n2) return u2.name;
          }
          return t2;
        }
        function wi(n2) {
          return (bl.call(Z2, "placeholder") ? Z2 : n2).placeholder;
        }
        function mi() {
          var n2 = Z2.iteratee || Ca;
          return n2 = n2 === Ca ? De : n2, arguments.length ? n2(arguments[0], arguments[1]) : n2;
        }
        function xi(n2, t2) {
          var r2 = n2.__data__;
          return Ti(t2) ? r2[typeof t2 == "string" ? "string" : "hash"] : r2.map;
        }
        function ji(n2) {
          for (var t2 = Pc(n2), r2 = t2.length; r2--; ) {
            var e2 = t2[r2], u2 = n2[e2];
            t2[r2] = [e2, u2, Fi(u2)];
          }
          return t2;
        }
        function Ai(n2, t2) {
          var r2 = B(n2, t2);
          return Ue(r2) ? r2 : X;
        }
        function ki(n2) {
          var t2 = bl.call(n2, Bl), r2 = n2[Bl];
          try {
            n2[Bl] = X;
            var e2 = !0;
          } catch {
          }
          var u2 = xl.call(n2);
          return e2 && (t2 ? n2[Bl] = r2 : delete n2[Bl]), u2;
        }
        function Oi(n2, t2, r2) {
          for (var e2 = -1, u2 = r2.length; ++e2 < u2; ) {
            var i2 = r2[e2], o2 = i2.size;
            switch (i2.type) {
              case "drop":
                n2 += o2;
                break;
              case "dropRight":
                t2 -= o2;
                break;
              case "take":
                t2 = Hl(t2, n2 + o2);
                break;
              case "takeRight":
                n2 = Gl(n2, t2 - o2);
            }
          }
          return { start: n2, end: t2 };
        }
        function Ii(n2) {
          var t2 = n2.match(Bt);
          return t2 ? t2[1].split(Tt) : [];
        }
        function Ri(n2, t2, r2) {
          t2 = ku(t2, n2);
          for (var e2 = -1, u2 = t2.length, i2 = !1; ++e2 < u2; ) {
            var o2 = no(t2[e2]);
            if (!(i2 = n2 != null && r2(n2, o2))) break;
            n2 = n2[o2];
          }
          return i2 || ++e2 != u2 ? i2 : (u2 = n2 == null ? 0 : n2.length, !!u2 && oc(u2) && Ci(o2, u2) && (bh(n2) || dh(n2)));
        }
        function zi(n2) {
          var t2 = n2.length, r2 = new n2.constructor(t2);
          return t2 && typeof n2[0] == "string" && bl.call(n2, "index") && (r2.index = n2.index, r2.input = n2.input), r2;
        }
        function Ei(n2) {
          return typeof n2.constructor != "function" || Mi(n2) ? {} : gs(El(n2));
        }
        function Si(n2, t2, r2) {
          var e2 = n2.constructor;
          switch (t2) {
            case ft:
              return Ru(n2);
            case Nn:
            case Pn:
              return new e2(+n2);
            case ct:
              return zu(n2, r2);
            case at:
            case lt:
            case st:
            case ht:
            case pt:
            case _t:
            case vt:
            case gt:
            case yt:
              return Wu(n2, r2);
            case Gn:
              return new e2();
            case Hn:
            case rt:
              return new e2(n2);
            case nt:
              return Eu(n2);
            case tt:
              return new e2();
            case et:
              return Su(n2);
          }
        }
        function Wi(n2, t2) {
          var r2 = t2.length;
          if (!r2) return n2;
          var e2 = r2 - 1;
          return t2[e2] = (r2 > 1 ? "& " : "") + t2[e2], t2 = t2.join(r2 > 2 ? ", " : " "), n2.replace(Ut, `{
/* [wrapped with ` + t2 + `] */
`);
        }
        function Li(n2) {
          return bh(n2) || dh(n2) || !!(Cl && n2 && n2[Cl]);
        }
        function Ci(n2, t2) {
          var r2 = typeof n2;
          return t2 = t2 ?? Wn, !!t2 && (r2 == "number" || r2 != "symbol" && Vt.test(n2)) && n2 > -1 && n2 % 1 == 0 && n2 < t2;
        }
        function Ui(n2, t2, r2) {
          if (!fc(r2)) return !1;
          var e2 = typeof t2;
          return !!(e2 == "number" ? Hf(r2) && Ci(t2, r2.length) : e2 == "string" && t2 in r2) && Gf(r2[t2], n2);
        }
        function Bi(n2, t2) {
          if (bh(n2)) return !1;
          var r2 = typeof n2;
          return !(r2 != "number" && r2 != "symbol" && r2 != "boolean" && n2 != null && !bc(n2)) || zt.test(n2) || !Rt.test(n2) || t2 != null && n2 in ll(t2);
        }
        function Ti(n2) {
          var t2 = typeof n2;
          return t2 == "string" || t2 == "number" || t2 == "symbol" || t2 == "boolean" ? n2 !== "__proto__" : n2 === null;
        }
        function $i(n2) {
          var t2 = bi(n2), r2 = Z2[t2];
          if (typeof r2 != "function" || !(t2 in Ct2.prototype)) return !1;
          if (n2 === r2) return !0;
          var e2 = Os(r2);
          return !!e2 && n2 === e2[0];
        }
        function Di(n2) {
          return !!ml && ml in n2;
        }
        function Mi(n2) {
          var t2 = n2 && n2.constructor;
          return n2 === (typeof t2 == "function" && t2.prototype || gl);
        }
        function Fi(n2) {
          return n2 === n2 && !fc(n2);
        }
        function Ni(n2, t2) {
          return function(r2) {
            return r2 != null && r2[n2] === t2 && (t2 !== X || n2 in ll(r2));
          };
        }
        function Pi(n2) {
          var t2 = Cf(n2, function(n3) {
            return r2.size === fn && r2.clear(), n3;
          }), r2 = t2.cache;
          return t2;
        }
        function qi(n2, t2) {
          var r2 = n2[1], e2 = t2[1], u2 = r2 | e2, i2 = u2 < (_n | vn | mn), o2 = e2 == mn && r2 == yn || e2 == mn && r2 == xn && n2[7].length <= t2[8] || e2 == (mn | xn) && t2[7].length <= t2[8] && r2 == yn;
          if (!i2 && !o2) return n2;
          e2 & _n && (n2[2] = t2[2], u2 |= r2 & _n ? 0 : gn);
          var f2 = t2[3];
          if (f2) {
            var c2 = n2[3];
            n2[3] = c2 ? Uu(c2, f2, t2[4]) : f2, n2[4] = c2 ? N(n2[3], cn) : t2[4];
          }
          return f2 = t2[5], f2 && (c2 = n2[5], n2[5] = c2 ? Bu(c2, f2, t2[6]) : f2, n2[6] = c2 ? N(n2[5], cn) : t2[6]), f2 = t2[7], f2 && (n2[7] = f2), e2 & mn && (n2[8] = n2[8] == null ? t2[8] : Hl(n2[8], t2[8])), n2[9] == null && (n2[9] = t2[9]), n2[0] = t2[0], n2[1] = u2, n2;
        }
        function Zi(n2) {
          var t2 = [];
          if (n2 != null) for (var r2 in ll(n2)) t2.push(r2);
          return t2;
        }
        function Ki(n2) {
          return xl.call(n2);
        }
        function Vi(t2, r2, e2) {
          return r2 = Gl(r2 === X ? t2.length - 1 : r2, 0), function() {
            for (var u2 = arguments, i2 = -1, o2 = Gl(u2.length - r2, 0), f2 = il(o2); ++i2 < o2; ) f2[i2] = u2[r2 + i2];
            i2 = -1;
            for (var c2 = il(r2 + 1); ++i2 < r2; ) c2[i2] = u2[i2];
            return c2[r2] = e2(f2), n(t2, this, c2);
          };
        }
        function Gi(n2, t2) {
          return t2.length < 2 ? n2 : _e2(n2, au(t2, 0, -1));
        }
        function Hi(n2, t2) {
          for (var r2 = n2.length, e2 = Hl(t2.length, r2), u2 = Tu(n2); e2--; ) {
            var i2 = t2[e2];
            n2[e2] = Ci(i2, r2) ? u2[i2] : X;
          }
          return n2;
        }
        function Ji(n2, t2) {
          if ((t2 !== "constructor" || typeof n2[t2] != "function") && t2 != "__proto__") return n2[t2];
        }
        function Yi(n2, t2, r2) {
          var e2 = t2 + "";
          return Ls(n2, Wi(e2, ro(Ii(e2), r2)));
        }
        function Qi(n2) {
          var t2 = 0, r2 = 0;
          return function() {
            var e2 = Jl(), u2 = In - (e2 - r2);
            if (r2 = e2, u2 > 0) {
              if (++t2 >= On) return arguments[0];
            } else t2 = 0;
            return n2.apply(X, arguments);
          };
        }
        function Xi(n2, t2) {
          var r2 = -1, e2 = n2.length, u2 = e2 - 1;
          for (t2 = t2 === X ? e2 : t2; ++r2 < t2; ) {
            var i2 = tu(r2, u2), o2 = n2[i2];
            n2[i2] = n2[r2], n2[r2] = o2;
          }
          return n2.length = t2, n2;
        }
        function no(n2) {
          if (typeof n2 == "string" || bc(n2)) return n2;
          var t2 = n2 + "";
          return t2 == "0" && 1 / n2 == -Sn ? "-0" : t2;
        }
        function to(n2) {
          if (n2 != null) {
            try {
              return dl.call(n2);
            } catch {
            }
            try {
              return n2 + "";
            } catch {
            }
          }
          return "";
        }
        function ro(n2, t2) {
          return r($n, function(r2) {
            var e2 = "_." + r2[0];
            t2 & r2[1] && !o(n2, e2) && n2.push(e2);
          }), n2.sort();
        }
        function eo(n2) {
          if (n2 instanceof Ct2) return n2.clone();
          var t2 = new Y2(n2.__wrapped__, n2.__chain__);
          return t2.__actions__ = Tu(n2.__actions__), t2.__index__ = n2.__index__, t2.__values__ = n2.__values__, t2;
        }
        function uo(n2, t2, r2) {
          t2 = (r2 ? Ui(n2, t2, r2) : t2 === X) ? 1 : Gl(kc(t2), 0);
          var e2 = n2 == null ? 0 : n2.length;
          if (!e2 || t2 < 1) return [];
          for (var u2 = 0, i2 = 0, o2 = il(Fl(e2 / t2)); u2 < e2; ) o2[i2++] = au(n2, u2, u2 += t2);
          return o2;
        }
        function io(n2) {
          for (var t2 = -1, r2 = n2 == null ? 0 : n2.length, e2 = 0, u2 = []; ++t2 < r2; ) {
            var i2 = n2[t2];
            i2 && (u2[e2++] = i2);
          }
          return u2;
        }
        function oo() {
          var n2 = arguments.length;
          if (!n2) return [];
          for (var t2 = il(n2 - 1), r2 = arguments[0], e2 = n2; e2--; ) t2[e2 - 1] = arguments[e2];
          return a(bh(r2) ? Tu(r2) : [r2], ee2(t2, 1));
        }
        function fo(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          return e2 ? (t2 = r2 || t2 === X ? 1 : kc(t2), au(n2, t2 < 0 ? 0 : t2, e2)) : [];
        }
        function co(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          return e2 ? (t2 = r2 || t2 === X ? 1 : kc(t2), t2 = e2 - t2, au(n2, 0, t2 < 0 ? 0 : t2)) : [];
        }
        function ao(n2, t2) {
          return n2 && n2.length ? bu(n2, mi(t2, 3), !0, !0) : [];
        }
        function lo(n2, t2) {
          return n2 && n2.length ? bu(n2, mi(t2, 3), !0) : [];
        }
        function so(n2, t2, r2, e2) {
          var u2 = n2 == null ? 0 : n2.length;
          return u2 ? (r2 && typeof r2 != "number" && Ui(n2, t2, r2) && (r2 = 0, e2 = u2), ne2(n2, t2, r2, e2)) : [];
        }
        function ho(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          if (!e2) return -1;
          var u2 = r2 == null ? 0 : kc(r2);
          return u2 < 0 && (u2 = Gl(e2 + u2, 0)), g(n2, mi(t2, 3), u2);
        }
        function po(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          if (!e2) return -1;
          var u2 = e2 - 1;
          return r2 !== X && (u2 = kc(r2), u2 = r2 < 0 ? Gl(e2 + u2, 0) : Hl(u2, e2 - 1)), g(n2, mi(t2, 3), u2, !0);
        }
        function _o(n2) {
          return n2 != null && n2.length ? ee2(n2, 1) : [];
        }
        function vo(n2) {
          return n2 != null && n2.length ? ee2(n2, Sn) : [];
        }
        function go(n2, t2) {
          return n2 != null && n2.length ? (t2 = t2 === X ? 1 : kc(t2), ee2(n2, t2)) : [];
        }
        function yo(n2) {
          for (var t2 = -1, r2 = n2 == null ? 0 : n2.length, e2 = {}; ++t2 < r2; ) {
            var u2 = n2[t2];
            e2[u2[0]] = u2[1];
          }
          return e2;
        }
        function bo(n2) {
          return n2 && n2.length ? n2[0] : X;
        }
        function wo(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          if (!e2) return -1;
          var u2 = r2 == null ? 0 : kc(r2);
          return u2 < 0 && (u2 = Gl(e2 + u2, 0)), y(n2, t2, u2);
        }
        function mo(n2) {
          return n2 != null && n2.length ? au(n2, 0, -1) : [];
        }
        function xo(n2, t2) {
          return n2 == null ? "" : Kl.call(n2, t2);
        }
        function jo(n2) {
          var t2 = n2 == null ? 0 : n2.length;
          return t2 ? n2[t2 - 1] : X;
        }
        function Ao(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          if (!e2) return -1;
          var u2 = e2;
          return r2 !== X && (u2 = kc(r2), u2 = u2 < 0 ? Gl(e2 + u2, 0) : Hl(u2, e2 - 1)), t2 === t2 ? K(n2, t2, u2) : g(n2, b, u2, !0);
        }
        function ko2(n2, t2) {
          return n2 && n2.length ? Ge(n2, kc(t2)) : X;
        }
        function Oo(n2, t2) {
          return n2 && n2.length && t2 && t2.length ? Xe(n2, t2) : n2;
        }
        function Io(n2, t2, r2) {
          return n2 && n2.length && t2 && t2.length ? Xe(n2, t2, mi(r2, 2)) : n2;
        }
        function Ro(n2, t2, r2) {
          return n2 && n2.length && t2 && t2.length ? Xe(n2, t2, X, r2) : n2;
        }
        function zo(n2, t2) {
          var r2 = [];
          if (!n2 || !n2.length) return r2;
          var e2 = -1, u2 = [], i2 = n2.length;
          for (t2 = mi(t2, 3); ++e2 < i2; ) {
            var o2 = n2[e2];
            t2(o2, e2, n2) && (r2.push(o2), u2.push(e2));
          }
          return nu(n2, u2), r2;
        }
        function Eo(n2) {
          return n2 == null ? n2 : Xl.call(n2);
        }
        function So(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          return e2 ? (r2 && typeof r2 != "number" && Ui(n2, t2, r2) ? (t2 = 0, r2 = e2) : (t2 = t2 == null ? 0 : kc(t2), r2 = r2 === X ? e2 : kc(r2)), au(n2, t2, r2)) : [];
        }
        function Wo(n2, t2) {
          return su(n2, t2);
        }
        function Lo(n2, t2, r2) {
          return hu(n2, t2, mi(r2, 2));
        }
        function Co(n2, t2) {
          var r2 = n2 == null ? 0 : n2.length;
          if (r2) {
            var e2 = su(n2, t2);
            if (e2 < r2 && Gf(n2[e2], t2)) return e2;
          }
          return -1;
        }
        function Uo(n2, t2) {
          return su(n2, t2, !0);
        }
        function Bo(n2, t2, r2) {
          return hu(n2, t2, mi(r2, 2), !0);
        }
        function To(n2, t2) {
          if (n2 != null && n2.length) {
            var r2 = su(n2, t2, !0) - 1;
            if (Gf(n2[r2], t2)) return r2;
          }
          return -1;
        }
        function $o(n2) {
          return n2 && n2.length ? pu(n2) : [];
        }
        function Do(n2, t2) {
          return n2 && n2.length ? pu(n2, mi(t2, 2)) : [];
        }
        function Mo(n2) {
          var t2 = n2 == null ? 0 : n2.length;
          return t2 ? au(n2, 1, t2) : [];
        }
        function Fo(n2, t2, r2) {
          return n2 && n2.length ? (t2 = r2 || t2 === X ? 1 : kc(t2), au(n2, 0, t2 < 0 ? 0 : t2)) : [];
        }
        function No(n2, t2, r2) {
          var e2 = n2 == null ? 0 : n2.length;
          return e2 ? (t2 = r2 || t2 === X ? 1 : kc(t2), t2 = e2 - t2, au(n2, t2 < 0 ? 0 : t2, e2)) : [];
        }
        function Po(n2, t2) {
          return n2 && n2.length ? bu(n2, mi(t2, 3), !1, !0) : [];
        }
        function qo(n2, t2) {
          return n2 && n2.length ? bu(n2, mi(t2, 3)) : [];
        }
        function Zo(n2) {
          return n2 && n2.length ? gu(n2) : [];
        }
        function Ko(n2, t2) {
          return n2 && n2.length ? gu(n2, mi(t2, 2)) : [];
        }
        function Vo(n2, t2) {
          return t2 = typeof t2 == "function" ? t2 : X, n2 && n2.length ? gu(n2, X, t2) : [];
        }
        function Go(n2) {
          if (!n2 || !n2.length) return [];
          var t2 = 0;
          return n2 = i(n2, function(n3) {
            if (Jf(n3)) return t2 = Gl(n3.length, t2), !0;
          }), O(t2, function(t3) {
            return c(n2, m(t3));
          });
        }
        function Ho(t2, r2) {
          if (!t2 || !t2.length) return [];
          var e2 = Go(t2);
          return r2 == null ? e2 : c(e2, function(t3) {
            return n(r2, X, t3);
          });
        }
        function Jo(n2, t2) {
          return xu(n2 || [], t2 || [], Sr2);
        }
        function Yo(n2, t2) {
          return xu(n2 || [], t2 || [], fu);
        }
        function Qo(n2) {
          var t2 = Z2(n2);
          return t2.__chain__ = !0, t2;
        }
        function Xo(n2, t2) {
          return t2(n2), n2;
        }
        function nf(n2, t2) {
          return t2(n2);
        }
        function tf() {
          return Qo(this);
        }
        function rf() {
          return new Y2(this.value(), this.__chain__);
        }
        function ef() {
          this.__values__ === X && (this.__values__ = jc(this.value()));
          var n2 = this.__index__ >= this.__values__.length;
          return { done: n2, value: n2 ? X : this.__values__[this.__index__++] };
        }
        function uf() {
          return this;
        }
        function of(n2) {
          for (var t2, r2 = this; r2 instanceof J2; ) {
            var e2 = eo(r2);
            e2.__index__ = 0, e2.__values__ = X, t2 ? u2.__wrapped__ = e2 : t2 = e2;
            var u2 = e2;
            r2 = r2.__wrapped__;
          }
          return u2.__wrapped__ = n2, t2;
        }
        function ff() {
          var n2 = this.__wrapped__;
          if (n2 instanceof Ct2) {
            var t2 = n2;
            return this.__actions__.length && (t2 = new Ct2(this)), t2 = t2.reverse(), t2.__actions__.push({ func: nf, args: [Eo], thisArg: X }), new Y2(t2, this.__chain__);
          }
          return this.thru(Eo);
        }
        function cf() {
          return wu(this.__wrapped__, this.__actions__);
        }
        function af(n2, t2, r2) {
          var e2 = bh(n2) ? u : Jr2;
          return r2 && Ui(n2, t2, r2) && (t2 = X), e2(n2, mi(t2, 3));
        }
        function lf(n2, t2) {
          return (bh(n2) ? i : te2)(n2, mi(t2, 3));
        }
        function sf(n2, t2) {
          return ee2(yf(n2, t2), 1);
        }
        function hf(n2, t2) {
          return ee2(yf(n2, t2), Sn);
        }
        function pf(n2, t2, r2) {
          return r2 = r2 === X ? 1 : kc(r2), ee2(yf(n2, t2), r2);
        }
        function _f(n2, t2) {
          return (bh(n2) ? r : ys)(n2, mi(t2, 3));
        }
        function vf(n2, t2) {
          return (bh(n2) ? e : ds)(n2, mi(t2, 3));
        }
        function gf(n2, t2, r2, e2) {
          n2 = Hf(n2) ? n2 : ra(n2), r2 = r2 && !e2 ? kc(r2) : 0;
          var u2 = n2.length;
          return r2 < 0 && (r2 = Gl(u2 + r2, 0)), dc(n2) ? r2 <= u2 && n2.indexOf(t2, r2) > -1 : !!u2 && y(n2, t2, r2) > -1;
        }
        function yf(n2, t2) {
          return (bh(n2) ? c : Pe)(n2, mi(t2, 3));
        }
        function df(n2, t2, r2, e2) {
          return n2 == null ? [] : (bh(t2) || (t2 = t2 == null ? [] : [t2]), r2 = e2 ? X : r2, bh(r2) || (r2 = r2 == null ? [] : [r2]), He(n2, t2, r2));
        }
        function bf(n2, t2, r2) {
          var e2 = bh(n2) ? l : j, u2 = arguments.length < 3;
          return e2(n2, mi(t2, 4), r2, u2, ys);
        }
        function wf(n2, t2, r2) {
          var e2 = bh(n2) ? s : j, u2 = arguments.length < 3;
          return e2(n2, mi(t2, 4), r2, u2, ds);
        }
        function mf(n2, t2) {
          return (bh(n2) ? i : te2)(n2, Uf(mi(t2, 3)));
        }
        function xf(n2) {
          return (bh(n2) ? Ir2 : iu)(n2);
        }
        function jf(n2, t2, r2) {
          return t2 = (r2 ? Ui(n2, t2, r2) : t2 === X) ? 1 : kc(t2), (bh(n2) ? Rr2 : ou)(n2, t2);
        }
        function Af(n2) {
          return (bh(n2) ? zr2 : cu)(n2);
        }
        function kf(n2) {
          if (n2 == null) return 0;
          if (Hf(n2)) return dc(n2) ? V(n2) : n2.length;
          var t2 = zs(n2);
          return t2 == Gn || t2 == tt ? n2.size : Me(n2).length;
        }
        function Of(n2, t2, r2) {
          var e2 = bh(n2) ? h : lu;
          return r2 && Ui(n2, t2, r2) && (t2 = X), e2(n2, mi(t2, 3));
        }
        function If(n2, t2) {
          if (typeof t2 != "function") throw new pl(en);
          return n2 = kc(n2), function() {
            if (--n2 < 1) return t2.apply(this, arguments);
          };
        }
        function Rf(n2, t2, r2) {
          return t2 = r2 ? X : t2, t2 = n2 && t2 == null ? n2.length : t2, ai(n2, mn, X, X, X, X, t2);
        }
        function zf(n2, t2) {
          var r2;
          if (typeof t2 != "function") throw new pl(en);
          return n2 = kc(n2), function() {
            return --n2 > 0 && (r2 = t2.apply(this, arguments)), n2 <= 1 && (t2 = X), r2;
          };
        }
        function Ef(n2, t2, r2) {
          t2 = r2 ? X : t2;
          var e2 = ai(n2, yn, X, X, X, X, X, t2);
          return e2.placeholder = Ef.placeholder, e2;
        }
        function Sf(n2, t2, r2) {
          t2 = r2 ? X : t2;
          var e2 = ai(n2, dn, X, X, X, X, X, t2);
          return e2.placeholder = Sf.placeholder, e2;
        }
        function Wf(n2, t2, r2) {
          function e2(t3) {
            var r3 = h2, e3 = p3;
            return h2 = p3 = X, d2 = t3, v2 = n2.apply(e3, r3);
          }
          function u2(n3) {
            return d2 = n3, g2 = Ws(f2, t2), b2 ? e2(n3) : v2;
          }
          function i2(n3) {
            var r3 = n3 - y2, e3 = n3 - d2, u3 = t2 - r3;
            return w2 ? Hl(u3, _3 - e3) : u3;
          }
          function o2(n3) {
            var r3 = n3 - y2, e3 = n3 - d2;
            return y2 === X || r3 >= t2 || r3 < 0 || w2 && e3 >= _3;
          }
          function f2() {
            var n3 = fh();
            return o2(n3) ? c2(n3) : (g2 = Ws(f2, i2(n3)), X);
          }
          function c2(n3) {
            return g2 = X, m2 && h2 ? e2(n3) : (h2 = p3 = X, v2);
          }
          function a2() {
            g2 !== X && As(g2), d2 = 0, h2 = y2 = p3 = g2 = X;
          }
          function l2() {
            return g2 === X ? v2 : c2(fh());
          }
          function s2() {
            var n3 = fh(), r3 = o2(n3);
            if (h2 = arguments, p3 = this, y2 = n3, r3) {
              if (g2 === X) return u2(y2);
              if (w2) return As(g2), g2 = Ws(f2, t2), e2(y2);
            }
            return g2 === X && (g2 = Ws(f2, t2)), v2;
          }
          var h2, p3, _3, v2, g2, y2, d2 = 0, b2 = !1, w2 = !1, m2 = !0;
          if (typeof n2 != "function") throw new pl(en);
          return t2 = Ic(t2) || 0, fc(r2) && (b2 = !!r2.leading, w2 = "maxWait" in r2, _3 = w2 ? Gl(Ic(r2.maxWait) || 0, t2) : _3, m2 = "trailing" in r2 ? !!r2.trailing : m2), s2.cancel = a2, s2.flush = l2, s2;
        }
        function Lf(n2) {
          return ai(n2, jn);
        }
        function Cf(n2, t2) {
          if (typeof n2 != "function" || t2 != null && typeof t2 != "function") throw new pl(en);
          var r2 = function() {
            var e2 = arguments, u2 = t2 ? t2.apply(this, e2) : e2[0], i2 = r2.cache;
            if (i2.has(u2)) return i2.get(u2);
            var o2 = n2.apply(this, e2);
            return r2.cache = i2.set(u2, o2) || i2, o2;
          };
          return r2.cache = new (Cf.Cache || sr2)(), r2;
        }
        function Uf(n2) {
          if (typeof n2 != "function") throw new pl(en);
          return function() {
            var t2 = arguments;
            switch (t2.length) {
              case 0:
                return !n2.call(this);
              case 1:
                return !n2.call(this, t2[0]);
              case 2:
                return !n2.call(this, t2[0], t2[1]);
              case 3:
                return !n2.call(this, t2[0], t2[1], t2[2]);
            }
            return !n2.apply(this, t2);
          };
        }
        function Bf(n2) {
          return zf(2, n2);
        }
        function Tf(n2, t2) {
          if (typeof n2 != "function") throw new pl(en);
          return t2 = t2 === X ? t2 : kc(t2), uu(n2, t2);
        }
        function $f(t2, r2) {
          if (typeof t2 != "function") throw new pl(en);
          return r2 = r2 == null ? 0 : Gl(kc(r2), 0), uu(function(e2) {
            var u2 = e2[r2], i2 = Ou(e2, 0, r2);
            return u2 && a(i2, u2), n(t2, this, i2);
          });
        }
        function Df(n2, t2, r2) {
          var e2 = !0, u2 = !0;
          if (typeof n2 != "function") throw new pl(en);
          return fc(r2) && (e2 = "leading" in r2 ? !!r2.leading : e2, u2 = "trailing" in r2 ? !!r2.trailing : u2), Wf(n2, t2, { leading: e2, maxWait: t2, trailing: u2 });
        }
        function Mf(n2) {
          return Rf(n2, 1);
        }
        function Ff(n2, t2) {
          return ph(Au(t2), n2);
        }
        function Nf() {
          if (!arguments.length) return [];
          var n2 = arguments[0];
          return bh(n2) ? n2 : [n2];
        }
        function Pf(n2) {
          return Fr2(n2, sn);
        }
        function qf(n2, t2) {
          return t2 = typeof t2 == "function" ? t2 : X, Fr2(n2, sn, t2);
        }
        function Zf(n2) {
          return Fr2(n2, an | sn);
        }
        function Kf(n2, t2) {
          return t2 = typeof t2 == "function" ? t2 : X, Fr2(n2, an | sn, t2);
        }
        function Vf(n2, t2) {
          return t2 == null || Pr2(n2, t2, Pc(t2));
        }
        function Gf(n2, t2) {
          return n2 === t2 || n2 !== n2 && t2 !== t2;
        }
        function Hf(n2) {
          return n2 != null && oc(n2.length) && !uc(n2);
        }
        function Jf(n2) {
          return cc(n2) && Hf(n2);
        }
        function Yf(n2) {
          return n2 === !0 || n2 === !1 || cc(n2) && we(n2) == Nn;
        }
        function Qf(n2) {
          return cc(n2) && n2.nodeType === 1 && !gc(n2);
        }
        function Xf(n2) {
          if (n2 == null) return !0;
          if (Hf(n2) && (bh(n2) || typeof n2 == "string" || typeof n2.splice == "function" || mh(n2) || Oh(n2) || dh(n2))) return !n2.length;
          var t2 = zs(n2);
          if (t2 == Gn || t2 == tt) return !n2.size;
          if (Mi(n2)) return !Me(n2).length;
          for (var r2 in n2) if (bl.call(n2, r2)) return !1;
          return !0;
        }
        function nc(n2, t2) {
          return Se(n2, t2);
        }
        function tc(n2, t2, r2) {
          r2 = typeof r2 == "function" ? r2 : X;
          var e2 = r2 ? r2(n2, t2) : X;
          return e2 === X ? Se(n2, t2, X, r2) : !!e2;
        }
        function rc(n2) {
          if (!cc(n2)) return !1;
          var t2 = we(n2);
          return t2 == Zn || t2 == qn || typeof n2.message == "string" && typeof n2.name == "string" && !gc(n2);
        }
        function ec(n2) {
          return typeof n2 == "number" && Zl(n2);
        }
        function uc(n2) {
          if (!fc(n2)) return !1;
          var t2 = we(n2);
          return t2 == Kn || t2 == Vn || t2 == Fn || t2 == Xn;
        }
        function ic(n2) {
          return typeof n2 == "number" && n2 == kc(n2);
        }
        function oc(n2) {
          return typeof n2 == "number" && n2 > -1 && n2 % 1 == 0 && n2 <= Wn;
        }
        function fc(n2) {
          var t2 = typeof n2;
          return n2 != null && (t2 == "object" || t2 == "function");
        }
        function cc(n2) {
          return n2 != null && typeof n2 == "object";
        }
        function ac(n2, t2) {
          return n2 === t2 || Ce(n2, t2, ji(t2));
        }
        function lc(n2, t2, r2) {
          return r2 = typeof r2 == "function" ? r2 : X, Ce(n2, t2, ji(t2), r2);
        }
        function sc(n2) {
          return vc(n2) && n2 != +n2;
        }
        function hc(n2) {
          if (Es(n2)) throw new fl(rn);
          return Ue(n2);
        }
        function pc(n2) {
          return n2 === null;
        }
        function _c(n2) {
          return n2 == null;
        }
        function vc(n2) {
          return typeof n2 == "number" || cc(n2) && we(n2) == Hn;
        }
        function gc(n2) {
          if (!cc(n2) || we(n2) != Yn) return !1;
          var t2 = El(n2);
          if (t2 === null) return !0;
          var r2 = bl.call(t2, "constructor") && t2.constructor;
          return typeof r2 == "function" && r2 instanceof r2 && dl.call(r2) == jl;
        }
        function yc(n2) {
          return ic(n2) && n2 >= -Wn && n2 <= Wn;
        }
        function dc(n2) {
          return typeof n2 == "string" || !bh(n2) && cc(n2) && we(n2) == rt;
        }
        function bc(n2) {
          return typeof n2 == "symbol" || cc(n2) && we(n2) == et;
        }
        function wc(n2) {
          return n2 === X;
        }
        function mc(n2) {
          return cc(n2) && zs(n2) == it;
        }
        function xc(n2) {
          return cc(n2) && we(n2) == ot;
        }
        function jc(n2) {
          if (!n2) return [];
          if (Hf(n2)) return dc(n2) ? G(n2) : Tu(n2);
          if (Ul && n2[Ul]) return D(n2[Ul]());
          var t2 = zs(n2);
          return (t2 == Gn ? M : t2 == tt ? P : ra)(n2);
        }
        function Ac(n2) {
          return n2 ? (n2 = Ic(n2), n2 === Sn || n2 === -Sn ? (n2 < 0 ? -1 : 1) * Ln : n2 === n2 ? n2 : 0) : n2 === 0 ? n2 : 0;
        }
        function kc(n2) {
          var t2 = Ac(n2), r2 = t2 % 1;
          return t2 === t2 ? r2 ? t2 - r2 : t2 : 0;
        }
        function Oc(n2) {
          return n2 ? Mr2(kc(n2), 0, Un) : 0;
        }
        function Ic(n2) {
          if (typeof n2 == "number") return n2;
          if (bc(n2)) return Cn;
          if (fc(n2)) {
            var t2 = typeof n2.valueOf == "function" ? n2.valueOf() : n2;
            n2 = fc(t2) ? t2 + "" : t2;
          }
          if (typeof n2 != "string") return n2 === 0 ? n2 : +n2;
          n2 = R(n2);
          var r2 = qt.test(n2);
          return r2 || Kt.test(n2) ? Xr(n2.slice(2), r2 ? 2 : 8) : Pt.test(n2) ? Cn : +n2;
        }
        function Rc(n2) {
          return $u(n2, qc(n2));
        }
        function zc(n2) {
          return n2 ? Mr2(kc(n2), -Wn, Wn) : n2 === 0 ? n2 : 0;
        }
        function Ec(n2) {
          return n2 == null ? "" : vu(n2);
        }
        function Sc(n2, t2) {
          var r2 = gs(n2);
          return t2 == null ? r2 : Cr2(r2, t2);
        }
        function Wc(n2, t2) {
          return v(n2, mi(t2, 3), ue2);
        }
        function Lc(n2, t2) {
          return v(n2, mi(t2, 3), oe2);
        }
        function Cc(n2, t2) {
          return n2 == null ? n2 : bs(n2, mi(t2, 3), qc);
        }
        function Uc(n2, t2) {
          return n2 == null ? n2 : ws(n2, mi(t2, 3), qc);
        }
        function Bc(n2, t2) {
          return n2 && ue2(n2, mi(t2, 3));
        }
        function Tc(n2, t2) {
          return n2 && oe2(n2, mi(t2, 3));
        }
        function $c(n2) {
          return n2 == null ? [] : fe2(n2, Pc(n2));
        }
        function Dc(n2) {
          return n2 == null ? [] : fe2(n2, qc(n2));
        }
        function Mc(n2, t2, r2) {
          var e2 = n2 == null ? X : _e2(n2, t2);
          return e2 === X ? r2 : e2;
        }
        function Fc(n2, t2) {
          return n2 != null && Ri(n2, t2, xe);
        }
        function Nc(n2, t2) {
          return n2 != null && Ri(n2, t2, je);
        }
        function Pc(n2) {
          return Hf(n2) ? Or2(n2) : Me(n2);
        }
        function qc(n2) {
          return Hf(n2) ? Or2(n2, !0) : Fe(n2);
        }
        function Zc(n2, t2) {
          var r2 = {};
          return t2 = mi(t2, 3), ue2(n2, function(n3, e2, u2) {
            Br2(r2, t2(n3, e2, u2), n3);
          }), r2;
        }
        function Kc(n2, t2) {
          var r2 = {};
          return t2 = mi(t2, 3), ue2(n2, function(n3, e2, u2) {
            Br2(r2, e2, t2(n3, e2, u2));
          }), r2;
        }
        function Vc(n2, t2) {
          return Gc(n2, Uf(mi(t2)));
        }
        function Gc(n2, t2) {
          if (n2 == null) return {};
          var r2 = c(di(n2), function(n3) {
            return [n3];
          });
          return t2 = mi(t2), Ye(n2, r2, function(n3, r3) {
            return t2(n3, r3[0]);
          });
        }
        function Hc(n2, t2, r2) {
          t2 = ku(t2, n2);
          var e2 = -1, u2 = t2.length;
          for (u2 || (u2 = 1, n2 = X); ++e2 < u2; ) {
            var i2 = n2 == null ? X : n2[no(t2[e2])];
            i2 === X && (e2 = u2, i2 = r2), n2 = uc(i2) ? i2.call(n2) : i2;
          }
          return n2;
        }
        function Jc(n2, t2, r2) {
          return n2 == null ? n2 : fu(n2, t2, r2);
        }
        function Yc(n2, t2, r2, e2) {
          return e2 = typeof e2 == "function" ? e2 : X, n2 == null ? n2 : fu(n2, t2, r2, e2);
        }
        function Qc(n2, t2, e2) {
          var u2 = bh(n2), i2 = u2 || mh(n2) || Oh(n2);
          if (t2 = mi(t2, 4), e2 == null) {
            var o2 = n2 && n2.constructor;
            e2 = i2 ? u2 ? new o2() : [] : fc(n2) && uc(o2) ? gs(El(n2)) : {};
          }
          return (i2 ? r : ue2)(n2, function(n3, r2, u3) {
            return t2(e2, n3, r2, u3);
          }), e2;
        }
        function Xc(n2, t2) {
          return n2 == null || yu(n2, t2);
        }
        function na(n2, t2, r2) {
          return n2 == null ? n2 : du(n2, t2, Au(r2));
        }
        function ta(n2, t2, r2, e2) {
          return e2 = typeof e2 == "function" ? e2 : X, n2 == null ? n2 : du(n2, t2, Au(r2), e2);
        }
        function ra(n2) {
          return n2 == null ? [] : E(n2, Pc(n2));
        }
        function ea(n2) {
          return n2 == null ? [] : E(n2, qc(n2));
        }
        function ua(n2, t2, r2) {
          return r2 === X && (r2 = t2, t2 = X), r2 !== X && (r2 = Ic(r2), r2 = r2 === r2 ? r2 : 0), t2 !== X && (t2 = Ic(t2), t2 = t2 === t2 ? t2 : 0), Mr2(Ic(n2), t2, r2);
        }
        function ia(n2, t2, r2) {
          return t2 = Ac(t2), r2 === X ? (r2 = t2, t2 = 0) : r2 = Ac(r2), n2 = Ic(n2), Ae(n2, t2, r2);
        }
        function oa(n2, t2, r2) {
          if (r2 && typeof r2 != "boolean" && Ui(n2, t2, r2) && (t2 = r2 = X), r2 === X && (typeof t2 == "boolean" ? (r2 = t2, t2 = X) : typeof n2 == "boolean" && (r2 = n2, n2 = X)), n2 === X && t2 === X ? (n2 = 0, t2 = 1) : (n2 = Ac(n2), t2 === X ? (t2 = n2, n2 = 0) : t2 = Ac(t2)), n2 > t2) {
            var e2 = n2;
            n2 = t2, t2 = e2;
          }
          if (r2 || n2 % 1 || t2 % 1) {
            var u2 = Ql();
            return Hl(n2 + u2 * (t2 - n2 + Qr("1e-" + ((u2 + "").length - 1))), t2);
          }
          return tu(n2, t2);
        }
        function fa(n2) {
          return Qh(Ec(n2).toLowerCase());
        }
        function ca(n2) {
          return n2 = Ec(n2), n2 && n2.replace(Gt, ve).replace(Dr, "");
        }
        function aa(n2, t2, r2) {
          n2 = Ec(n2), t2 = vu(t2);
          var e2 = n2.length;
          r2 = r2 === X ? e2 : Mr2(kc(r2), 0, e2);
          var u2 = r2;
          return r2 -= t2.length, r2 >= 0 && n2.slice(r2, u2) == t2;
        }
        function la(n2) {
          return n2 = Ec(n2), n2 && At.test(n2) ? n2.replace(xt, ge) : n2;
        }
        function sa(n2) {
          return n2 = Ec(n2), n2 && Wt.test(n2) ? n2.replace(St, "\\$&") : n2;
        }
        function ha(n2, t2, r2) {
          n2 = Ec(n2), t2 = kc(t2);
          var e2 = t2 ? V(n2) : 0;
          if (!t2 || e2 >= t2) return n2;
          var u2 = (t2 - e2) / 2;
          return ri(Nl(u2), r2) + n2 + ri(Fl(u2), r2);
        }
        function pa(n2, t2, r2) {
          n2 = Ec(n2), t2 = kc(t2);
          var e2 = t2 ? V(n2) : 0;
          return t2 && e2 < t2 ? n2 + ri(t2 - e2, r2) : n2;
        }
        function _a(n2, t2, r2) {
          n2 = Ec(n2), t2 = kc(t2);
          var e2 = t2 ? V(n2) : 0;
          return t2 && e2 < t2 ? ri(t2 - e2, r2) + n2 : n2;
        }
        function va(n2, t2, r2) {
          return r2 || t2 == null ? t2 = 0 : t2 && (t2 = +t2), Yl(Ec(n2).replace(Lt, ""), t2 || 0);
        }
        function ga2(n2, t2, r2) {
          return t2 = (r2 ? Ui(n2, t2, r2) : t2 === X) ? 1 : kc(t2), eu(Ec(n2), t2);
        }
        function ya() {
          var n2 = arguments, t2 = Ec(n2[0]);
          return n2.length < 3 ? t2 : t2.replace(n2[1], n2[2]);
        }
        function da(n2, t2, r2) {
          return r2 && typeof r2 != "number" && Ui(n2, t2, r2) && (t2 = r2 = X), (r2 = r2 === X ? Un : r2 >>> 0) ? (n2 = Ec(n2), n2 && (typeof t2 == "string" || t2 != null && !Ah(t2)) && (t2 = vu(t2), !t2 && T(n2)) ? Ou(G(n2), 0, r2) : n2.split(t2, r2)) : [];
        }
        function ba(n2, t2, r2) {
          return n2 = Ec(n2), r2 = r2 == null ? 0 : Mr2(kc(r2), 0, n2.length), t2 = vu(t2), n2.slice(r2, r2 + t2.length) == t2;
        }
        function wa(n2, t2, r2) {
          var e2 = Z2.templateSettings;
          r2 && Ui(n2, t2, r2) && (t2 = X), n2 = Ec(n2), t2 = Sh({}, t2, e2, li);
          var u2, i2, o2 = Sh({}, t2.imports, e2.imports, li), f2 = Pc(o2), c2 = E(o2, f2), a2 = 0, l2 = t2.interpolate || Ht, s2 = "__p += '", h2 = sl((t2.escape || Ht).source + "|" + l2.source + "|" + (l2 === It ? Ft : Ht).source + "|" + (t2.evaluate || Ht).source + "|$", "g"), p3 = "//# sourceURL=" + (bl.call(t2, "sourceURL") ? (t2.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zr + "]") + `
`;
          n2.replace(h2, function(t3, r3, e3, o3, f3, c3) {
            return e3 || (e3 = o3), s2 += n2.slice(a2, c3).replace(Jt, U), r3 && (u2 = !0, s2 += `' +
__e(` + r3 + `) +
'`), f3 && (i2 = !0, s2 += `';
` + f3 + `;
__p += '`), e3 && (s2 += `' +
((__t = (` + e3 + `)) == null ? '' : __t) +
'`), a2 = c3 + t3.length, t3;
          }), s2 += `';
`;
          var _3 = bl.call(t2, "variable") && t2.variable;
          if (_3) {
            if (Dt.test(_3)) throw new fl(un);
          } else s2 = `with (obj) {
` + s2 + `
}
`;
          s2 = (i2 ? s2.replace(dt, "") : s2).replace(bt, "$1").replace(wt, "$1;"), s2 = "function(" + (_3 || "obj") + `) {
` + (_3 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (u2 ? ", __e = _.escape" : "") + (i2 ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + s2 + `return __p
}`;
          var v2 = Xh(function() {
            return cl(f2, p3 + "return " + s2).apply(X, c2);
          });
          if (v2.source = s2, rc(v2)) throw v2;
          return v2;
        }
        function ma(n2) {
          return Ec(n2).toLowerCase();
        }
        function xa(n2) {
          return Ec(n2).toUpperCase();
        }
        function ja(n2, t2, r2) {
          if (n2 = Ec(n2), n2 && (r2 || t2 === X)) return R(n2);
          if (!n2 || !(t2 = vu(t2))) return n2;
          var e2 = G(n2), u2 = G(t2);
          return Ou(e2, W(e2, u2), L(e2, u2) + 1).join("");
        }
        function Aa(n2, t2, r2) {
          if (n2 = Ec(n2), n2 && (r2 || t2 === X)) return n2.slice(0, H(n2) + 1);
          if (!n2 || !(t2 = vu(t2))) return n2;
          var e2 = G(n2);
          return Ou(e2, 0, L(e2, G(t2)) + 1).join("");
        }
        function ka(n2, t2, r2) {
          if (n2 = Ec(n2), n2 && (r2 || t2 === X)) return n2.replace(Lt, "");
          if (!n2 || !(t2 = vu(t2))) return n2;
          var e2 = G(n2);
          return Ou(e2, W(e2, G(t2))).join("");
        }
        function Oa(n2, t2) {
          var r2 = An, e2 = kn;
          if (fc(t2)) {
            var u2 = "separator" in t2 ? t2.separator : u2;
            r2 = "length" in t2 ? kc(t2.length) : r2, e2 = "omission" in t2 ? vu(t2.omission) : e2;
          }
          n2 = Ec(n2);
          var i2 = n2.length;
          if (T(n2)) {
            var o2 = G(n2);
            i2 = o2.length;
          }
          if (r2 >= i2) return n2;
          var f2 = r2 - V(e2);
          if (f2 < 1) return e2;
          var c2 = o2 ? Ou(o2, 0, f2).join("") : n2.slice(0, f2);
          if (u2 === X) return c2 + e2;
          if (o2 && (f2 += c2.length - f2), Ah(u2)) {
            if (n2.slice(f2).search(u2)) {
              var a2, l2 = c2;
              for (u2.global || (u2 = sl(u2.source, Ec(Nt.exec(u2)) + "g")), u2.lastIndex = 0; a2 = u2.exec(l2); ) var s2 = a2.index;
              c2 = c2.slice(0, s2 === X ? f2 : s2);
            }
          } else if (n2.indexOf(vu(u2), f2) != f2) {
            var h2 = c2.lastIndexOf(u2);
            h2 > -1 && (c2 = c2.slice(0, h2));
          }
          return c2 + e2;
        }
        function Ia(n2) {
          return n2 = Ec(n2), n2 && jt.test(n2) ? n2.replace(mt, ye) : n2;
        }
        function Ra(n2, t2, r2) {
          return n2 = Ec(n2), t2 = r2 ? X : t2, t2 === X ? $(n2) ? Q(n2) : _2(n2) : n2.match(t2) || [];
        }
        function za(t2) {
          var r2 = t2 == null ? 0 : t2.length, e2 = mi();
          return t2 = r2 ? c(t2, function(n2) {
            if (typeof n2[1] != "function") throw new pl(en);
            return [e2(n2[0]), n2[1]];
          }) : [], uu(function(e3) {
            for (var u2 = -1; ++u2 < r2; ) {
              var i2 = t2[u2];
              if (n(i2[0], this, e3)) return n(i2[1], this, e3);
            }
          });
        }
        function Ea(n2) {
          return Nr2(Fr2(n2, an));
        }
        function Sa(n2) {
          return function() {
            return n2;
          };
        }
        function Wa(n2, t2) {
          return n2 == null || n2 !== n2 ? t2 : n2;
        }
        function La(n2) {
          return n2;
        }
        function Ca(n2) {
          return De(typeof n2 == "function" ? n2 : Fr2(n2, an));
        }
        function Ua(n2) {
          return qe(Fr2(n2, an));
        }
        function Ba(n2, t2) {
          return Ze(n2, Fr2(t2, an));
        }
        function Ta(n2, t2, e2) {
          var u2 = Pc(t2), i2 = fe2(t2, u2);
          e2 != null || fc(t2) && (i2.length || !u2.length) || (e2 = t2, t2 = n2, n2 = this, i2 = fe2(t2, Pc(t2)));
          var o2 = !(fc(e2) && "chain" in e2 && !e2.chain), f2 = uc(n2);
          return r(i2, function(r2) {
            var e3 = t2[r2];
            n2[r2] = e3, f2 && (n2.prototype[r2] = function() {
              var t3 = this.__chain__;
              if (o2 || t3) {
                var r3 = n2(this.__wrapped__);
                return (r3.__actions__ = Tu(this.__actions__)).push({ func: e3, args: arguments, thisArg: n2 }), r3.__chain__ = t3, r3;
              }
              return e3.apply(n2, a([this.value()], arguments));
            });
          }), n2;
        }
        function $a() {
          return re._ === this && (re._ = Al), this;
        }
        function Da() {
        }
        function Ma(n2) {
          return n2 = kc(n2), uu(function(t2) {
            return Ge(t2, n2);
          });
        }
        function Fa(n2) {
          return Bi(n2) ? m(no(n2)) : Qe(n2);
        }
        function Na(n2) {
          return function(t2) {
            return n2 == null ? X : _e2(n2, t2);
          };
        }
        function Pa() {
          return [];
        }
        function qa() {
          return !1;
        }
        function Za() {
          return {};
        }
        function Ka() {
          return "";
        }
        function Va() {
          return !0;
        }
        function Ga(n2, t2) {
          if (n2 = kc(n2), n2 < 1 || n2 > Wn) return [];
          var r2 = Un, e2 = Hl(n2, Un);
          t2 = mi(t2), n2 -= Un;
          for (var u2 = O(e2, t2); ++r2 < n2; ) t2(r2);
          return u2;
        }
        function Ha(n2) {
          return bh(n2) ? c(n2, no) : bc(n2) ? [n2] : Tu(Cs(Ec(n2)));
        }
        function Ja(n2) {
          var t2 = ++wl;
          return Ec(n2) + t2;
        }
        function Ya(n2) {
          return n2 && n2.length ? Yr2(n2, La, me) : X;
        }
        function Qa(n2, t2) {
          return n2 && n2.length ? Yr2(n2, mi(t2, 2), me) : X;
        }
        function Xa(n2) {
          return w(n2, La);
        }
        function nl(n2, t2) {
          return w(n2, mi(t2, 2));
        }
        function tl(n2) {
          return n2 && n2.length ? Yr2(n2, La, Ne) : X;
        }
        function rl(n2, t2) {
          return n2 && n2.length ? Yr2(n2, mi(t2, 2), Ne) : X;
        }
        function el(n2) {
          return n2 && n2.length ? k(n2, La) : 0;
        }
        function ul(n2, t2) {
          return n2 && n2.length ? k(n2, mi(t2, 2)) : 0;
        }
        x2 = x2 == null ? re : be.defaults(re.Object(), x2, be.pick(re, qr));
        var il = x2.Array, ol = x2.Date, fl = x2.Error, cl = x2.Function, al = x2.Math, ll = x2.Object, sl = x2.RegExp, hl = x2.String, pl = x2.TypeError, _l = il.prototype, vl = cl.prototype, gl = ll.prototype, yl = x2["__core-js_shared__"], dl = vl.toString, bl = gl.hasOwnProperty, wl = 0, ml = (function() {
          var n2 = /[^.]+$/.exec(yl && yl.keys && yl.keys.IE_PROTO || "");
          return n2 ? "Symbol(src)_1." + n2 : "";
        })(), xl = gl.toString, jl = dl.call(ll), Al = re._, kl = sl("^" + dl.call(bl).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ol = ie ? x2.Buffer : X, Il = x2.Symbol, Rl = x2.Uint8Array, zl = Ol ? Ol.allocUnsafe : X, El = F(ll.getPrototypeOf, ll), Sl = ll.create, Wl = gl.propertyIsEnumerable, Ll = _l.splice, Cl = Il ? Il.isConcatSpreadable : X, Ul = Il ? Il.iterator : X, Bl = Il ? Il.toStringTag : X, Tl = (function() {
          try {
            var n2 = Ai(ll, "defineProperty");
            return n2({}, "", {}), n2;
          } catch {
          }
        })(), $l = x2.clearTimeout !== re.clearTimeout && x2.clearTimeout, Dl = ol && ol.now !== re.Date.now && ol.now, Ml = x2.setTimeout !== re.setTimeout && x2.setTimeout, Fl = al.ceil, Nl = al.floor, Pl = ll.getOwnPropertySymbols, ql = Ol ? Ol.isBuffer : X, Zl = x2.isFinite, Kl = _l.join, Vl = F(ll.keys, ll), Gl = al.max, Hl = al.min, Jl = ol.now, Yl = x2.parseInt, Ql = al.random, Xl = _l.reverse, ns = Ai(x2, "DataView"), ts = Ai(x2, "Map"), rs = Ai(x2, "Promise"), es = Ai(x2, "Set"), us = Ai(x2, "WeakMap"), is = Ai(ll, "create"), os = us && new us(), fs = {}, cs = to(ns), as = to(ts), ls = to(rs), ss = to(es), hs = to(us), ps = Il ? Il.prototype : X, _s = ps ? ps.valueOf : X, vs = ps ? ps.toString : X, gs = /* @__PURE__ */ (function() {
          function n2() {
          }
          return function(t2) {
            if (!fc(t2)) return {};
            if (Sl) return Sl(t2);
            n2.prototype = t2;
            var r2 = new n2();
            return n2.prototype = X, r2;
          };
        })();
        Z2.templateSettings = { escape: kt, evaluate: Ot, interpolate: It, variable: "", imports: { _: Z2 } }, Z2.prototype = J2.prototype, Z2.prototype.constructor = Z2, Y2.prototype = gs(J2.prototype), Y2.prototype.constructor = Y2, Ct2.prototype = gs(J2.prototype), Ct2.prototype.constructor = Ct2, Xt2.prototype.clear = nr2, Xt2.prototype.delete = tr2, Xt2.prototype.get = rr2, Xt2.prototype.has = er2, Xt2.prototype.set = ur2, ir2.prototype.clear = or2, ir2.prototype.delete = fr2, ir2.prototype.get = cr2, ir2.prototype.has = ar2, ir2.prototype.set = lr2, sr2.prototype.clear = hr2, sr2.prototype.delete = pr2, sr2.prototype.get = _r2, sr2.prototype.has = vr2, sr2.prototype.set = gr2, yr2.prototype.add = yr2.prototype.push = dr2, yr2.prototype.has = br2, wr2.prototype.clear = mr2, wr2.prototype.delete = xr2, wr2.prototype.get = jr2, wr2.prototype.has = Ar2, wr2.prototype.set = kr2;
        var ys = Pu(ue2), ds = Pu(oe2, !0), bs = qu(), ws = qu(!0), ms = os ? function(n2, t2) {
          return os.set(n2, t2), n2;
        } : La, xs = Tl ? function(n2, t2) {
          return Tl(n2, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Sa(t2),
            writable: !0
          });
        } : La, js = uu, As = $l || function(n2) {
          return re.clearTimeout(n2);
        }, ks = es && 1 / P(new es([, -0]))[1] == Sn ? function(n2) {
          return new es(n2);
        } : Da, Os = os ? function(n2) {
          return os.get(n2);
        } : Da, Is = Pl ? function(n2) {
          return n2 == null ? [] : (n2 = ll(n2), i(Pl(n2), function(t2) {
            return Wl.call(n2, t2);
          }));
        } : Pa, Rs = Pl ? function(n2) {
          for (var t2 = []; n2; ) a(t2, Is(n2)), n2 = El(n2);
          return t2;
        } : Pa, zs = we;
        (ns && zs(new ns(new ArrayBuffer(1))) != ct || ts && zs(new ts()) != Gn || rs && zs(rs.resolve()) != Qn || es && zs(new es()) != tt || us && zs(new us()) != it) && (zs = function(n2) {
          var t2 = we(n2), r2 = t2 == Yn ? n2.constructor : X, e2 = r2 ? to(r2) : "";
          if (e2) switch (e2) {
            case cs:
              return ct;
            case as:
              return Gn;
            case ls:
              return Qn;
            case ss:
              return tt;
            case hs:
              return it;
          }
          return t2;
        });
        var Es = yl ? uc : qa, Ss = Qi(ms), Ws = Ml || function(n2, t2) {
          return re.setTimeout(n2, t2);
        }, Ls = Qi(xs), Cs = Pi(function(n2) {
          var t2 = [];
          return n2.charCodeAt(0) === 46 && t2.push(""), n2.replace(Et, function(n3, r2, e2, u2) {
            t2.push(e2 ? u2.replace(Mt, "$1") : r2 || n3);
          }), t2;
        }), Us = uu(function(n2, t2) {
          return Jf(n2) ? Hr2(n2, ee2(t2, 1, Jf, !0)) : [];
        }), Bs = uu(function(n2, t2) {
          var r2 = jo(t2);
          return Jf(r2) && (r2 = X), Jf(n2) ? Hr2(n2, ee2(t2, 1, Jf, !0), mi(r2, 2)) : [];
        }), Ts = uu(function(n2, t2) {
          var r2 = jo(t2);
          return Jf(r2) && (r2 = X), Jf(n2) ? Hr2(n2, ee2(t2, 1, Jf, !0), X, r2) : [];
        }), $s = uu(function(n2) {
          var t2 = c(n2, ju);
          return t2.length && t2[0] === n2[0] ? ke(t2) : [];
        }), Ds = uu(function(n2) {
          var t2 = jo(n2), r2 = c(n2, ju);
          return t2 === jo(r2) ? t2 = X : r2.pop(), r2.length && r2[0] === n2[0] ? ke(r2, mi(t2, 2)) : [];
        }), Ms = uu(function(n2) {
          var t2 = jo(n2), r2 = c(n2, ju);
          return t2 = typeof t2 == "function" ? t2 : X, t2 && r2.pop(), r2.length && r2[0] === n2[0] ? ke(r2, X, t2) : [];
        }), Fs = uu(Oo), Ns = gi(function(n2, t2) {
          var r2 = n2 == null ? 0 : n2.length, e2 = Tr2(n2, t2);
          return nu(n2, c(t2, function(n3) {
            return Ci(n3, r2) ? +n3 : n3;
          }).sort(Lu)), e2;
        }), Ps = uu(function(n2) {
          return gu(ee2(n2, 1, Jf, !0));
        }), qs = uu(function(n2) {
          var t2 = jo(n2);
          return Jf(t2) && (t2 = X), gu(ee2(n2, 1, Jf, !0), mi(t2, 2));
        }), Zs = uu(function(n2) {
          var t2 = jo(n2);
          return t2 = typeof t2 == "function" ? t2 : X, gu(ee2(n2, 1, Jf, !0), X, t2);
        }), Ks = uu(function(n2, t2) {
          return Jf(n2) ? Hr2(n2, t2) : [];
        }), Vs = uu(function(n2) {
          return mu(i(n2, Jf));
        }), Gs = uu(function(n2) {
          var t2 = jo(n2);
          return Jf(t2) && (t2 = X), mu(i(n2, Jf), mi(t2, 2));
        }), Hs = uu(function(n2) {
          var t2 = jo(n2);
          return t2 = typeof t2 == "function" ? t2 : X, mu(i(n2, Jf), X, t2);
        }), Js = uu(Go), Ys = uu(function(n2) {
          var t2 = n2.length, r2 = t2 > 1 ? n2[t2 - 1] : X;
          return r2 = typeof r2 == "function" ? (n2.pop(), r2) : X, Ho(n2, r2);
        }), Qs = gi(function(n2) {
          var t2 = n2.length, r2 = t2 ? n2[0] : 0, e2 = this.__wrapped__, u2 = function(t3) {
            return Tr2(t3, n2);
          };
          return !(t2 > 1 || this.__actions__.length) && e2 instanceof Ct2 && Ci(r2) ? (e2 = e2.slice(r2, +r2 + (t2 ? 1 : 0)), e2.__actions__.push({ func: nf, args: [u2], thisArg: X }), new Y2(e2, this.__chain__).thru(function(n3) {
            return t2 && !n3.length && n3.push(X), n3;
          })) : this.thru(u2);
        }), Xs = Fu(function(n2, t2, r2) {
          bl.call(n2, r2) ? ++n2[r2] : Br2(n2, r2, 1);
        }), nh = Ju(ho), th = Ju(po), rh = Fu(function(n2, t2, r2) {
          bl.call(n2, r2) ? n2[r2].push(t2) : Br2(n2, r2, [t2]);
        }), eh = uu(function(t2, r2, e2) {
          var u2 = -1, i2 = typeof r2 == "function", o2 = Hf(t2) ? il(t2.length) : [];
          return ys(t2, function(t3) {
            o2[++u2] = i2 ? n(r2, t3, e2) : Ie(t3, r2, e2);
          }), o2;
        }), uh = Fu(function(n2, t2, r2) {
          Br2(n2, r2, t2);
        }), ih = Fu(function(n2, t2, r2) {
          n2[r2 ? 0 : 1].push(t2);
        }, function() {
          return [[], []];
        }), oh = uu(function(n2, t2) {
          if (n2 == null) return [];
          var r2 = t2.length;
          return r2 > 1 && Ui(n2, t2[0], t2[1]) ? t2 = [] : r2 > 2 && Ui(t2[0], t2[1], t2[2]) && (t2 = [t2[0]]), He(n2, ee2(t2, 1), []);
        }), fh = Dl || function() {
          return re.Date.now();
        }, ch = uu(function(n2, t2, r2) {
          var e2 = _n;
          if (r2.length) {
            var u2 = N(r2, wi(ch));
            e2 |= bn;
          }
          return ai(n2, e2, t2, r2, u2);
        }), ah = uu(function(n2, t2, r2) {
          var e2 = _n | vn;
          if (r2.length) {
            var u2 = N(r2, wi(ah));
            e2 |= bn;
          }
          return ai(t2, e2, n2, r2, u2);
        }), lh = uu(function(n2, t2) {
          return Gr2(n2, 1, t2);
        }), sh = uu(function(n2, t2, r2) {
          return Gr2(n2, Ic(t2) || 0, r2);
        });
        Cf.Cache = sr2;
        var hh = js(function(t2, r2) {
          r2 = r2.length == 1 && bh(r2[0]) ? c(r2[0], z(mi())) : c(ee2(r2, 1), z(mi()));
          var e2 = r2.length;
          return uu(function(u2) {
            for (var i2 = -1, o2 = Hl(u2.length, e2); ++i2 < o2; ) u2[i2] = r2[i2].call(this, u2[i2]);
            return n(t2, this, u2);
          });
        }), ph = uu(function(n2, t2) {
          return ai(n2, bn, X, t2, N(t2, wi(ph)));
        }), _h = uu(function(n2, t2) {
          return ai(n2, wn, X, t2, N(t2, wi(_h)));
        }), vh = gi(function(n2, t2) {
          return ai(n2, xn, X, X, X, t2);
        }), gh = ii(me), yh = ii(function(n2, t2) {
          return n2 >= t2;
        }), dh = Re(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Re : function(n2) {
          return cc(n2) && bl.call(n2, "callee") && !Wl.call(n2, "callee");
        }, bh = il.isArray, wh = ce ? z(ce) : ze, mh = ql || qa, xh = ae ? z(ae) : Ee, jh = le ? z(le) : Le, Ah = se ? z(se) : Be, kh = he ? z(he) : Te, Oh = pe ? z(pe) : $e, Ih = ii(Ne), Rh = ii(function(n2, t2) {
          return n2 <= t2;
        }), zh = Nu(function(n2, t2) {
          if (Mi(t2) || Hf(t2)) return $u(t2, Pc(t2), n2), X;
          for (var r2 in t2) bl.call(t2, r2) && Sr2(n2, r2, t2[r2]);
        }), Eh = Nu(function(n2, t2) {
          $u(t2, qc(t2), n2);
        }), Sh = Nu(function(n2, t2, r2, e2) {
          $u(t2, qc(t2), n2, e2);
        }), Wh = Nu(function(n2, t2, r2, e2) {
          $u(t2, Pc(t2), n2, e2);
        }), Lh = gi(Tr2), Ch = uu(function(n2, t2) {
          n2 = ll(n2);
          var r2 = -1, e2 = t2.length, u2 = e2 > 2 ? t2[2] : X;
          for (u2 && Ui(t2[0], t2[1], u2) && (e2 = 1); ++r2 < e2; ) for (var i2 = t2[r2], o2 = qc(i2), f2 = -1, c2 = o2.length; ++f2 < c2; ) {
            var a2 = o2[f2], l2 = n2[a2];
            (l2 === X || Gf(l2, gl[a2]) && !bl.call(n2, a2)) && (n2[a2] = i2[a2]);
          }
          return n2;
        }), Uh = uu(function(t2) {
          return t2.push(X, si), n(Mh, X, t2);
        }), Bh = Xu(function(n2, t2, r2) {
          t2 != null && typeof t2.toString != "function" && (t2 = xl.call(t2)), n2[t2] = r2;
        }, Sa(La)), Th = Xu(function(n2, t2, r2) {
          t2 != null && typeof t2.toString != "function" && (t2 = xl.call(t2)), bl.call(n2, t2) ? n2[t2].push(r2) : n2[t2] = [r2];
        }, mi), $h = uu(Ie), Dh = Nu(function(n2, t2, r2) {
          Ke(n2, t2, r2);
        }), Mh = Nu(function(n2, t2, r2, e2) {
          Ke(n2, t2, r2, e2);
        }), Fh = gi(function(n2, t2) {
          var r2 = {};
          if (n2 == null) return r2;
          var e2 = !1;
          t2 = c(t2, function(t3) {
            return t3 = ku(t3, n2), e2 || (e2 = t3.length > 1), t3;
          }), $u(n2, di(n2), r2), e2 && (r2 = Fr2(r2, an | ln | sn, hi));
          for (var u2 = t2.length; u2--; ) yu(r2, t2[u2]);
          return r2;
        }), Nh = gi(function(n2, t2) {
          return n2 == null ? {} : Je(n2, t2);
        }), Ph = ci2(Pc), qh = ci2(qc), Zh = Vu(function(n2, t2, r2) {
          return t2 = t2.toLowerCase(), n2 + (r2 ? fa(t2) : t2);
        }), Kh = Vu(function(n2, t2, r2) {
          return n2 + (r2 ? "-" : "") + t2.toLowerCase();
        }), Vh = Vu(function(n2, t2, r2) {
          return n2 + (r2 ? " " : "") + t2.toLowerCase();
        }), Gh = Ku("toLowerCase"), Hh = Vu(function(n2, t2, r2) {
          return n2 + (r2 ? "_" : "") + t2.toLowerCase();
        }), Jh = Vu(function(n2, t2, r2) {
          return n2 + (r2 ? " " : "") + Qh(t2);
        }), Yh = Vu(function(n2, t2, r2) {
          return n2 + (r2 ? " " : "") + t2.toUpperCase();
        }), Qh = Ku("toUpperCase"), Xh = uu(function(t2, r2) {
          try {
            return n(t2, X, r2);
          } catch (n2) {
            return rc(n2) ? n2 : new fl(n2);
          }
        }), np = gi(function(n2, t2) {
          return r(t2, function(t3) {
            t3 = no(t3), Br2(n2, t3, ch(n2[t3], n2));
          }), n2;
        }), tp = Yu(), rp = Yu(!0), ep = uu(function(n2, t2) {
          return function(r2) {
            return Ie(r2, n2, t2);
          };
        }), up = uu(function(n2, t2) {
          return function(r2) {
            return Ie(n2, r2, t2);
          };
        }), ip = ti(c), op = ti(u), fp2 = ti(h), cp = ui(), ap = ui(!0), lp = ni(function(n2, t2) {
          return n2 + t2;
        }, 0), sp = fi("ceil"), hp = ni(function(n2, t2) {
          return n2 / t2;
        }, 1), pp = fi("floor"), _p = ni(function(n2, t2) {
          return n2 * t2;
        }, 1), vp = fi("round"), gp = ni(function(n2, t2) {
          return n2 - t2;
        }, 0);
        return Z2.after = If, Z2.ary = Rf, Z2.assign = zh, Z2.assignIn = Eh, Z2.assignInWith = Sh, Z2.assignWith = Wh, Z2.at = Lh, Z2.before = zf, Z2.bind = ch, Z2.bindAll = np, Z2.bindKey = ah, Z2.castArray = Nf, Z2.chain = Qo, Z2.chunk = uo, Z2.compact = io, Z2.concat = oo, Z2.cond = za, Z2.conforms = Ea, Z2.constant = Sa, Z2.countBy = Xs, Z2.create = Sc, Z2.curry = Ef, Z2.curryRight = Sf, Z2.debounce = Wf, Z2.defaults = Ch, Z2.defaultsDeep = Uh, Z2.defer = lh, Z2.delay = sh, Z2.difference = Us, Z2.differenceBy = Bs, Z2.differenceWith = Ts, Z2.drop = fo, Z2.dropRight = co, Z2.dropRightWhile = ao, Z2.dropWhile = lo, Z2.fill = so, Z2.filter = lf, Z2.flatMap = sf, Z2.flatMapDeep = hf, Z2.flatMapDepth = pf, Z2.flatten = _o, Z2.flattenDeep = vo, Z2.flattenDepth = go, Z2.flip = Lf, Z2.flow = tp, Z2.flowRight = rp, Z2.fromPairs = yo, Z2.functions = $c, Z2.functionsIn = Dc, Z2.groupBy = rh, Z2.initial = mo, Z2.intersection = $s, Z2.intersectionBy = Ds, Z2.intersectionWith = Ms, Z2.invert = Bh, Z2.invertBy = Th, Z2.invokeMap = eh, Z2.iteratee = Ca, Z2.keyBy = uh, Z2.keys = Pc, Z2.keysIn = qc, Z2.map = yf, Z2.mapKeys = Zc, Z2.mapValues = Kc, Z2.matches = Ua, Z2.matchesProperty = Ba, Z2.memoize = Cf, Z2.merge = Dh, Z2.mergeWith = Mh, Z2.method = ep, Z2.methodOf = up, Z2.mixin = Ta, Z2.negate = Uf, Z2.nthArg = Ma, Z2.omit = Fh, Z2.omitBy = Vc, Z2.once = Bf, Z2.orderBy = df, Z2.over = ip, Z2.overArgs = hh, Z2.overEvery = op, Z2.overSome = fp2, Z2.partial = ph, Z2.partialRight = _h, Z2.partition = ih, Z2.pick = Nh, Z2.pickBy = Gc, Z2.property = Fa, Z2.propertyOf = Na, Z2.pull = Fs, Z2.pullAll = Oo, Z2.pullAllBy = Io, Z2.pullAllWith = Ro, Z2.pullAt = Ns, Z2.range = cp, Z2.rangeRight = ap, Z2.rearg = vh, Z2.reject = mf, Z2.remove = zo, Z2.rest = Tf, Z2.reverse = Eo, Z2.sampleSize = jf, Z2.set = Jc, Z2.setWith = Yc, Z2.shuffle = Af, Z2.slice = So, Z2.sortBy = oh, Z2.sortedUniq = $o, Z2.sortedUniqBy = Do, Z2.split = da, Z2.spread = $f, Z2.tail = Mo, Z2.take = Fo, Z2.takeRight = No, Z2.takeRightWhile = Po, Z2.takeWhile = qo, Z2.tap = Xo, Z2.throttle = Df, Z2.thru = nf, Z2.toArray = jc, Z2.toPairs = Ph, Z2.toPairsIn = qh, Z2.toPath = Ha, Z2.toPlainObject = Rc, Z2.transform = Qc, Z2.unary = Mf, Z2.union = Ps, Z2.unionBy = qs, Z2.unionWith = Zs, Z2.uniq = Zo, Z2.uniqBy = Ko, Z2.uniqWith = Vo, Z2.unset = Xc, Z2.unzip = Go, Z2.unzipWith = Ho, Z2.update = na, Z2.updateWith = ta, Z2.values = ra, Z2.valuesIn = ea, Z2.without = Ks, Z2.words = Ra, Z2.wrap = Ff, Z2.xor = Vs, Z2.xorBy = Gs, Z2.xorWith = Hs, Z2.zip = Js, Z2.zipObject = Jo, Z2.zipObjectDeep = Yo, Z2.zipWith = Ys, Z2.entries = Ph, Z2.entriesIn = qh, Z2.extend = Eh, Z2.extendWith = Sh, Ta(Z2, Z2), Z2.add = lp, Z2.attempt = Xh, Z2.camelCase = Zh, Z2.capitalize = fa, Z2.ceil = sp, Z2.clamp = ua, Z2.clone = Pf, Z2.cloneDeep = Zf, Z2.cloneDeepWith = Kf, Z2.cloneWith = qf, Z2.conformsTo = Vf, Z2.deburr = ca, Z2.defaultTo = Wa, Z2.divide = hp, Z2.endsWith = aa, Z2.eq = Gf, Z2.escape = la, Z2.escapeRegExp = sa, Z2.every = af, Z2.find = nh, Z2.findIndex = ho, Z2.findKey = Wc, Z2.findLast = th, Z2.findLastIndex = po, Z2.findLastKey = Lc, Z2.floor = pp, Z2.forEach = _f, Z2.forEachRight = vf, Z2.forIn = Cc, Z2.forInRight = Uc, Z2.forOwn = Bc, Z2.forOwnRight = Tc, Z2.get = Mc, Z2.gt = gh, Z2.gte = yh, Z2.has = Fc, Z2.hasIn = Nc, Z2.head = bo, Z2.identity = La, Z2.includes = gf, Z2.indexOf = wo, Z2.inRange = ia, Z2.invoke = $h, Z2.isArguments = dh, Z2.isArray = bh, Z2.isArrayBuffer = wh, Z2.isArrayLike = Hf, Z2.isArrayLikeObject = Jf, Z2.isBoolean = Yf, Z2.isBuffer = mh, Z2.isDate = xh, Z2.isElement = Qf, Z2.isEmpty = Xf, Z2.isEqual = nc, Z2.isEqualWith = tc, Z2.isError = rc, Z2.isFinite = ec, Z2.isFunction = uc, Z2.isInteger = ic, Z2.isLength = oc, Z2.isMap = jh, Z2.isMatch = ac, Z2.isMatchWith = lc, Z2.isNaN = sc, Z2.isNative = hc, Z2.isNil = _c, Z2.isNull = pc, Z2.isNumber = vc, Z2.isObject = fc, Z2.isObjectLike = cc, Z2.isPlainObject = gc, Z2.isRegExp = Ah, Z2.isSafeInteger = yc, Z2.isSet = kh, Z2.isString = dc, Z2.isSymbol = bc, Z2.isTypedArray = Oh, Z2.isUndefined = wc, Z2.isWeakMap = mc, Z2.isWeakSet = xc, Z2.join = xo, Z2.kebabCase = Kh, Z2.last = jo, Z2.lastIndexOf = Ao, Z2.lowerCase = Vh, Z2.lowerFirst = Gh, Z2.lt = Ih, Z2.lte = Rh, Z2.max = Ya, Z2.maxBy = Qa, Z2.mean = Xa, Z2.meanBy = nl, Z2.min = tl, Z2.minBy = rl, Z2.stubArray = Pa, Z2.stubFalse = qa, Z2.stubObject = Za, Z2.stubString = Ka, Z2.stubTrue = Va, Z2.multiply = _p, Z2.nth = ko2, Z2.noConflict = $a, Z2.noop = Da, Z2.now = fh, Z2.pad = ha, Z2.padEnd = pa, Z2.padStart = _a, Z2.parseInt = va, Z2.random = oa, Z2.reduce = bf, Z2.reduceRight = wf, Z2.repeat = ga2, Z2.replace = ya, Z2.result = Hc, Z2.round = vp, Z2.runInContext = p2, Z2.sample = xf, Z2.size = kf, Z2.snakeCase = Hh, Z2.some = Of, Z2.sortedIndex = Wo, Z2.sortedIndexBy = Lo, Z2.sortedIndexOf = Co, Z2.sortedLastIndex = Uo, Z2.sortedLastIndexBy = Bo, Z2.sortedLastIndexOf = To, Z2.startCase = Jh, Z2.startsWith = ba, Z2.subtract = gp, Z2.sum = el, Z2.sumBy = ul, Z2.template = wa, Z2.times = Ga, Z2.toFinite = Ac, Z2.toInteger = kc, Z2.toLength = Oc, Z2.toLower = ma, Z2.toNumber = Ic, Z2.toSafeInteger = zc, Z2.toString = Ec, Z2.toUpper = xa, Z2.trim = ja, Z2.trimEnd = Aa, Z2.trimStart = ka, Z2.truncate = Oa, Z2.unescape = Ia, Z2.uniqueId = Ja, Z2.upperCase = Yh, Z2.upperFirst = Qh, Z2.each = _f, Z2.eachRight = vf, Z2.first = bo, Ta(Z2, (function() {
          var n2 = {};
          return ue2(Z2, function(t2, r2) {
            bl.call(Z2.prototype, r2) || (n2[r2] = t2);
          }), n2;
        })(), { chain: !1 }), Z2.VERSION = nn, r(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n2) {
          Z2[n2].placeholder = Z2;
        }), r(["drop", "take"], function(n2, t2) {
          Ct2.prototype[n2] = function(r2) {
            r2 = r2 === X ? 1 : Gl(kc(r2), 0);
            var e2 = this.__filtered__ && !t2 ? new Ct2(this) : this.clone();
            return e2.__filtered__ ? e2.__takeCount__ = Hl(r2, e2.__takeCount__) : e2.__views__.push({ size: Hl(r2, Un), type: n2 + (e2.__dir__ < 0 ? "Right" : "") }), e2;
          }, Ct2.prototype[n2 + "Right"] = function(t3) {
            return this.reverse()[n2](t3).reverse();
          };
        }), r(["filter", "map", "takeWhile"], function(n2, t2) {
          var r2 = t2 + 1, e2 = r2 == Rn || r2 == En;
          Ct2.prototype[n2] = function(n3) {
            var t3 = this.clone();
            return t3.__iteratees__.push({ iteratee: mi(n3, 3), type: r2 }), t3.__filtered__ = t3.__filtered__ || e2, t3;
          };
        }), r(["head", "last"], function(n2, t2) {
          var r2 = "take" + (t2 ? "Right" : "");
          Ct2.prototype[n2] = function() {
            return this[r2](1).value()[0];
          };
        }), r(["initial", "tail"], function(n2, t2) {
          var r2 = "drop" + (t2 ? "" : "Right");
          Ct2.prototype[n2] = function() {
            return this.__filtered__ ? new Ct2(this) : this[r2](1);
          };
        }), Ct2.prototype.compact = function() {
          return this.filter(La);
        }, Ct2.prototype.find = function(n2) {
          return this.filter(n2).head();
        }, Ct2.prototype.findLast = function(n2) {
          return this.reverse().find(n2);
        }, Ct2.prototype.invokeMap = uu(function(n2, t2) {
          return typeof n2 == "function" ? new Ct2(this) : this.map(function(r2) {
            return Ie(r2, n2, t2);
          });
        }), Ct2.prototype.reject = function(n2) {
          return this.filter(Uf(mi(n2)));
        }, Ct2.prototype.slice = function(n2, t2) {
          n2 = kc(n2);
          var r2 = this;
          return r2.__filtered__ && (n2 > 0 || t2 < 0) ? new Ct2(r2) : (n2 < 0 ? r2 = r2.takeRight(-n2) : n2 && (r2 = r2.drop(n2)), t2 !== X && (t2 = kc(t2), r2 = t2 < 0 ? r2.dropRight(-t2) : r2.take(t2 - n2)), r2);
        }, Ct2.prototype.takeRightWhile = function(n2) {
          return this.reverse().takeWhile(n2).reverse();
        }, Ct2.prototype.toArray = function() {
          return this.take(Un);
        }, ue2(Ct2.prototype, function(n2, t2) {
          var r2 = /^(?:filter|find|map|reject)|While$/.test(t2), e2 = /^(?:head|last)$/.test(t2), u2 = Z2[e2 ? "take" + (t2 == "last" ? "Right" : "") : t2], i2 = e2 || /^find/.test(t2);
          u2 && (Z2.prototype[t2] = function() {
            var t3 = this.__wrapped__, o2 = e2 ? [1] : arguments, f2 = t3 instanceof Ct2, c2 = o2[0], l2 = f2 || bh(t3), s2 = function(n3) {
              var t4 = u2.apply(Z2, a([n3], o2));
              return e2 && h2 ? t4[0] : t4;
            };
            l2 && r2 && typeof c2 == "function" && c2.length != 1 && (f2 = l2 = !1);
            var h2 = this.__chain__, p3 = !!this.__actions__.length, _3 = i2 && !h2, v2 = f2 && !p3;
            if (!i2 && l2) {
              t3 = v2 ? t3 : new Ct2(this);
              var g2 = n2.apply(t3, o2);
              return g2.__actions__.push({ func: nf, args: [s2], thisArg: X }), new Y2(g2, h2);
            }
            return _3 && v2 ? n2.apply(this, o2) : (g2 = this.thru(s2), _3 ? e2 ? g2.value()[0] : g2.value() : g2);
          });
        }), r(["pop", "push", "shift", "sort", "splice", "unshift"], function(n2) {
          var t2 = _l[n2], r2 = /^(?:push|sort|unshift)$/.test(n2) ? "tap" : "thru", e2 = /^(?:pop|shift)$/.test(n2);
          Z2.prototype[n2] = function() {
            var n3 = arguments;
            if (e2 && !this.__chain__) {
              var u2 = this.value();
              return t2.apply(bh(u2) ? u2 : [], n3);
            }
            return this[r2](function(r3) {
              return t2.apply(bh(r3) ? r3 : [], n3);
            });
          };
        }), ue2(Ct2.prototype, function(n2, t2) {
          var r2 = Z2[t2];
          if (r2) {
            var e2 = r2.name + "";
            bl.call(fs, e2) || (fs[e2] = []), fs[e2].push({ name: t2, func: r2 });
          }
        }), fs[Qu(X, vn).name] = [{ name: "wrapper", func: X }], Ct2.prototype.clone = $t2, Ct2.prototype.reverse = Yt2, Ct2.prototype.value = Qt2, Z2.prototype.at = Qs, Z2.prototype.chain = tf, Z2.prototype.commit = rf, Z2.prototype.next = ef, Z2.prototype.plant = of, Z2.prototype.reverse = ff, Z2.prototype.toJSON = Z2.prototype.valueOf = Z2.prototype.value = cf, Z2.prototype.first = Z2.prototype.head, Ul && (Z2.prototype[Ul] = uf), Z2;
      }, be = de();
      ue ? ((ue.exports = be)._ = be, ee._ = be) : re._ = be;
    }).call(lodash_min);
  })(lodash_min$1, lodash_min$1.exports)), lodash_min$1.exports;
}
var _mapping = {}, hasRequired_mapping;
function require_mapping() {
  return hasRequired_mapping || (hasRequired_mapping = 1, (function(exports$1) {
    exports$1.aliasToReal = {
      // Lodash aliases.
      each: "forEach",
      eachRight: "forEachRight",
      entries: "toPairs",
      entriesIn: "toPairsIn",
      extend: "assignIn",
      extendAll: "assignInAll",
      extendAllWith: "assignInAllWith",
      extendWith: "assignInWith",
      first: "head",
      // Methods that are curried variants of others.
      conforms: "conformsTo",
      matches: "isMatch",
      property: "get",
      // Ramda aliases.
      __: "placeholder",
      F: "stubFalse",
      T: "stubTrue",
      all: "every",
      allPass: "overEvery",
      always: "constant",
      any: "some",
      anyPass: "overSome",
      apply: "spread",
      assoc: "set",
      assocPath: "set",
      complement: "negate",
      compose: "flowRight",
      contains: "includes",
      dissoc: "unset",
      dissocPath: "unset",
      dropLast: "dropRight",
      dropLastWhile: "dropRightWhile",
      equals: "isEqual",
      identical: "eq",
      indexBy: "keyBy",
      init: "initial",
      invertObj: "invert",
      juxt: "over",
      omitAll: "omit",
      nAry: "ary",
      path: "get",
      pathEq: "matchesProperty",
      pathOr: "getOr",
      paths: "at",
      pickAll: "pick",
      pipe: "flow",
      pluck: "map",
      prop: "get",
      propEq: "matchesProperty",
      propOr: "getOr",
      props: "at",
      symmetricDifference: "xor",
      symmetricDifferenceBy: "xorBy",
      symmetricDifferenceWith: "xorWith",
      takeLast: "takeRight",
      takeLastWhile: "takeRightWhile",
      unapply: "rest",
      unnest: "flatten",
      useWith: "overArgs",
      where: "conformsTo",
      whereEq: "isMatch",
      zipObj: "zipObject"
    }, exports$1.aryMethod = {
      1: [
        "assignAll",
        "assignInAll",
        "attempt",
        "castArray",
        "ceil",
        "create",
        "curry",
        "curryRight",
        "defaultsAll",
        "defaultsDeepAll",
        "floor",
        "flow",
        "flowRight",
        "fromPairs",
        "invert",
        "iteratee",
        "memoize",
        "method",
        "mergeAll",
        "methodOf",
        "mixin",
        "nthArg",
        "over",
        "overEvery",
        "overSome",
        "rest",
        "reverse",
        "round",
        "runInContext",
        "spread",
        "template",
        "trim",
        "trimEnd",
        "trimStart",
        "uniqueId",
        "words",
        "zipAll"
      ],
      2: [
        "add",
        "after",
        "ary",
        "assign",
        "assignAllWith",
        "assignIn",
        "assignInAllWith",
        "at",
        "before",
        "bind",
        "bindAll",
        "bindKey",
        "chunk",
        "cloneDeepWith",
        "cloneWith",
        "concat",
        "conformsTo",
        "countBy",
        "curryN",
        "curryRightN",
        "debounce",
        "defaults",
        "defaultsDeep",
        "defaultTo",
        "delay",
        "difference",
        "divide",
        "drop",
        "dropRight",
        "dropRightWhile",
        "dropWhile",
        "endsWith",
        "eq",
        "every",
        "filter",
        "find",
        "findIndex",
        "findKey",
        "findLast",
        "findLastIndex",
        "findLastKey",
        "flatMap",
        "flatMapDeep",
        "flattenDepth",
        "forEach",
        "forEachRight",
        "forIn",
        "forInRight",
        "forOwn",
        "forOwnRight",
        "get",
        "groupBy",
        "gt",
        "gte",
        "has",
        "hasIn",
        "includes",
        "indexOf",
        "intersection",
        "invertBy",
        "invoke",
        "invokeMap",
        "isEqual",
        "isMatch",
        "join",
        "keyBy",
        "lastIndexOf",
        "lt",
        "lte",
        "map",
        "mapKeys",
        "mapValues",
        "matchesProperty",
        "maxBy",
        "meanBy",
        "merge",
        "mergeAllWith",
        "minBy",
        "multiply",
        "nth",
        "omit",
        "omitBy",
        "overArgs",
        "pad",
        "padEnd",
        "padStart",
        "parseInt",
        "partial",
        "partialRight",
        "partition",
        "pick",
        "pickBy",
        "propertyOf",
        "pull",
        "pullAll",
        "pullAt",
        "random",
        "range",
        "rangeRight",
        "rearg",
        "reject",
        "remove",
        "repeat",
        "restFrom",
        "result",
        "sampleSize",
        "some",
        "sortBy",
        "sortedIndex",
        "sortedIndexOf",
        "sortedLastIndex",
        "sortedLastIndexOf",
        "sortedUniqBy",
        "split",
        "spreadFrom",
        "startsWith",
        "subtract",
        "sumBy",
        "take",
        "takeRight",
        "takeRightWhile",
        "takeWhile",
        "tap",
        "throttle",
        "thru",
        "times",
        "trimChars",
        "trimCharsEnd",
        "trimCharsStart",
        "truncate",
        "union",
        "uniqBy",
        "uniqWith",
        "unset",
        "unzipWith",
        "without",
        "wrap",
        "xor",
        "zip",
        "zipObject",
        "zipObjectDeep"
      ],
      3: [
        "assignInWith",
        "assignWith",
        "clamp",
        "differenceBy",
        "differenceWith",
        "findFrom",
        "findIndexFrom",
        "findLastFrom",
        "findLastIndexFrom",
        "getOr",
        "includesFrom",
        "indexOfFrom",
        "inRange",
        "intersectionBy",
        "intersectionWith",
        "invokeArgs",
        "invokeArgsMap",
        "isEqualWith",
        "isMatchWith",
        "flatMapDepth",
        "lastIndexOfFrom",
        "mergeWith",
        "orderBy",
        "padChars",
        "padCharsEnd",
        "padCharsStart",
        "pullAllBy",
        "pullAllWith",
        "rangeStep",
        "rangeStepRight",
        "reduce",
        "reduceRight",
        "replace",
        "set",
        "slice",
        "sortedIndexBy",
        "sortedLastIndexBy",
        "transform",
        "unionBy",
        "unionWith",
        "update",
        "xorBy",
        "xorWith",
        "zipWith"
      ],
      4: [
        "fill",
        "setWith",
        "updateWith"
      ]
    }, exports$1.aryRearg = {
      2: [1, 0],
      3: [2, 0, 1],
      4: [3, 2, 0, 1]
    }, exports$1.iterateeAry = {
      dropRightWhile: 1,
      dropWhile: 1,
      every: 1,
      filter: 1,
      find: 1,
      findFrom: 1,
      findIndex: 1,
      findIndexFrom: 1,
      findKey: 1,
      findLast: 1,
      findLastFrom: 1,
      findLastIndex: 1,
      findLastIndexFrom: 1,
      findLastKey: 1,
      flatMap: 1,
      flatMapDeep: 1,
      flatMapDepth: 1,
      forEach: 1,
      forEachRight: 1,
      forIn: 1,
      forInRight: 1,
      forOwn: 1,
      forOwnRight: 1,
      map: 1,
      mapKeys: 1,
      mapValues: 1,
      partition: 1,
      reduce: 2,
      reduceRight: 2,
      reject: 1,
      remove: 1,
      some: 1,
      takeRightWhile: 1,
      takeWhile: 1,
      times: 1,
      transform: 2
    }, exports$1.iterateeRearg = {
      mapKeys: [1],
      reduceRight: [1, 0]
    }, exports$1.methodRearg = {
      assignInAllWith: [1, 0],
      assignInWith: [1, 2, 0],
      assignAllWith: [1, 0],
      assignWith: [1, 2, 0],
      differenceBy: [1, 2, 0],
      differenceWith: [1, 2, 0],
      getOr: [2, 1, 0],
      intersectionBy: [1, 2, 0],
      intersectionWith: [1, 2, 0],
      isEqualWith: [1, 2, 0],
      isMatchWith: [2, 1, 0],
      mergeAllWith: [1, 0],
      mergeWith: [1, 2, 0],
      padChars: [2, 1, 0],
      padCharsEnd: [2, 1, 0],
      padCharsStart: [2, 1, 0],
      pullAllBy: [2, 1, 0],
      pullAllWith: [2, 1, 0],
      rangeStep: [1, 2, 0],
      rangeStepRight: [1, 2, 0],
      setWith: [3, 1, 2, 0],
      sortedIndexBy: [2, 1, 0],
      sortedLastIndexBy: [2, 1, 0],
      unionBy: [1, 2, 0],
      unionWith: [1, 2, 0],
      updateWith: [3, 1, 2, 0],
      xorBy: [1, 2, 0],
      xorWith: [1, 2, 0],
      zipWith: [1, 2, 0]
    }, exports$1.methodSpread = {
      assignAll: { start: 0 },
      assignAllWith: { start: 0 },
      assignInAll: { start: 0 },
      assignInAllWith: { start: 0 },
      defaultsAll: { start: 0 },
      defaultsDeepAll: { start: 0 },
      invokeArgs: { start: 2 },
      invokeArgsMap: { start: 2 },
      mergeAll: { start: 0 },
      mergeAllWith: { start: 0 },
      partial: { start: 1 },
      partialRight: { start: 1 },
      without: { start: 1 },
      zipAll: { start: 0 }
    }, exports$1.mutate = {
      array: {
        fill: !0,
        pull: !0,
        pullAll: !0,
        pullAllBy: !0,
        pullAllWith: !0,
        pullAt: !0,
        remove: !0,
        reverse: !0
      },
      object: {
        assign: !0,
        assignAll: !0,
        assignAllWith: !0,
        assignIn: !0,
        assignInAll: !0,
        assignInAllWith: !0,
        assignInWith: !0,
        assignWith: !0,
        defaults: !0,
        defaultsAll: !0,
        defaultsDeep: !0,
        defaultsDeepAll: !0,
        merge: !0,
        mergeAll: !0,
        mergeAllWith: !0,
        mergeWith: !0
      },
      set: {
        set: !0,
        setWith: !0,
        unset: !0,
        update: !0,
        updateWith: !0
      }
    }, exports$1.realToAlias = (function() {
      var hasOwnProperty = Object.prototype.hasOwnProperty, object = exports$1.aliasToReal, result = {};
      for (var key in object) {
        var value = object[key];
        hasOwnProperty.call(result, value) ? result[value].push(key) : result[value] = [key];
      }
      return result;
    })(), exports$1.remap = {
      assignAll: "assign",
      assignAllWith: "assignWith",
      assignInAll: "assignIn",
      assignInAllWith: "assignInWith",
      curryN: "curry",
      curryRightN: "curryRight",
      defaultsAll: "defaults",
      defaultsDeepAll: "defaultsDeep",
      findFrom: "find",
      findIndexFrom: "findIndex",
      findLastFrom: "findLast",
      findLastIndexFrom: "findLastIndex",
      getOr: "get",
      includesFrom: "includes",
      indexOfFrom: "indexOf",
      invokeArgs: "invoke",
      invokeArgsMap: "invokeMap",
      lastIndexOfFrom: "lastIndexOf",
      mergeAll: "merge",
      mergeAllWith: "mergeWith",
      padChars: "pad",
      padCharsEnd: "padEnd",
      padCharsStart: "padStart",
      propertyOf: "get",
      rangeStep: "range",
      rangeStepRight: "rangeRight",
      restFrom: "rest",
      spreadFrom: "spread",
      trimChars: "trim",
      trimCharsEnd: "trimEnd",
      trimCharsStart: "trimStart",
      zipAll: "zip"
    }, exports$1.skipFixed = {
      castArray: !0,
      flow: !0,
      flowRight: !0,
      iteratee: !0,
      mixin: !0,
      rearg: !0,
      runInContext: !0
    }, exports$1.skipRearg = {
      add: !0,
      assign: !0,
      assignIn: !0,
      bind: !0,
      bindKey: !0,
      concat: !0,
      difference: !0,
      divide: !0,
      eq: !0,
      gt: !0,
      gte: !0,
      isEqual: !0,
      lt: !0,
      lte: !0,
      matchesProperty: !0,
      merge: !0,
      multiply: !0,
      overArgs: !0,
      partial: !0,
      partialRight: !0,
      propertyOf: !0,
      random: !0,
      range: !0,
      rangeRight: !0,
      subtract: !0,
      zip: !0,
      zipObject: !0,
      zipObjectDeep: !0
    };
  })(_mapping)), _mapping;
}
var placeholder, hasRequiredPlaceholder;
function requirePlaceholder() {
  return hasRequiredPlaceholder || (hasRequiredPlaceholder = 1, placeholder = {}), placeholder;
}
var _baseConvert, hasRequired_baseConvert;
function require_baseConvert() {
  if (hasRequired_baseConvert) return _baseConvert;
  hasRequired_baseConvert = 1;
  var mapping = require_mapping(), fallbackHolder = requirePlaceholder(), push = Array.prototype.push;
  function baseArity(func, n) {
    return n == 2 ? function(a, b) {
      return func.apply(void 0, arguments);
    } : function(a) {
      return func.apply(void 0, arguments);
    };
  }
  function baseAry(func, n) {
    return n == 2 ? function(a, b) {
      return func(a, b);
    } : function(a) {
      return func(a);
    };
  }
  function cloneArray(array) {
    for (var length = array ? array.length : 0, result = Array(length); length--; )
      result[length] = array[length];
    return result;
  }
  function createCloner(func) {
    return function(object) {
      return func({}, object);
    };
  }
  function flatSpread(func, start) {
    return function() {
      for (var length = arguments.length, lastIndex = length - 1, args = Array(length); length--; )
        args[length] = arguments[length];
      var array = args[start], otherArgs = args.slice(0, start);
      return array && push.apply(otherArgs, array), start != lastIndex && push.apply(otherArgs, args.slice(start + 1)), func.apply(this, otherArgs);
    };
  }
  function wrapImmutable(func, cloner) {
    return function() {
      var length = arguments.length;
      if (length) {
        for (var args = Array(length); length--; )
          args[length] = arguments[length];
        var result = args[0] = cloner.apply(void 0, args);
        return func.apply(void 0, args), result;
      }
    };
  }
  function baseConvert(util, name, func, options) {
    var isLib = typeof name == "function", isObj = name === Object(name);
    if (isObj && (options = func, func = name, name = void 0), func == null)
      throw new TypeError();
    options || (options = {});
    var config = {
      cap: "cap" in options ? options.cap : !0,
      curry: "curry" in options ? options.curry : !0,
      fixed: "fixed" in options ? options.fixed : !0,
      immutable: "immutable" in options ? options.immutable : !0,
      rearg: "rearg" in options ? options.rearg : !0
    }, defaultHolder = isLib ? func : fallbackHolder, forceCurry = "curry" in options && options.curry, forceFixed = "fixed" in options && options.fixed, forceRearg = "rearg" in options && options.rearg, pristine = isLib ? func.runInContext() : void 0, helpers = isLib ? func : {
      ary: util.ary,
      assign: util.assign,
      clone: util.clone,
      curry: util.curry,
      forEach: util.forEach,
      isArray: util.isArray,
      isError: util.isError,
      isFunction: util.isFunction,
      isWeakMap: util.isWeakMap,
      iteratee: util.iteratee,
      keys: util.keys,
      rearg: util.rearg,
      toInteger: util.toInteger,
      toPath: util.toPath
    }, ary = helpers.ary, assign2 = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath, aryMethodKeys = keys(mapping.aryMethod), wrappers = {
      castArray: function(castArray) {
        return function() {
          var value = arguments[0];
          return isArray(value) ? castArray(cloneArray(value)) : castArray.apply(void 0, arguments);
        };
      },
      iteratee: function(iteratee) {
        return function() {
          var func2 = arguments[0], arity = arguments[1], result = iteratee(func2, arity), length = result.length;
          return config.cap && typeof arity == "number" ? (arity = arity > 2 ? arity - 2 : 1, length && length <= arity ? result : baseAry(result, arity)) : result;
        };
      },
      mixin: function(mixin) {
        return function(source) {
          var func2 = this;
          if (!isFunction(func2))
            return mixin(func2, Object(source));
          var pairs2 = [];
          return each(keys(source), function(key) {
            isFunction(source[key]) && pairs2.push([key, func2.prototype[key]]);
          }), mixin(func2, Object(source)), each(pairs2, function(pair) {
            var value = pair[1];
            isFunction(value) ? func2.prototype[pair[0]] = value : delete func2.prototype[pair[0]];
          }), func2;
        };
      },
      nthArg: function(nthArg) {
        return function(n) {
          var arity = n < 0 ? 1 : toInteger(n) + 1;
          return curry(nthArg(n), arity);
        };
      },
      rearg: function(rearg2) {
        return function(func2, indexes) {
          var arity = indexes ? indexes.length : 0;
          return curry(rearg2(func2, indexes), arity);
        };
      },
      runInContext: function(runInContext) {
        return function(context) {
          return baseConvert(util, runInContext(context), options);
        };
      }
    };
    function castCap(name2, func2) {
      if (config.cap) {
        var indexes = mapping.iterateeRearg[name2];
        if (indexes)
          return iterateeRearg(func2, indexes);
        var n = !isLib && mapping.iterateeAry[name2];
        if (n)
          return iterateeAry(func2, n);
      }
      return func2;
    }
    function castCurry(name2, func2, n) {
      return forceCurry || config.curry && n > 1 ? curry(func2, n) : func2;
    }
    function castFixed(name2, func2, n) {
      if (config.fixed && (forceFixed || !mapping.skipFixed[name2])) {
        var data = mapping.methodSpread[name2], start = data && data.start;
        return start === void 0 ? ary(func2, n) : flatSpread(func2, start);
      }
      return func2;
    }
    function castRearg(name2, func2, n) {
      return config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name2]) ? rearg(func2, mapping.methodRearg[name2] || mapping.aryRearg[n]) : func2;
    }
    function cloneByPath(object, path) {
      path = toPath(path);
      for (var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result; nested != null && ++index < length; ) {
        var key = path[index], value = nested[key];
        value != null && !(isFunction(value) || isError(value) || isWeakMap(value)) && (nested[key] = clone(index == lastIndex ? value : Object(value))), nested = nested[key];
      }
      return result;
    }
    function convertLib(options2) {
      return _2.runInContext.convert(options2)(void 0);
    }
    function createConverter(name2, func2) {
      var realName = mapping.aliasToReal[name2] || name2, methodName = mapping.remap[realName] || realName, oldOptions = options;
      return function(options2) {
        var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func2, newOptions = assign2(assign2({}, oldOptions), options2);
        return baseConvert(newUtil, realName, newFunc, newOptions);
      };
    }
    function iterateeAry(func2, n) {
      return overArg(func2, function(func3) {
        return typeof func3 == "function" ? baseAry(func3, n) : func3;
      });
    }
    function iterateeRearg(func2, indexes) {
      return overArg(func2, function(func3) {
        var n = indexes.length;
        return baseArity(rearg(baseAry(func3, n), indexes), n);
      });
    }
    function overArg(func2, transform) {
      return function() {
        var length = arguments.length;
        if (!length)
          return func2();
        for (var args = Array(length); length--; )
          args[length] = arguments[length];
        var index = config.rearg ? 0 : length - 1;
        return args[index] = transform(args[index]), func2.apply(void 0, args);
      };
    }
    function wrap(name2, func2, placeholder2) {
      var result, realName = mapping.aliasToReal[name2] || name2, wrapped = func2, wrapper = wrappers[realName];
      return wrapper ? wrapped = wrapper(func2) : config.immutable && (mapping.mutate.array[realName] ? wrapped = wrapImmutable(func2, cloneArray) : mapping.mutate.object[realName] ? wrapped = wrapImmutable(func2, createCloner(func2)) : mapping.mutate.set[realName] && (wrapped = wrapImmutable(func2, cloneByPath))), each(aryMethodKeys, function(aryKey) {
        return each(mapping.aryMethod[aryKey], function(otherName) {
          if (realName == otherName) {
            var data = mapping.methodSpread[realName], afterRearg = data && data.afterRearg;
            return result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey), result = castCap(realName, result), result = castCurry(realName, result, aryKey), !1;
          }
        }), !result;
      }), result || (result = wrapped), result == func2 && (result = forceCurry ? curry(result, 1) : function() {
        return func2.apply(this, arguments);
      }), result.convert = createConverter(realName, func2), result.placeholder = func2.placeholder = placeholder2, result;
    }
    if (!isObj)
      return wrap(name, func, defaultHolder);
    var _2 = func, pairs = [];
    return each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(key) {
        var func2 = _2[mapping.remap[key] || key];
        func2 && pairs.push([key, wrap(key, func2, _2)]);
      });
    }), each(keys(_2), function(key) {
      var func2 = _2[key];
      if (typeof func2 == "function") {
        for (var length = pairs.length; length--; )
          if (pairs[length][0] == key)
            return;
        func2.convert = createConverter(key, func2), pairs.push([key, func2]);
      }
    }), each(pairs, function(pair) {
      _2[pair[0]] = pair[1];
    }), _2.convert = convertLib, _2.placeholder = _2, each(keys(_2), function(key) {
      each(mapping.realToAlias[key] || [], function(alias) {
        _2[alias] = _2[key];
      });
    }), _2;
  }
  return _baseConvert = baseConvert, _baseConvert;
}
var fp, hasRequiredFp;
function requireFp() {
  if (hasRequiredFp) return fp;
  hasRequiredFp = 1;
  var _2 = requireLodash_min().runInContext();
  return fp = require_baseConvert()(_2, _2), fp;
}
var fpExports = requireFp();
const _ = /* @__PURE__ */ getDefaultExportFromCjs(fpExports), removeCommas = (x) => _.pipe(_.toString, _.replace(/,/g, ""))(x), numberWithCommas = (x) => x ? _.pipe(removeCommas, _.replace(/\B(?=(\d{3})+(?!\d))/g, ","))(x) : 0, phoneWithHyphen = (x) => x ? x.replace(/[^0-9]/g, "").replace(/(^02|^0502|^0504|^0505|^0506|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})/, "$1-$2-$3").replace("--", "-") : "", removeHyphen = (x) => _.pipe(_.toString, _.replace(/-/g, ""))(x), ci = "/wt_mark/w_mark_04.png", cdnAliasMobileList = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${ENCAR_IMG_SERVER}${ci}`, cdnAliasMobileListPremium = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${ENCAR_IMG_SERVER}${ci}`, cdnAliasMobileDetailView = `impolicy=heightRate&rh=480&cw=640&ch=480&cg=Center&wtmk=${ENCAR_IMG_SERVER}${ci}`, cdnAliasMobileDetailViewRatio5x3 = `impolicy=heightRate&rh=384&cw=640&ch=384&cg=Center&wtmk=${ENCAR_IMG_SERVER}${ci}`, cdnAliasMobileSelfReview = "downsize=180px:*&crop=130px:130px;*,*", cdnAliasDetailViewBigRatio5x3 = `impolicy=heightRate&rh=768&cw=1280&ch=768&cg=Center&wtmk=${ENCAR_IMG_SERVER}${ci}`, carDetailImageFilter = (items) => {
  const filtered = items?.filter((item) => !CAR_DETAIL_IMAGE_EXCLUDED_GROUP.includes(item.type));
  return filtered && filtered.sort((a, b) => Number(a.code) - Number(b.code));
}, carDetailImageGroup = (items, panorama) => {
  var _a, _b;
  const group = (items ?? []).reduce((acc, item) => {
    var _a2;
    const code = String(item.code), findCodeInGroup = CAR_DETAIL_IMAGE_GROUP.find(({ codes }) => codes.includes(code));
    if (findCodeInGroup && !CAR_DETAIL_IMAGE_EXCLUDED_GROUP.includes(findCodeInGroup.groupName)) {
      const labelText = (_a2 = CAR_DETAIL_IMAGE_LABEL[code]) !== null && _a2 !== void 0 ? _a2 : "";
      acc[findCodeInGroup.groupName].push(Object.assign(Object.assign({}, item), { label: labelText, groupName: findCodeInGroup.groupName, groupLabel: findCodeInGroup.label }));
    }
    return acc;
  }, {
    // OUTER: [], INNER: [], THUMBNAIL: [], OPTION: [],
    OUTER: [],
    INNER: [],
    OPTION: []
  }), sorted = CAR_DETAIL_IMAGE_GROUP.filter(({ groupName }) => !CAR_DETAIL_IMAGE_EXCLUDED_GROUP.includes(groupName)).reduce((acc, { groupName, codes }) => Object.assign(Object.assign({}, acc), { [groupName]: [...group[groupName]].sort((a, b) => codes.indexOf(String(a.code)) - codes.indexOf(String(b.code))) }), {
    // OUTER: [], INNER: [], THUMBNAIL: [], OPTION: [],
    OUTER: [],
    INNER: [],
    OPTION: []
  });
  if (!panorama)
    return sorted;
  const panoramaLabel = (_a = CAR_DETAIL_IMAGE_LABEL[CAR_DETAIL_PANORAMA_THUMBNAIL_CODE]) !== null && _a !== void 0 ? _a : "", innerGroup = CAR_DETAIL_IMAGE_GROUP.find(({ groupName }) => groupName === "INNER");
  return Object.assign(Object.assign({}, sorted), { INNER: [
    Object.assign(Object.assign({}, panorama), { label: panoramaLabel, groupName: "INNER", groupLabel: (_b = innerGroup?.label) !== null && _b !== void 0 ? _b : "" }),
    ...sorted.INNER
  ] });
}, carDetailImageArray = (items, panorama) => {
  const group = carDetailImageGroup(items, panorama);
  return CAR_DETAIL_IMAGE_GROUP.filter(({ groupName }) => !CAR_DETAIL_IMAGE_EXCLUDED_GROUP.includes(groupName)).flatMap(({ groupName }) => {
    var _a;
    return (_a = group[groupName]) !== null && _a !== void 0 ? _a : [];
  });
}, carDetailImage = (path, cache) => {
  const inCache = cache ? `&t=${dayjs(cache).format("YYYYMMDDHHmmss")}` : "";
  return `${ENCAR_IMG_SERVER}/carpicture${path}?${cdnAliasMobileDetailView}${inCache}`;
}, carDetailImageRatio5x3 = (path, cache) => {
  const inCache = cache ? `&t=${dayjs(cache).format("YYYYMMDDHHmmss")}` : "";
  return `${ENCAR_IMG_SERVER}/carpicture${path}?${cdnAliasMobileDetailViewRatio5x3}${inCache}`;
}, carDetailImageBigRatio5x3 = (path, cache) => {
  const inCache = cache ? `&t=${dayjs(cache).format("YYYYMMDDHHmmss")}` : "";
  return `${ENCAR_IMG_SERVER}/carpicture${path}?${cdnAliasDetailViewBigRatio5x3}${inCache}`;
}, carDetailImageOrigin = (path) => `${ENCAR_IMG_SERVER}/carpicture${path}`, sellerProfileImage = (path) => `${ENCAR_IMG_SERVER}${path}?resize=160px:160px${`&t=${dayjs().format("YYYYMMDDHHmm")}`}`, handleAppOpen = (appUrl) => {
  uaParser().isIOS || uaParser().isAndroid ? mobileAppBridge().appLauncher(appUrl || "/") : alert("안드로이드, 아이폰 기기에서 이용 가능합니다.");
}, handleAppDownload = () => {
  mobileAppBridge().appDownload();
};
function marketingTermsManager() {
  let hostNameArray = [];
  typeof window < "u" && (hostNameArray = window.location.hostname.split("."));
  const [first, second] = hostNameArray.reverse();
  return {
    setViewCookie() {
      api.get("marketing_terms_view") && api.set("marketing_terms_view", "true", { expires: 30 / 1440, domain: `.${second}.${first}` });
    },
    removeViewCookie() {
      api.remove("marketing_terms_view", { domain: `.${second}.${first}` });
    }
  };
}
const checkKoreanLang = (language) => {
  var _a;
  const raw = language ?? (isBrowser ? navigator.language || ((_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) || "" : null);
  return raw === null ? null : raw.split(",")[0].trim().toLowerCase().startsWith("ko");
}, MEASUREMENT_ID = "G-WY0RWR65ED", isDebugEnv = DEPLOY_ENV === "local" || DEPLOY_ENV === "dev" || DEPLOY_ENV === "qa";
let gtag;
const configuredIds = /* @__PURE__ */ new Set();
function ensureGtag(measurementId = MEASUREMENT_ID) {
  if (!gtag) {
    const layer = window.dataLayer || [];
    window.dataLayer = layer, gtag = function() {
      layer.push(arguments);
    };
    const script = document.createElement("script");
    script.async = !0, script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`, document.head.appendChild(script), gtag("js", /* @__PURE__ */ new Date());
  }
  return configuredIds.has(measurementId) || (configuredIds.add(measurementId), gtag("config", measurementId, Object.assign({ send_page_view: !1 }, isDebugEnv ? { debug_mode: !0 } : {}))), gtag;
}
function omitEmpty(payload) {
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== void 0 && value !== ""));
}
class Ga4 {
  constructor(measurementId = MEASUREMENT_ID) {
    this.measurementId = measurementId;
  }
  /**
   * GA4 이벤트 전송.
   *
   * 사내 스킴은 이벤트 이름 자리에 eventtype(VIEW/CLICK/ACTION)을 그대로 넣는다.
   * 소문자 click 은 GA4 자동수집 이벤트명과 충돌하므로 대문자 고정이다.
   * A/B 퍼널처럼 이름 자체를 분기값으로 쪼개는 경우(`배너노출_B`)를 위해 임의 문자열도 받는다.
   *
   * 부트스트랩은 첫 전송 시점에 한다 — 인스턴스만 만들고 안 쓰면 스크립트가 붙지 않는다.
   *
   * `send_to` — 측정 ID 가 둘 이상 config 되면 gtag 는 이벤트를 전 ID 로 뿌리므로
   * 이 인스턴스의 ID 로 한정한다. ID 가 하나뿐이면 결과는 같다.
   */
  send(eventName, payload = {}) {
    if (typeof window > "u")
      return;
    const send = ensureGtag(this.measurementId), params = omitEmpty(payload);
    isDebugEnv && console.log("[ga4]", this.measurementId, eventName, params), send("event", eventName, Object.assign(Object.assign({}, params), { send_to: this.measurementId }));
  }
}
const defaultGa4 = new Ga4();
function sendGaEvent(eventtype, payload = {}) {
  defaultGa4.send(eventtype, payload);
}
function buildGaParams(entries) {
  return Object.entries(entries).filter(([, value]) => value !== void 0 && value !== "").map(([key, value]) => `${key}:${value}`).join("|");
}
function resolveGaAbType(abTestInfo) {
  if (!(!abTestInfo.checkComplete || abTestInfo.error) && !(abTestInfo.type !== "A" && abTestInfo.type !== "B"))
    return abTestInfo.type;
}
const SCREEN = {
  COUPON: "쿠폰발행페이지",
  COUPON_ISSUED: "쿠폰발행완료페이지",
  APPLY_FIRST: "신청자정보입력_최초",
  APPLY_REAPPLY: "재신청화면",
  APPLY_COMPLETE_FIRST: "엔카믿고신청완료_최초",
  APPLY_COMPLETE_REAPPLY: "엔카믿고신청완료_재신청"
}, GROUP = {
  COUPON: "쿠폰발행",
  COUPON_ISSUED: "쿠폰발행완료",
  APPLY_FIRST: "엔카믿고신청_최초",
  APPLY_REAPPLY: "엔카믿고신청_재신청"
}, COUPON_ISSUE_PARAMS = buildGaParams({ hasfreeshippingcoupon: !1 }), COUPON_ISSUED_PARAMS = buildGaParams({ hasfreeshippingcoupon: !0 }), screenName = (base, abType) => `${base}_${abType}`, trackHomeService = {
  /** No.1 / No.2 — 지표1 쿠폰발행페이지 진입수 */
  couponView: ({ abType }) => {
    abType && sendGaEvent("VIEW", {
      screenname: screenName(SCREEN.COUPON, abType),
      eventnamegroup: GROUP.COUPON,
      params: COUPON_ISSUE_PARAMS
    });
  },
  /** No.3 / No.4 — 지표2 '쿠폰 받기' 클릭수 */
  couponClaimClick: ({ abType }) => {
    abType && sendGaEvent("CLICK", {
      screenname: screenName(SCREEN.COUPON, abType),
      eventname: "쿠폰 받기",
      eventnamegroup: GROUP.COUPON,
      params: COUPON_ISSUE_PARAMS
    });
  },
  /** No.5 / No.6 — 지표3 쿠폰발급완료 진입수 (핵심지표1 분자) */
  couponIssuedView: ({ abType }) => {
    abType && sendGaEvent("VIEW", {
      screenname: screenName(SCREEN.COUPON_ISSUED, abType),
      eventnamegroup: GROUP.COUPON_ISSUED,
      params: COUPON_ISSUED_PARAMS
    });
  },
  /**
   * PUB-15493 — 쿠폰발행완료페이지 CTA 클릭수.
   * eventname 은 A/B 공통이다(A 안 버튼 문구와 다르지만 스펙이 통일값을 지정).
   */
  couponIssuedClick: ({ abType }) => {
    abType && sendGaEvent("CLICK", {
      screenname: screenName(SCREEN.COUPON_ISSUED, abType),
      eventname: "엔카믿고 배송 차량 보러가기",
      eventnamegroup: GROUP.COUPON_ISSUED,
      params: COUPON_ISSUED_PARAMS
    });
  },
  /** No.7~10 — 지표4 신청/재신청 진입수 */
  applyStepView: ({ abType, isReapply, hasCoupon }) => {
    abType && sendGaEvent("VIEW", {
      screenname: screenName(isReapply ? SCREEN.APPLY_REAPPLY : SCREEN.APPLY_FIRST, abType),
      eventnamegroup: isReapply ? GROUP.APPLY_REAPPLY : GROUP.APPLY_FIRST,
      params: buildGaParams({ hasfreeshippingcoupon: hasCoupon })
    });
  },
  /**
   * No.11~14 — 신청/재신청 완료수.
   *
   * 완료율의 분모(applyStepView)와 같은 축으로 쪼개려면 여기에도 hasfreeshippingcoupon 이 있어야 한다.
   */
  applyComplete: ({ abType, isReapply, hasCoupon }) => {
    abType && sendGaEvent("ACTION", {
      screenname: screenName(isReapply ? SCREEN.APPLY_COMPLETE_REAPPLY : SCREEN.APPLY_COMPLETE_FIRST, abType),
      eventname: "신청완료",
      eventnamegroup: isReapply ? GROUP.APPLY_REAPPLY : GROUP.APPLY_FIRST,
      params: buildGaParams({ hasfreeshippingcoupon: hasCoupon })
    });
  }
}, ga = new Ga4("G-0NW0FEW1PG"), AB_TEST_EVENT = "ab_test_on", trackInstantOffer = {
  /** 진행상황 즉시판매 배너 노출 */
  bannerView: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "배너노출", params: buildGaParams({ testtype: abType }) });
  },
  /** 배너 CTA 클릭. 검증 전이라 이탈분도 분모에 남는다 */
  bannerClick: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "배너클릭", params: buildGaParams({ testtype: abType }) });
  },
  /** 신청 가능 검증 통과 — car-delivery 이동 직전 */
  validationPassed: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "검증조건통과", params: buildGaParams({ testtype: abType }) });
  },
  /** 주소 상세 입력 완료 */
  addressSubmit: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "주소입력완료", params: buildGaParams({ testtype: abType }) });
  },
  /** 방문 일시 선택 완료 */
  visitDateSubmit: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "탁송시간입력완료", params: buildGaParams({ testtype: abType }) });
  },
  /** 탁송 신청 전송 성공 */
  applyComplete: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "신청완료", params: buildGaParams({ testtype: abType }) });
  },
  /** 판매 완료 안내 진입 */
  completeView: ({ abType }) => {
    abType && ga.send(AB_TEST_EVENT, { eventname: "완료페이지", params: buildGaParams({ testtype: abType }) });
  }
}, ORDER_MAP = {
  NEW_MEMBER: 1,
  TEST_DRIVE: 2,
  MY_CAR: 3
}, onClickDa = (daInfo) => {
  daInfo.clickUrl && (uaParser().isApp && (daInfo.openInExternalBrowser === "1" ? mobileAppBridge().goExternalPage(daInfo.clickUrl) : location.href = daInfo.clickUrl), daInfo?.target === "1" ? window.open(daInfo.clickUrl, "da_popup", uaParser().isPc ? "width=500,height=870,scrollbars=yes" : "") : location.href = daInfo?.clickUrl);
}, estimatePromotion = {
  ORDER_MAP,
  onClickDa
}, ensurePCID = () => {
  const existingPCID = api.get("PCID");
  if (existingPCID)
    return existingPCID;
  const timestamp = Date.now().toString(), random = Math.random().toString().slice(2), result = (timestamp + random).slice(0, 23);
  return api.set("PCID", result, { expires: 730, domain: getCookieDomain() }), result;
}, isAxiosLikeError = (error) => typeof error == "object" && error !== null && "response" in error, getBrowserInfo = () => ({
  happenedUrl: typeof window < "u" ? window.location.href : null,
  timestamp: (/* @__PURE__ */ new Date()).toISOString()
}), getRandomSample = (probability) => Math.random() < probability, sentryErrorFunctions = (error) => {
  const isErrorInstance = error instanceof Error, errorMessage = isErrorInstance ? error.message : String(error), errorName = isErrorInstance ? error.name : "Unknown";
  return { createError: () => {
    const originalMessage = isErrorInstance ? error.message : String(error), customErrorName = `[${errorName}] - ${originalMessage}`, newClientError = new Error(originalMessage);
    return newClientError.name = customErrorName, isErrorInstance && error.stack && (newClientError.stack = error.stack), newClientError;
  }, getContext: () => Object.assign({
    errorName,
    errorMessage,
    stack: isErrorInstance ? error.stack : null
  }, getBrowserInfo()) };
}, UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, HEX_HASH_REGEX = /^[0-9a-f]{16,}$/i, normalizeEndpoint = (endpoint) => endpoint.split("/").map((segment) => /^\d+$/.test(segment) ? ":id" : UUID_REGEX.test(segment) ? ":uuid" : HEX_HASH_REGEX.test(segment) ? ":hash" : segment).join("/"), sentryNetworkErrorFunctions = (error) => {
  const { response, config, code, message, stack } = error, { status, statusText } = response || {}, { method, url, baseURL } = config || {}, endpoint = url?.split("?")[0] || "", normalizedEndpoint = normalizeEndpoint(endpoint);
  return { createError: () => {
    const errorName = `[${status ? `${status} Error` : code === "ERR_CANCELED" || message?.includes("canceled") ? "요청 취소" : code === "ECONNABORTED" || message?.includes("timeout") ? "요청 시간 초과" : message?.includes("Network Error") ? "네트워크 연결 실패" : "연결 오류"}] - ${baseURL || ""}${normalizedEndpoint}`, newNetworkError = new Error(message);
    return newNetworkError.name = errorName, stack && (newNetworkError.stack = stack), newNetworkError.originalError = { response, config }, newNetworkError;
  }, getContext: () => {
    const truncateData = (data, maxSize = 1e4) => {
      if (!data)
        return data;
      const stringified = JSON.stringify(data);
      return stringified.length <= maxSize ? data : {
        isTruncated: !0,
        originalSize: stringified.length,
        preview: `${stringified.substring(0, maxSize)}...`
      };
    };
    return Object.assign({
      endpoint,
      method: method?.toUpperCase(),
      status,
      statusText,
      responseData: truncateData(response?.data),
      timeout: config?.timeout,
      baseURL: config?.baseURL
    }, getBrowserInfo());
  } };
}, createSentryErrorDetail = (error) => isAxiosLikeError(error) ? sentryNetworkErrorFunctions(error) : sentryErrorFunctions(error), DA_API_URL = "/RealMedia/ads/adstream_sx.ads/", getAxiosLikeError = (hint) => {
  const error = hint?.originalException;
  if (isAxiosLikeError(error))
    return error;
  const original = error?.originalError;
  return isAxiosLikeError(original) ? original : null;
}, isDaRelatedError = (hint) => {
  var _a, _b, _c;
  const error = getAxiosLikeError(hint);
  if (!error)
    return !1;
  const hasDaUrl = (_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.includes(DA_API_URL), isErrorResponse = !((_c = error.response) === null || _c === void 0) && _c.status ? error.response.status >= 400 : !0;
  return !!hasDaUrl && isErrorResponse;
}, AD_BLOCKER_PATTERNS = [/Blocked by AdGuard/i, /AdBlock/i, /ERR_BLOCKED_BY_CLIENT/i], DA_BLOCK_RESPONSE_PATTERNS = [/Blocked Request/i, /Request Blocked/i], matchesResponseData = (error, patterns) => {
  var _a;
  const responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
  if (!responseData)
    return !1;
  const dataString = typeof responseData == "string" ? responseData : JSON.stringify(responseData);
  return patterns.some((pattern) => pattern.test(dataString));
}, isAdBlockerError = (hint) => {
  const error = getAxiosLikeError(hint);
  return error ? matchesResponseData(error, AD_BLOCKER_PATTERNS) : !1;
}, CRAWLER_BLOCK_PATTERNS = [
  // 주 판정 경로 — API 응답 스텁의 리다이렉트 대상 파일명
  /has_been_cr_blocked_AWS/i,
  /has_been_blocked_AWS/i,
  // 안내 페이지를 직접 로드한 경우
  /불법 접근 차단 안내/,
  /Access to this page has been blocked/i,
  // 협의 이전 / 다른 WAF 규칙의 CloudFront 기본 차단 페이지
  /Generated by cloudfront/i
], CRAWLER_BLOCK_STATUS = [403, 404], isCrawlerBlocked = (hint) => {
  var _a;
  const error = getAxiosLikeError(hint);
  if (!error)
    return !1;
  const status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
  return !status || CRAWLER_BLOCK_STATUS.indexOf(status) === -1 ? !1 : matchesResponseData(error, CRAWLER_BLOCK_PATTERNS);
}, isDaBlockResponse = (hint) => {
  const error = getAxiosLikeError(hint);
  return error ? matchesResponseData(error, DA_BLOCK_RESPONSE_PATTERNS) : !1;
}, SENTRY_COMMON_NOISE_FILTER = {
  ignoreErrors: [
    // 브라우저 확장 프로그램 (암호화폐 지갑)
    /MetaMask/i,
    /Talisman/i,
    /Phantom/i,
    /Coinbase\s?Wallet/i,
    /WalletConnect/i,
    "Failed to connect to MetaMask",
    "Talisman extension has not been configured yet",
    // 서드파티 난독화 코드 / iframe 에러
    /undefined is not an object \(evaluating.+/,
    /Failed to read a named property 'document' from 'Window': Blocked a frame with origin ("https?.+") from accessing a cross-origin frame\./,
    /Blocked a frame with origin ("https?.+") from accessing a cross-origin frame\. Protocols, domains, and ports must match\./,
    // 서드파티 광고/트래킹 스크립트
    /Can't find variable: gmo/i
  ],
  denyUrls: [
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /inpage\.js$/i
  ]
}, isHtmlTruncationError = (event) => {
  var _a, _b, _c, _d;
  const exceptionValue = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0];
  return exceptionValue?.type !== "SyntaxError" || !(exceptionValue?.value || "").includes("Unexpected end of input") ? !1 : !((_d = (_c = exceptionValue.stacktrace) === null || _c === void 0 ? void 0 : _c.frames) === null || _d === void 0 ? void 0 : _d.some((frame) => /\.m?js(\?|$)/i.test(frame.filename || "")));
}, UNRESOLVED_FILENAMES = ["", "undefined", "null", "<anonymous>", "[native code]"], hasResolvedFrame = (event) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.some((value) => {
    var _a2, _b2;
    return (_b2 = (_a2 = value.stacktrace) === null || _a2 === void 0 ? void 0 : _a2.frames) === null || _b2 === void 0 ? void 0 : _b2.some((frame) => typeof frame.filename == "string" && UNRESOLVED_FILENAMES.indexOf(frame.filename.trim()) === -1);
  })) !== null && _c !== void 0 ? _c : !1;
}, isThirdPartyStackOverflow = (event) => {
  var _a, _b, _c;
  return (((_c = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value) || event.message || "").includes("Maximum call stack size exceeded") && !hasResolvedFrame(event);
}, commonBeforeSentry = (event, hint, options) => {
  var _a, _b, _c, _d;
  const customEvent = event, hasNetworkFailure = (_a = customEvent?.breadcrumbs) === null || _a === void 0 ? void 0 : _a.some((breadcrumb) => {
    var _a2, _b2, _c2;
    const isXhrRequest = breadcrumb.category === "xhr", hasFailureStatus = ((_a2 = breadcrumb.data) === null || _a2 === void 0 ? void 0 : _a2.status_code) === 0, hasValidApiUrl = (_c2 = (_b2 = breadcrumb.data) === null || _b2 === void 0 ? void 0 : _b2.url) === null || _c2 === void 0 ? void 0 : _c2.includes(options?.apiUrl);
    return isXhrRequest && hasFailureStatus && hasValidApiUrl;
  }), isDaError = isDaRelatedError(hint);
  if (hasNetworkFailure || isAdBlockerError(hint) || isDaError && isDaBlockResponse(hint))
    return null;
  if (isDaError) {
    if (getRandomSample(0.9))
      return null;
    customEvent.tags = Object.assign(Object.assign({}, customEvent.tags), { sampled: "10%" });
  }
  if (isCrawlerBlocked(hint)) {
    if (getRandomSample(0.99))
      return null;
    customEvent.tags = Object.assign(Object.assign({}, customEvent.tags), { sampled: "1%" });
  }
  if (isHtmlTruncationError(customEvent) || isThirdPartyStackOverflow(customEvent))
    return null;
  if (isDaError) {
    const originalError = getAxiosLikeError(hint), exceptionValue = (_c = (_b = customEvent.exception) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c[0];
    exceptionValue && (exceptionValue.type = "DA배너", exceptionValue.value = ` [${exceptionValue.value}]`), !((_d = originalError?.response) === null || _d === void 0) && _d.data && (customEvent.extra = Object.assign(Object.assign({}, customEvent.extra), { data: originalError.response.data || originalError.message }));
  }
  return customEvent;
}, EXCLUDED_BREADCRUMB_URLS = [
  "bc.ad.daum.net",
  "firehose.ap-northeast-2.amazonaws.com",
  "www.googleadservices.com",
  "googleads.g.doubleclick.net",
  "analytics.google.com"
], commonBeforeBreadcrumb = (breadcrumb) => {
  var _a;
  if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
    let url = ((_a = breadcrumb?.data) === null || _a === void 0 ? void 0 : _a.url) || "";
    if (typeof url != "string")
      return breadcrumb;
    if (url = url.toLowerCase(), EXCLUDED_BREADCRUMB_URLS.some((excludeUrl) => url.includes(excludeUrl.toLowerCase())))
      return null;
  }
  return breadcrumb;
}, COLOR_SORT_WHEN_REGISTER_MAP = {
  "001": 1,
  "002": 16,
  "003": 2,
  "004": 3,
  "005": 6,
  "006": 20,
  "007": 0,
  "008": 5,
  "009": 23,
  "010": 27,
  "011": 24,
  "012": 19,
  "013": 25,
  "014": 15,
  "015": 9,
  "016": 28,
  "017": 26,
  "018": 29,
  "019": 4,
  "020": 8,
  "021": 11,
  "022": 13,
  "023": 12,
  "024": 21,
  "025": 7,
  "026": 18,
  "027": 14,
  "028": 22,
  "029": 17,
  "030": 10,
  "099": 30
}, SEAT_COLOR_SORT_WHEN_REGISTER_MAP = {
  "001": 0,
  "002": 1,
  "003": 2,
  "004": 3,
  "005": 4,
  "006": 5,
  "007": 6,
  "008": 7,
  "009": 8,
  "010": 9
};
export {
  ACCESS_TOKEN_KEY,
  ALL_RECENTLY_VIEWED_CAR_KEY,
  API_AUTH_URL,
  API_CHAT_URL,
  API_DA_URL,
  API_JUSO_URL,
  API_LOAN_URL,
  API_MEYLE_URL,
  API_NAS_URL,
  API_PRIVATE_URL,
  API_URL,
  AUTH_PLATFORM_KEY,
  CAR_DETAIL_IMAGE_EXCLUDED_GROUP,
  CAR_DETAIL_IMAGE_GROUP,
  CAR_DETAIL_IMAGE_INNER_CODE,
  CAR_DETAIL_IMAGE_LABEL,
  CAR_DETAIL_IMAGE_OPTION_CODE,
  CAR_DETAIL_IMAGE_OUTER_CODE,
  CAR_DETAIL_IMAGE_THUMBNAIL_CODE,
  CAR_DETAIL_PANORAMA_THUMBNAIL_CODE,
  CITY_CODE_NUMBER,
  COLOR_SORT_WHEN_REGISTER_MAP,
  ChannelTalk,
  DEPLOY_ENV,
  DataTalkEventType,
  ENCAR_FEM,
  ENCAR_FEM_BUY,
  ENCAR_FEM_CAR,
  ENCAR_FEM_CHECK,
  ENCAR_FEM_SELL,
  ENCAR_GLOBAL,
  ENCAR_IMAGE_DOMAIN,
  ENCAR_IMG_SERVER,
  ENCAR_KEY_KAKAO_APP_JS,
  ENCAR_MOBILE,
  ENCAR_PC,
  ENCAR_STATIC_SERVER,
  ENCAR_SURVEY,
  ENCAR_SURVEY_AB_TEST,
  ENCAR_SURVEY_DEVICE,
  ENCAR_SURVEY_TYPE,
  ENCAR_URL_NOAH,
  EncarChat,
  EncarSurvey,
  EncarTranslator,
  Enlog,
  estimatePromotion as EstimatePromotion,
  GOOGLE_CLIENT_KEY,
  Ga4,
  HOT_MARK,
  ImageConverter,
  KAKAO_CLIENT_KEY,
  LEGACY_COOKIE_KEYS_TO_CLEANUP,
  LIST_PAGE_DEFAULT_SEARCH_PARAM,
  MAX_RECENTLY_VIEWED_COUNT,
  MY_INFO_ACCESS_DATA_KEY,
  NAVER_CLIENT_KEY,
  NaverAdManager,
  ONE_LINK_PREFIX,
  PRO_TRANSFER_INSTATNT_AB_TEST_KEY,
  RECENTLY_VIEWED_CAR_COOKIE_EXPIRE_DAYS,
  RECENTLY_VIEWED_CAR_KEY,
  RECENTLY_VIEWED_TRUCK_KEY,
  REPORT_ENTRY,
  RYVUSS_SEARCH_PARAM,
  SEAT_COLOR_SORT_WHEN_REGISTER_MAP,
  SENTRY_COMMON_NOISE_FILTER,
  TEST_DRIVE_DA_KEY,
  TOKEN_BRAND,
  TOKEN_INSPECT,
  TOKEN_MEETGO,
  TOKEN_MOBILE,
  TOKEN_PARTNERSHIP,
  TOKEN_VEHICLE,
  TOKEN_VEHICLE_PUBLIC,
  UNDER_BODY_PHOTO_LABEL,
  UNDER_BODY_STRING,
  UserPassStatus,
  appsflyerEvent,
  buildGaParams,
  carDetailImage,
  carDetailImageArray,
  carDetailImageBigRatio5x3,
  carDetailImageFilter,
  carDetailImageGroup,
  carDetailImageOrigin,
  carDetailImageRatio5x3,
  carReportIntroUrl,
  carReportUrl,
  cdnAliasDetailViewBigRatio5x3,
  cdnAliasMobileDetailView,
  cdnAliasMobileDetailViewRatio5x3,
  cdnAliasMobileList,
  cdnAliasMobileListPremium,
  cdnAliasMobileSelfReview,
  checkKoreanLang,
  clearAuthInfo,
  commaWithWon,
  commonBeforeBreadcrumb,
  commonBeforeSentry,
  createSentryErrorDetail,
  dataUrlToBlob,
  dayjs,
  deleteCookie,
  downloadBlobFile,
  encarMobileAppCheck,
  encarUrlBuilder,
  ensurePCID,
  formatToManWon,
  getClientIp,
  getCookie,
  getCookieDomain,
  getDsClickCode,
  getLocalItem,
  getRandomSample,
  getRecentViewIds,
  getSessionItem,
  getSiteTypeByEncarHostname,
  getTimer,
  goErrorPage,
  goHome,
  goLegacyPageByEncarHostname,
  goMyPage,
  handleAppDownload,
  handleAppOpen,
  handleDsClickUriChange,
  handleDsClickUriUnchange,
  handleDsCustom,
  isBrowser,
  isServer,
  loadScript,
  marketingTermsManager,
  maskAfterFiveChars,
  maskName,
  maskingFirstLast,
  maskingId,
  mobileAppBridge,
  numberCommaFormatter,
  numberWithComma,
  numberWithCommas,
  numberWithKoreanUnit,
  onMaskingEmailHandle,
  phoneWithHyphen,
  pixel,
  regRecentViewIds,
  removeCommas,
  removeCookies,
  removeEmojiAndEntityCdoe,
  removeHyphen,
  removeLocalItem,
  removeSessionItem,
  resolveGaAbType,
  sellerProfileImage,
  sendGaEvent,
  setCookie,
  setDsClickCode,
  setDsClickCodeReset,
  setLocalItem,
  setSessionItem,
  testCarNumber,
  testEmail,
  testEmojiRegex,
  testEncodedUrl,
  testFullUrl,
  testId,
  testKor,
  testMobile,
  testMobileSiteByOrigin,
  testName,
  testNumber,
  testSalesNumber,
  testTel,
  throttle,
  toFixedToNumber,
  trackHomeService,
  trackInstantOffer,
  truncateFileName,
  uaParser,
  unEscapeAll,
  urlToBlob,
  urlType,
  windowOpenWithAppRouting,
  windowPopupWithApp
};
//# sourceMappingURL=index.mjs.map
